(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7a3e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7a3e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ht8Wd", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aUkG7"));

});
parcelRegister("aUkG7", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $7f0f2c9d50707a51$export$ffb0004e005737fa; }, function (v) { return $7f0f2c9d50707a51$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $7f0f2c9d50707a51$export$34b9dba7ce09269b; }, function (v) { return $7f0f2c9d50707a51$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $7f0f2c9d50707a51$export$25062201e9e25d76; }, function (v) { return $7f0f2c9d50707a51$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7f0f2c9d50707a51$export$ffb0004e005737fa;
var $7f0f2c9d50707a51$export$34b9dba7ce09269b;
var $7f0f2c9d50707a51$export$25062201e9e25d76;
"use strict";

var $f6C7p = parcelRequire("f6C7p");
var $7f0f2c9d50707a51$var$k = Symbol.for("react.element"), $7f0f2c9d50707a51$var$l = Symbol.for("react.fragment"), $7f0f2c9d50707a51$var$m = Object.prototype.hasOwnProperty, $7f0f2c9d50707a51$var$n = $f6C7p.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7f0f2c9d50707a51$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7f0f2c9d50707a51$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7f0f2c9d50707a51$var$m.call(a, b) && !$7f0f2c9d50707a51$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7f0f2c9d50707a51$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7f0f2c9d50707a51$var$n.current
    };
}
$7f0f2c9d50707a51$export$ffb0004e005737fa = $7f0f2c9d50707a51$var$l;
$7f0f2c9d50707a51$export$34b9dba7ce09269b = $7f0f2c9d50707a51$var$q;
$7f0f2c9d50707a51$export$25062201e9e25d76 = $7f0f2c9d50707a51$var$q;

});
parcelRegister("f6C7p", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4q77j"));

});
parcelRegister("4q77j", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $337f1c65d3f4a3d7$export$dca3b0875bd9a954; }, function (v) { return $337f1c65d3f4a3d7$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $337f1c65d3f4a3d7$export$16fa2f45be04daa8; }, function (v) { return $337f1c65d3f4a3d7$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $337f1c65d3f4a3d7$export$ffb0004e005737fa; }, function (v) { return $337f1c65d3f4a3d7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $337f1c65d3f4a3d7$export$e2c29f18771995cb; }, function (v) { return $337f1c65d3f4a3d7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $337f1c65d3f4a3d7$export$221d75b3f55bb0bd; }, function (v) { return $337f1c65d3f4a3d7$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $337f1c65d3f4a3d7$export$5f8d39834fd61797; }, function (v) { return $337f1c65d3f4a3d7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $337f1c65d3f4a3d7$export$74bf444e3cd11ea5; }, function (v) { return $337f1c65d3f4a3d7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $337f1c65d3f4a3d7$export$ae55be85d98224ed; }, function (v) { return $337f1c65d3f4a3d7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $337f1c65d3f4a3d7$export$e530037191fcd5d7; }, function (v) { return $337f1c65d3f4a3d7$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $337f1c65d3f4a3d7$export$fd42f52fd3ae1109; }, function (v) { return $337f1c65d3f4a3d7$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $337f1c65d3f4a3d7$export$c8a8987d4410bf2d; }, function (v) { return $337f1c65d3f4a3d7$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $337f1c65d3f4a3d7$export$d38cd72104c1f0e9; }, function (v) { return $337f1c65d3f4a3d7$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $337f1c65d3f4a3d7$export$7d1e3a5e95ceca43; }, function (v) { return $337f1c65d3f4a3d7$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $337f1c65d3f4a3d7$export$257a8862b851cb5b; }, function (v) { return $337f1c65d3f4a3d7$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $337f1c65d3f4a3d7$export$a8257692ac88316c; }, function (v) { return $337f1c65d3f4a3d7$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $337f1c65d3f4a3d7$export$488013bae63b21da; }, function (v) { return $337f1c65d3f4a3d7$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $337f1c65d3f4a3d7$export$7c73462e0d25e514; }, function (v) { return $337f1c65d3f4a3d7$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $337f1c65d3f4a3d7$export$7568632d0d33d16d; }, function (v) { return $337f1c65d3f4a3d7$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $337f1c65d3f4a3d7$export$88948ce120ea2619; }, function (v) { return $337f1c65d3f4a3d7$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $337f1c65d3f4a3d7$export$35808ee640e87ca7; }, function (v) { return $337f1c65d3f4a3d7$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $337f1c65d3f4a3d7$export$fae74005e78b1a27; }, function (v) { return $337f1c65d3f4a3d7$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $337f1c65d3f4a3d7$export$dc8fbce3eb94dc1e; }, function (v) { return $337f1c65d3f4a3d7$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $337f1c65d3f4a3d7$export$6a7bc4e911dc01cf; }, function (v) { return $337f1c65d3f4a3d7$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $337f1c65d3f4a3d7$export$6d9c69b0de29b591; }, function (v) { return $337f1c65d3f4a3d7$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $337f1c65d3f4a3d7$export$f680877a34711e37; }, function (v) { return $337f1c65d3f4a3d7$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $337f1c65d3f4a3d7$export$d5a552a76deda3c2; }, function (v) { return $337f1c65d3f4a3d7$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $337f1c65d3f4a3d7$export$aaabe4eda9ed9969; }, function (v) { return $337f1c65d3f4a3d7$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $337f1c65d3f4a3d7$export$e5c5a5f917a5871c; }, function (v) { return $337f1c65d3f4a3d7$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $337f1c65d3f4a3d7$export$1538c33de8887b59; }, function (v) { return $337f1c65d3f4a3d7$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $337f1c65d3f4a3d7$export$13e3392192263954; }, function (v) { return $337f1c65d3f4a3d7$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $337f1c65d3f4a3d7$export$b8f5890fc79d6aca; }, function (v) { return $337f1c65d3f4a3d7$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $337f1c65d3f4a3d7$export$60241385465d0a34; }, function (v) { return $337f1c65d3f4a3d7$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $337f1c65d3f4a3d7$export$306c0aa65ff9ec16; }, function (v) { return $337f1c65d3f4a3d7$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $337f1c65d3f4a3d7$export$7b286972b8d8ccbf; }, function (v) { return $337f1c65d3f4a3d7$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $337f1c65d3f4a3d7$export$83d89fbfd8236492; }, function (v) { return $337f1c65d3f4a3d7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $7fjaO = parcelRequire("7fjaO");
var $337f1c65d3f4a3d7$export$dca3b0875bd9a954;
var $337f1c65d3f4a3d7$export$16fa2f45be04daa8;
var $337f1c65d3f4a3d7$export$ffb0004e005737fa;
var $337f1c65d3f4a3d7$export$e2c29f18771995cb;
var $337f1c65d3f4a3d7$export$221d75b3f55bb0bd;
var $337f1c65d3f4a3d7$export$5f8d39834fd61797;
var $337f1c65d3f4a3d7$export$74bf444e3cd11ea5;
var $337f1c65d3f4a3d7$export$ae55be85d98224ed;
var $337f1c65d3f4a3d7$export$e530037191fcd5d7;
var $337f1c65d3f4a3d7$export$fd42f52fd3ae1109;
var $337f1c65d3f4a3d7$export$c8a8987d4410bf2d;
var $337f1c65d3f4a3d7$export$d38cd72104c1f0e9;
var $337f1c65d3f4a3d7$export$7d1e3a5e95ceca43;
var $337f1c65d3f4a3d7$export$257a8862b851cb5b;
var $337f1c65d3f4a3d7$export$a8257692ac88316c;
var $337f1c65d3f4a3d7$export$488013bae63b21da;
var $337f1c65d3f4a3d7$export$7c73462e0d25e514;
var $337f1c65d3f4a3d7$export$7568632d0d33d16d;
var $337f1c65d3f4a3d7$export$88948ce120ea2619;
var $337f1c65d3f4a3d7$export$35808ee640e87ca7;
var $337f1c65d3f4a3d7$export$fae74005e78b1a27;
var $337f1c65d3f4a3d7$export$dc8fbce3eb94dc1e;
var $337f1c65d3f4a3d7$export$6a7bc4e911dc01cf;
var $337f1c65d3f4a3d7$export$6d9c69b0de29b591;
var $337f1c65d3f4a3d7$export$f680877a34711e37;
var $337f1c65d3f4a3d7$export$d5a552a76deda3c2;
var $337f1c65d3f4a3d7$export$aaabe4eda9ed9969;
var $337f1c65d3f4a3d7$export$e5c5a5f917a5871c;
var $337f1c65d3f4a3d7$export$1538c33de8887b59;
var $337f1c65d3f4a3d7$export$13e3392192263954;
var $337f1c65d3f4a3d7$export$b8f5890fc79d6aca;
var $337f1c65d3f4a3d7$export$60241385465d0a34;
var $337f1c65d3f4a3d7$export$306c0aa65ff9ec16;
var $337f1c65d3f4a3d7$export$7b286972b8d8ccbf;
var $337f1c65d3f4a3d7$export$83d89fbfd8236492;
"use strict";
var $337f1c65d3f4a3d7$var$l = Symbol.for("react.element"), $337f1c65d3f4a3d7$var$n = Symbol.for("react.portal"), $337f1c65d3f4a3d7$var$p = Symbol.for("react.fragment"), $337f1c65d3f4a3d7$var$q = Symbol.for("react.strict_mode"), $337f1c65d3f4a3d7$var$r = Symbol.for("react.profiler"), $337f1c65d3f4a3d7$var$t = Symbol.for("react.provider"), $337f1c65d3f4a3d7$var$u = Symbol.for("react.context"), $337f1c65d3f4a3d7$var$v = Symbol.for("react.forward_ref"), $337f1c65d3f4a3d7$var$w = Symbol.for("react.suspense"), $337f1c65d3f4a3d7$var$x = Symbol.for("react.memo"), $337f1c65d3f4a3d7$var$y = Symbol.for("react.lazy"), $337f1c65d3f4a3d7$var$z = Symbol.iterator;
function $337f1c65d3f4a3d7$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $337f1c65d3f4a3d7$var$z && a[$337f1c65d3f4a3d7$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $337f1c65d3f4a3d7$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $337f1c65d3f4a3d7$var$C = Object.assign, $337f1c65d3f4a3d7$var$D = {};
function $337f1c65d3f4a3d7$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $337f1c65d3f4a3d7$var$D;
    this.updater = e || $337f1c65d3f4a3d7$var$B;
}
$337f1c65d3f4a3d7$var$E.prototype.isReactComponent = {};
$337f1c65d3f4a3d7$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$337f1c65d3f4a3d7$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $337f1c65d3f4a3d7$var$F() {}
$337f1c65d3f4a3d7$var$F.prototype = $337f1c65d3f4a3d7$var$E.prototype;
function $337f1c65d3f4a3d7$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $337f1c65d3f4a3d7$var$D;
    this.updater = e || $337f1c65d3f4a3d7$var$B;
}
var $337f1c65d3f4a3d7$var$H = $337f1c65d3f4a3d7$var$G.prototype = new $337f1c65d3f4a3d7$var$F;
$337f1c65d3f4a3d7$var$H.constructor = $337f1c65d3f4a3d7$var$G;
$337f1c65d3f4a3d7$var$C($337f1c65d3f4a3d7$var$H, $337f1c65d3f4a3d7$var$E.prototype);
$337f1c65d3f4a3d7$var$H.isPureReactComponent = !0;
var $337f1c65d3f4a3d7$var$I = Array.isArray, $337f1c65d3f4a3d7$var$J = Object.prototype.hasOwnProperty, $337f1c65d3f4a3d7$var$K = {
    current: null
}, $337f1c65d3f4a3d7$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $337f1c65d3f4a3d7$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$337f1c65d3f4a3d7$var$J.call(b, d) && !$337f1c65d3f4a3d7$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $337f1c65d3f4a3d7$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $337f1c65d3f4a3d7$var$K.current
    };
}
function $337f1c65d3f4a3d7$var$N(a, b) {
    return {
        $$typeof: $337f1c65d3f4a3d7$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $337f1c65d3f4a3d7$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $337f1c65d3f4a3d7$var$l;
}
function $337f1c65d3f4a3d7$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $337f1c65d3f4a3d7$var$P = /\/+/g;
function $337f1c65d3f4a3d7$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $337f1c65d3f4a3d7$var$escape("" + a.key) : b.toString(36);
}
function $337f1c65d3f4a3d7$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $7fjaO._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $337f1c65d3f4a3d7$var$l:
                case $337f1c65d3f4a3d7$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $337f1c65d3f4a3d7$var$Q(h, 0) : d, $337f1c65d3f4a3d7$var$I(c) ? (e = "", null != a && (e = a.replace($337f1c65d3f4a3d7$var$P, "$&/") + "/"), $337f1c65d3f4a3d7$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($337f1c65d3f4a3d7$var$O(c) && (c = $337f1c65d3f4a3d7$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($337f1c65d3f4a3d7$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($337f1c65d3f4a3d7$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $337f1c65d3f4a3d7$var$Q(k, g);
        h += $337f1c65d3f4a3d7$var$R(k, b, e, f, c);
    }
    else if (f = $337f1c65d3f4a3d7$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $337f1c65d3f4a3d7$var$Q(k, g++), h += $337f1c65d3f4a3d7$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $337f1c65d3f4a3d7$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $337f1c65d3f4a3d7$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $337f1c65d3f4a3d7$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $337f1c65d3f4a3d7$var$U = {
    current: null
}, $337f1c65d3f4a3d7$var$V = {
    transition: null
}, $337f1c65d3f4a3d7$var$W = {
    ReactCurrentDispatcher: $337f1c65d3f4a3d7$var$U,
    ReactCurrentBatchConfig: $337f1c65d3f4a3d7$var$V,
    ReactCurrentOwner: $337f1c65d3f4a3d7$var$K
};
$337f1c65d3f4a3d7$export$dca3b0875bd9a954 = {
    map: $337f1c65d3f4a3d7$var$S,
    forEach: function forEach(a, b, e) {
        $337f1c65d3f4a3d7$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $337f1c65d3f4a3d7$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $337f1c65d3f4a3d7$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$337f1c65d3f4a3d7$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$337f1c65d3f4a3d7$export$16fa2f45be04daa8 = $337f1c65d3f4a3d7$var$E;
$337f1c65d3f4a3d7$export$ffb0004e005737fa = $337f1c65d3f4a3d7$var$p;
$337f1c65d3f4a3d7$export$e2c29f18771995cb = $337f1c65d3f4a3d7$var$r;
$337f1c65d3f4a3d7$export$221d75b3f55bb0bd = $337f1c65d3f4a3d7$var$G;
$337f1c65d3f4a3d7$export$5f8d39834fd61797 = $337f1c65d3f4a3d7$var$q;
$337f1c65d3f4a3d7$export$74bf444e3cd11ea5 = $337f1c65d3f4a3d7$var$w;
$337f1c65d3f4a3d7$export$ae55be85d98224ed = $337f1c65d3f4a3d7$var$W;
$337f1c65d3f4a3d7$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $337f1c65d3f4a3d7$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $337f1c65d3f4a3d7$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$337f1c65d3f4a3d7$var$J.call(b, f) && !$337f1c65d3f4a3d7$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $337f1c65d3f4a3d7$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$337f1c65d3f4a3d7$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $337f1c65d3f4a3d7$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $337f1c65d3f4a3d7$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$337f1c65d3f4a3d7$export$c8a8987d4410bf2d = $337f1c65d3f4a3d7$var$M;
$337f1c65d3f4a3d7$export$d38cd72104c1f0e9 = function(a) {
    var b = $337f1c65d3f4a3d7$var$M.bind(null, a);
    b.type = a;
    return b;
};
$337f1c65d3f4a3d7$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$337f1c65d3f4a3d7$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $337f1c65d3f4a3d7$var$v,
        render: a
    };
};
$337f1c65d3f4a3d7$export$a8257692ac88316c = $337f1c65d3f4a3d7$var$O;
$337f1c65d3f4a3d7$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $337f1c65d3f4a3d7$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $337f1c65d3f4a3d7$var$T
    };
};
$337f1c65d3f4a3d7$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $337f1c65d3f4a3d7$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$337f1c65d3f4a3d7$export$7568632d0d33d16d = function(a) {
    var b = $337f1c65d3f4a3d7$var$V.transition;
    $337f1c65d3f4a3d7$var$V.transition = {};
    try {
        a();
    } finally{
        $337f1c65d3f4a3d7$var$V.transition = b;
    }
};
$337f1c65d3f4a3d7$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$337f1c65d3f4a3d7$export$35808ee640e87ca7 = function(a, b) {
    return $337f1c65d3f4a3d7$var$U.current.useCallback(a, b);
};
$337f1c65d3f4a3d7$export$fae74005e78b1a27 = function(a) {
    return $337f1c65d3f4a3d7$var$U.current.useContext(a);
};
$337f1c65d3f4a3d7$export$dc8fbce3eb94dc1e = function() {};
$337f1c65d3f4a3d7$export$6a7bc4e911dc01cf = function(a) {
    return $337f1c65d3f4a3d7$var$U.current.useDeferredValue(a);
};
$337f1c65d3f4a3d7$export$6d9c69b0de29b591 = function(a, b) {
    return $337f1c65d3f4a3d7$var$U.current.useEffect(a, b);
};
$337f1c65d3f4a3d7$export$f680877a34711e37 = function() {
    return $337f1c65d3f4a3d7$var$U.current.useId();
};
$337f1c65d3f4a3d7$export$d5a552a76deda3c2 = function(a, b, e) {
    return $337f1c65d3f4a3d7$var$U.current.useImperativeHandle(a, b, e);
};
$337f1c65d3f4a3d7$export$aaabe4eda9ed9969 = function(a, b) {
    return $337f1c65d3f4a3d7$var$U.current.useInsertionEffect(a, b);
};
$337f1c65d3f4a3d7$export$e5c5a5f917a5871c = function(a, b) {
    return $337f1c65d3f4a3d7$var$U.current.useLayoutEffect(a, b);
};
$337f1c65d3f4a3d7$export$1538c33de8887b59 = function(a, b) {
    return $337f1c65d3f4a3d7$var$U.current.useMemo(a, b);
};
$337f1c65d3f4a3d7$export$13e3392192263954 = function(a, b, e) {
    return $337f1c65d3f4a3d7$var$U.current.useReducer(a, b, e);
};
$337f1c65d3f4a3d7$export$b8f5890fc79d6aca = function(a) {
    return $337f1c65d3f4a3d7$var$U.current.useRef(a);
};
$337f1c65d3f4a3d7$export$60241385465d0a34 = function(a) {
    return $337f1c65d3f4a3d7$var$U.current.useState(a);
};
$337f1c65d3f4a3d7$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $337f1c65d3f4a3d7$var$U.current.useSyncExternalStore(a, b, e);
};
$337f1c65d3f4a3d7$export$7b286972b8d8ccbf = function() {
    return $337f1c65d3f4a3d7$var$U.current.useTransition();
};
$337f1c65d3f4a3d7$export$83d89fbfd8236492 = "18.2.0";

});
parcelRegister("7fjaO", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $5468ce916cf9fce6$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $5468ce916cf9fce6$export$5f0017c582d45a2d; });
function $5468ce916cf9fce6$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("ikjDJ", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $d579544f31d629f8$export$ae55be85d98224ed; }, function (v) { return $d579544f31d629f8$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $d579544f31d629f8$export$d39a5bbd09211389; }, function (v) { return $d579544f31d629f8$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $d579544f31d629f8$export$882461b6382ed46c; }, function (v) { return $d579544f31d629f8$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $d579544f31d629f8$export$466bfc07425424d5; }, function (v) { return $d579544f31d629f8$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $d579544f31d629f8$export$cd75ccfd720a3cd4; }, function (v) { return $d579544f31d629f8$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $d579544f31d629f8$export$fa8d919ba61d84db; }, function (v) { return $d579544f31d629f8$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $d579544f31d629f8$export$757ceba2d55c277e; }, function (v) { return $d579544f31d629f8$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $d579544f31d629f8$export$b3890eb0ae9dca99; }, function (v) { return $d579544f31d629f8$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $d579544f31d629f8$export$502457920280e6be; }, function (v) { return $d579544f31d629f8$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $d579544f31d629f8$export$c78a37762a8d58e1; }, function (v) { return $d579544f31d629f8$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $d579544f31d629f8$export$dc54d992c10e8a18; }, function (v) { return $d579544f31d629f8$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $d579544f31d629f8$export$83d89fbfd8236492; }, function (v) { return $d579544f31d629f8$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $7fjaO = parcelRequire("7fjaO");
var $d579544f31d629f8$export$ae55be85d98224ed;
var $d579544f31d629f8$export$d39a5bbd09211389;
var $d579544f31d629f8$export$882461b6382ed46c;
var $d579544f31d629f8$export$466bfc07425424d5;
var $d579544f31d629f8$export$cd75ccfd720a3cd4;
var $d579544f31d629f8$export$fa8d919ba61d84db;
var $d579544f31d629f8$export$757ceba2d55c277e;
var $d579544f31d629f8$export$b3890eb0ae9dca99;
var $d579544f31d629f8$export$502457920280e6be;
var $d579544f31d629f8$export$c78a37762a8d58e1;
var $d579544f31d629f8$export$dc54d992c10e8a18;
var $d579544f31d629f8$export$83d89fbfd8236492;
"use strict";

var $f6C7p = parcelRequire("f6C7p");

var $8wlpD = parcelRequire("8wlpD");
function $d579544f31d629f8$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $d579544f31d629f8$var$da = new Set, $d579544f31d629f8$var$ea = {};
function $d579544f31d629f8$var$fa(a, b) {
    $d579544f31d629f8$var$ha(a, b);
    $d579544f31d629f8$var$ha(a + "Capture", b);
}
function $d579544f31d629f8$var$ha(a, b) {
    $d579544f31d629f8$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$d579544f31d629f8$var$da.add(b[a]);
}
var $d579544f31d629f8$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $d579544f31d629f8$var$ja = Object.prototype.hasOwnProperty, $d579544f31d629f8$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $d579544f31d629f8$var$la = {}, $d579544f31d629f8$var$ma = {};
function $d579544f31d629f8$var$oa(a) {
    if ($d579544f31d629f8$var$ja.call($d579544f31d629f8$var$ma, a)) return !0;
    if ($d579544f31d629f8$var$ja.call($d579544f31d629f8$var$la, a)) return !1;
    if ($d579544f31d629f8$var$ka.test(a)) return $d579544f31d629f8$var$ma[a] = !0;
    $d579544f31d629f8$var$la[a] = !0;
    return !1;
}
function $d579544f31d629f8$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $7fjaO._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $d579544f31d629f8$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $d579544f31d629f8$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $d579544f31d629f8$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $d579544f31d629f8$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $d579544f31d629f8$var$z[a] = new $d579544f31d629f8$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $d579544f31d629f8$var$z[b] = new $d579544f31d629f8$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $d579544f31d629f8$var$z[a] = new $d579544f31d629f8$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $d579544f31d629f8$var$z[a] = new $d579544f31d629f8$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $d579544f31d629f8$var$z[a] = new $d579544f31d629f8$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $d579544f31d629f8$var$z[a] = new $d579544f31d629f8$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $d579544f31d629f8$var$z[a] = new $d579544f31d629f8$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $d579544f31d629f8$var$z[a] = new $d579544f31d629f8$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $d579544f31d629f8$var$z[a] = new $d579544f31d629f8$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $d579544f31d629f8$var$ra = /[\-:]([a-z])/g;
function $d579544f31d629f8$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($d579544f31d629f8$var$ra, $d579544f31d629f8$var$sa);
    $d579544f31d629f8$var$z[b] = new $d579544f31d629f8$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($d579544f31d629f8$var$ra, $d579544f31d629f8$var$sa);
    $d579544f31d629f8$var$z[b] = new $d579544f31d629f8$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($d579544f31d629f8$var$ra, $d579544f31d629f8$var$sa);
    $d579544f31d629f8$var$z[b] = new $d579544f31d629f8$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $d579544f31d629f8$var$z[a] = new $d579544f31d629f8$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$d579544f31d629f8$var$z.xlinkHref = new $d579544f31d629f8$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $d579544f31d629f8$var$z[a] = new $d579544f31d629f8$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $d579544f31d629f8$var$ta(a, b, c, d) {
    var e = $d579544f31d629f8$var$z.hasOwnProperty(b) ? $d579544f31d629f8$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $d579544f31d629f8$var$qa(b, c, e, d) && (c = null), d || null === e ? $d579544f31d629f8$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $d579544f31d629f8$var$ua = $f6C7p.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $d579544f31d629f8$var$va = Symbol.for("react.element"), $d579544f31d629f8$var$wa = Symbol.for("react.portal"), $d579544f31d629f8$var$ya = Symbol.for("react.fragment"), $d579544f31d629f8$var$za = Symbol.for("react.strict_mode"), $d579544f31d629f8$var$Aa = Symbol.for("react.profiler"), $d579544f31d629f8$var$Ba = Symbol.for("react.provider"), $d579544f31d629f8$var$Ca = Symbol.for("react.context"), $d579544f31d629f8$var$Da = Symbol.for("react.forward_ref"), $d579544f31d629f8$var$Ea = Symbol.for("react.suspense"), $d579544f31d629f8$var$Fa = Symbol.for("react.suspense_list"), $d579544f31d629f8$var$Ga = Symbol.for("react.memo"), $d579544f31d629f8$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $d579544f31d629f8$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $d579544f31d629f8$var$Ja = Symbol.iterator;
function $d579544f31d629f8$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $d579544f31d629f8$var$Ja && a[$d579544f31d629f8$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $d579544f31d629f8$var$A = Object.assign, $d579544f31d629f8$var$La;
function $d579544f31d629f8$var$Ma(a) {
    if (void 0 === $d579544f31d629f8$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $d579544f31d629f8$var$La = b && b[1] || "";
    }
    return "\n" + $d579544f31d629f8$var$La + a;
}
var $d579544f31d629f8$var$Na = !1;
function $d579544f31d629f8$var$Oa(a, b) {
    if (!a || $d579544f31d629f8$var$Na) return "";
    $d579544f31d629f8$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $d579544f31d629f8$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $d579544f31d629f8$var$Ma(a) : "";
}
function $d579544f31d629f8$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $d579544f31d629f8$var$Ma(a.type);
        case 16:
            return $d579544f31d629f8$var$Ma("Lazy");
        case 13:
            return $d579544f31d629f8$var$Ma("Suspense");
        case 19:
            return $d579544f31d629f8$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $d579544f31d629f8$var$Oa(a.type, !1), a;
        case 11:
            return a = $d579544f31d629f8$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $d579544f31d629f8$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $d579544f31d629f8$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $d579544f31d629f8$var$ya:
            return "Fragment";
        case $d579544f31d629f8$var$wa:
            return "Portal";
        case $d579544f31d629f8$var$Aa:
            return "Profiler";
        case $d579544f31d629f8$var$za:
            return "StrictMode";
        case $d579544f31d629f8$var$Ea:
            return "Suspense";
        case $d579544f31d629f8$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $d579544f31d629f8$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $d579544f31d629f8$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $d579544f31d629f8$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $d579544f31d629f8$var$Ga:
            return b = a.displayName || null, null !== b ? b : $d579544f31d629f8$var$Qa(a.type) || "Memo";
        case $d579544f31d629f8$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $d579544f31d629f8$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $d579544f31d629f8$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $d579544f31d629f8$var$Qa(b);
        case 8:
            return b === $d579544f31d629f8$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $d579544f31d629f8$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $7fjaO._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $d579544f31d629f8$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $d579544f31d629f8$var$Ua(a) {
    var b = $d579544f31d629f8$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $d579544f31d629f8$var$Va(a) {
    a._valueTracker || (a._valueTracker = $d579544f31d629f8$var$Ua(a));
}
function $d579544f31d629f8$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $d579544f31d629f8$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $d579544f31d629f8$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $d579544f31d629f8$var$Ya(a, b) {
    var c = b.checked;
    return $d579544f31d629f8$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $d579544f31d629f8$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $d579544f31d629f8$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $d579544f31d629f8$var$ab(a, b) {
    b = b.checked;
    null != b && $d579544f31d629f8$var$ta(a, "checked", b, !1);
}
function $d579544f31d629f8$var$bb(a, b) {
    $d579544f31d629f8$var$ab(a, b);
    var c = $d579544f31d629f8$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $d579544f31d629f8$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $d579544f31d629f8$var$cb(a, b.type, $d579544f31d629f8$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $d579544f31d629f8$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $d579544f31d629f8$var$cb(a, b, c) {
    if ("number" !== b || $d579544f31d629f8$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $d579544f31d629f8$var$eb = Array.isArray;
function $d579544f31d629f8$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $d579544f31d629f8$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $d579544f31d629f8$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($d579544f31d629f8$var$p(91));
    return $d579544f31d629f8$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $d579544f31d629f8$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($d579544f31d629f8$var$p(92));
            if ($d579544f31d629f8$var$eb(c)) {
                if (1 < c.length) throw Error($d579544f31d629f8$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $d579544f31d629f8$var$Sa(c)
    };
}
function $d579544f31d629f8$var$ib(a, b) {
    var c = $d579544f31d629f8$var$Sa(b.value), d = $d579544f31d629f8$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $d579544f31d629f8$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $d579544f31d629f8$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $d579544f31d629f8$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $d579544f31d629f8$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $d579544f31d629f8$var$mb, $d579544f31d629f8$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $d579544f31d629f8$var$mb = $d579544f31d629f8$var$mb || document.createElement("div");
        $d579544f31d629f8$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $d579544f31d629f8$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $d579544f31d629f8$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $d579544f31d629f8$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $d579544f31d629f8$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($d579544f31d629f8$var$pb).forEach(function(a) {
    $d579544f31d629f8$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $d579544f31d629f8$var$pb[b] = $d579544f31d629f8$var$pb[a];
    });
});
function $d579544f31d629f8$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $d579544f31d629f8$var$pb.hasOwnProperty(a) && $d579544f31d629f8$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $d579544f31d629f8$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $d579544f31d629f8$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $d579544f31d629f8$var$tb = $d579544f31d629f8$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $d579544f31d629f8$var$ub(a, b) {
    if (b) {
        if ($d579544f31d629f8$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($d579544f31d629f8$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($d579544f31d629f8$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($d579544f31d629f8$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($d579544f31d629f8$var$p(62));
    }
}
function $d579544f31d629f8$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $d579544f31d629f8$var$wb = null;
function $d579544f31d629f8$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $d579544f31d629f8$var$yb = null, $d579544f31d629f8$var$zb = null, $d579544f31d629f8$var$Ab = null;
function $d579544f31d629f8$var$Bb(a) {
    if (a = $d579544f31d629f8$var$Cb(a)) {
        if ("function" !== typeof $d579544f31d629f8$var$yb) throw Error($d579544f31d629f8$var$p(280));
        var b = a.stateNode;
        b && (b = $d579544f31d629f8$var$Db(b), $d579544f31d629f8$var$yb(a.stateNode, a.type, b));
    }
}
function $d579544f31d629f8$var$Eb(a) {
    $d579544f31d629f8$var$zb ? $d579544f31d629f8$var$Ab ? $d579544f31d629f8$var$Ab.push(a) : $d579544f31d629f8$var$Ab = [
        a
    ] : $d579544f31d629f8$var$zb = a;
}
function $d579544f31d629f8$var$Fb() {
    if ($d579544f31d629f8$var$zb) {
        var a = $d579544f31d629f8$var$zb, b = $d579544f31d629f8$var$Ab;
        $d579544f31d629f8$var$Ab = $d579544f31d629f8$var$zb = null;
        $d579544f31d629f8$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$d579544f31d629f8$var$Bb(b[a]);
    }
}
function $d579544f31d629f8$var$Gb(a, b) {
    return a(b);
}
function $d579544f31d629f8$var$Hb() {}
var $d579544f31d629f8$var$Ib = !1;
function $d579544f31d629f8$var$Jb(a, b, c) {
    if ($d579544f31d629f8$var$Ib) return a(b, c);
    $d579544f31d629f8$var$Ib = !0;
    try {
        return $d579544f31d629f8$var$Gb(a, b, c);
    } finally{
        if ($d579544f31d629f8$var$Ib = !1, null !== $d579544f31d629f8$var$zb || null !== $d579544f31d629f8$var$Ab) $d579544f31d629f8$var$Hb(), $d579544f31d629f8$var$Fb();
    }
}
function $d579544f31d629f8$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $d579544f31d629f8$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($d579544f31d629f8$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $7fjaO._)(c)));
    return c;
}
var $d579544f31d629f8$var$Lb = !1;
if ($d579544f31d629f8$var$ia) try {
    var $d579544f31d629f8$var$Mb = {};
    Object.defineProperty($d579544f31d629f8$var$Mb, "passive", {
        get: function get() {
            $d579544f31d629f8$var$Lb = !0;
        }
    });
    window.addEventListener("test", $d579544f31d629f8$var$Mb, $d579544f31d629f8$var$Mb);
    window.removeEventListener("test", $d579544f31d629f8$var$Mb, $d579544f31d629f8$var$Mb);
} catch (a) {
    $d579544f31d629f8$var$Lb = !1;
}
function $d579544f31d629f8$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $d579544f31d629f8$var$Ob = !1, $d579544f31d629f8$var$Pb = null, $d579544f31d629f8$var$Qb = !1, $d579544f31d629f8$var$Rb = null, $d579544f31d629f8$var$Sb = {
    onError: function onError(a) {
        $d579544f31d629f8$var$Ob = !0;
        $d579544f31d629f8$var$Pb = a;
    }
};
function $d579544f31d629f8$var$Tb(a, b, c, d, e, f, g, h, k) {
    $d579544f31d629f8$var$Ob = !1;
    $d579544f31d629f8$var$Pb = null;
    $d579544f31d629f8$var$Nb.apply($d579544f31d629f8$var$Sb, arguments);
}
function $d579544f31d629f8$var$Ub(a, b, c, d, e, f, g, h, k) {
    $d579544f31d629f8$var$Tb.apply(this, arguments);
    if ($d579544f31d629f8$var$Ob) {
        if ($d579544f31d629f8$var$Ob) {
            var l = $d579544f31d629f8$var$Pb;
            $d579544f31d629f8$var$Ob = !1;
            $d579544f31d629f8$var$Pb = null;
        } else throw Error($d579544f31d629f8$var$p(198));
        $d579544f31d629f8$var$Qb || ($d579544f31d629f8$var$Qb = !0, $d579544f31d629f8$var$Rb = l);
    }
}
function $d579544f31d629f8$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $d579544f31d629f8$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $d579544f31d629f8$var$Xb(a) {
    if ($d579544f31d629f8$var$Vb(a) !== a) throw Error($d579544f31d629f8$var$p(188));
}
function $d579544f31d629f8$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $d579544f31d629f8$var$Vb(a);
        if (null === b) throw Error($d579544f31d629f8$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $d579544f31d629f8$var$Xb(e), a;
                if (f === d) return $d579544f31d629f8$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($d579544f31d629f8$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($d579544f31d629f8$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($d579544f31d629f8$var$p(190));
    }
    if (3 !== c.tag) throw Error($d579544f31d629f8$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $d579544f31d629f8$var$Zb(a) {
    a = $d579544f31d629f8$var$Yb(a);
    return null !== a ? $d579544f31d629f8$var$$b(a) : null;
}
function $d579544f31d629f8$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $d579544f31d629f8$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $d579544f31d629f8$var$ac = $8wlpD.unstable_scheduleCallback, $d579544f31d629f8$var$bc = $8wlpD.unstable_cancelCallback, $d579544f31d629f8$var$cc = $8wlpD.unstable_shouldYield, $d579544f31d629f8$var$dc = $8wlpD.unstable_requestPaint, $d579544f31d629f8$var$B = $8wlpD.unstable_now, $d579544f31d629f8$var$ec = $8wlpD.unstable_getCurrentPriorityLevel, $d579544f31d629f8$var$fc = $8wlpD.unstable_ImmediatePriority, $d579544f31d629f8$var$gc = $8wlpD.unstable_UserBlockingPriority, $d579544f31d629f8$var$hc = $8wlpD.unstable_NormalPriority, $d579544f31d629f8$var$ic = $8wlpD.unstable_LowPriority, $d579544f31d629f8$var$jc = $8wlpD.unstable_IdlePriority, $d579544f31d629f8$var$kc = null, $d579544f31d629f8$var$lc = null;
function $d579544f31d629f8$var$mc(a) {
    if ($d579544f31d629f8$var$lc && "function" === typeof $d579544f31d629f8$var$lc.onCommitFiberRoot) try {
        $d579544f31d629f8$var$lc.onCommitFiberRoot($d579544f31d629f8$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $d579544f31d629f8$var$oc = Math.clz32 ? Math.clz32 : $d579544f31d629f8$var$nc, $d579544f31d629f8$var$pc = Math.log, $d579544f31d629f8$var$qc = Math.LN2;
function $d579544f31d629f8$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($d579544f31d629f8$var$pc(a) / $d579544f31d629f8$var$qc | 0) | 0;
}
var $d579544f31d629f8$var$rc = 64, $d579544f31d629f8$var$sc = 4194304;
function $d579544f31d629f8$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $d579544f31d629f8$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $d579544f31d629f8$var$tc(h) : (f &= g, 0 !== f && (d = $d579544f31d629f8$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $d579544f31d629f8$var$tc(g) : 0 !== f && (d = $d579544f31d629f8$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $d579544f31d629f8$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $d579544f31d629f8$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $d579544f31d629f8$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $d579544f31d629f8$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $d579544f31d629f8$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $d579544f31d629f8$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $d579544f31d629f8$var$yc() {
    var a = $d579544f31d629f8$var$rc;
    $d579544f31d629f8$var$rc <<= 1;
    0 === ($d579544f31d629f8$var$rc & 4194240) && ($d579544f31d629f8$var$rc = 64);
    return a;
}
function $d579544f31d629f8$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $d579544f31d629f8$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $d579544f31d629f8$var$oc(b);
    a[b] = c;
}
function $d579544f31d629f8$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $d579544f31d629f8$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $d579544f31d629f8$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $d579544f31d629f8$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $d579544f31d629f8$var$C = 0;
function $d579544f31d629f8$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $d579544f31d629f8$var$Ec, $d579544f31d629f8$var$Fc, $d579544f31d629f8$var$Gc, $d579544f31d629f8$var$Hc, $d579544f31d629f8$var$Ic, $d579544f31d629f8$var$Jc = !1, $d579544f31d629f8$var$Kc = [], $d579544f31d629f8$var$Lc = null, $d579544f31d629f8$var$Mc = null, $d579544f31d629f8$var$Nc = null, $d579544f31d629f8$var$Oc = new Map, $d579544f31d629f8$var$Pc = new Map, $d579544f31d629f8$var$Qc = [], $d579544f31d629f8$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $d579544f31d629f8$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $d579544f31d629f8$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $d579544f31d629f8$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $d579544f31d629f8$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $d579544f31d629f8$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $d579544f31d629f8$var$Pc.delete(b.pointerId);
    }
}
function $d579544f31d629f8$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $d579544f31d629f8$var$Cb(b), null !== b && $d579544f31d629f8$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $d579544f31d629f8$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $d579544f31d629f8$var$Lc = $d579544f31d629f8$var$Tc($d579544f31d629f8$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $d579544f31d629f8$var$Mc = $d579544f31d629f8$var$Tc($d579544f31d629f8$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $d579544f31d629f8$var$Nc = $d579544f31d629f8$var$Tc($d579544f31d629f8$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $d579544f31d629f8$var$Oc.set(f, $d579544f31d629f8$var$Tc($d579544f31d629f8$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $d579544f31d629f8$var$Pc.set(f, $d579544f31d629f8$var$Tc($d579544f31d629f8$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $d579544f31d629f8$var$Vc(a) {
    var b = $d579544f31d629f8$var$Wc(a.target);
    if (null !== b) {
        var c = $d579544f31d629f8$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $d579544f31d629f8$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $d579544f31d629f8$var$Ic(a.priority, function() {
                        $d579544f31d629f8$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $d579544f31d629f8$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $d579544f31d629f8$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $d579544f31d629f8$var$wb = d;
            c.target.dispatchEvent(d);
            $d579544f31d629f8$var$wb = null;
        } else return b = $d579544f31d629f8$var$Cb(c), null !== b && $d579544f31d629f8$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $d579544f31d629f8$var$Zc(a, b, c) {
    $d579544f31d629f8$var$Xc(a) && c.delete(b);
}
function $d579544f31d629f8$var$$c() {
    $d579544f31d629f8$var$Jc = !1;
    null !== $d579544f31d629f8$var$Lc && $d579544f31d629f8$var$Xc($d579544f31d629f8$var$Lc) && ($d579544f31d629f8$var$Lc = null);
    null !== $d579544f31d629f8$var$Mc && $d579544f31d629f8$var$Xc($d579544f31d629f8$var$Mc) && ($d579544f31d629f8$var$Mc = null);
    null !== $d579544f31d629f8$var$Nc && $d579544f31d629f8$var$Xc($d579544f31d629f8$var$Nc) && ($d579544f31d629f8$var$Nc = null);
    $d579544f31d629f8$var$Oc.forEach($d579544f31d629f8$var$Zc);
    $d579544f31d629f8$var$Pc.forEach($d579544f31d629f8$var$Zc);
}
function $d579544f31d629f8$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $d579544f31d629f8$var$Jc || ($d579544f31d629f8$var$Jc = !0, $8wlpD.unstable_scheduleCallback($8wlpD.unstable_NormalPriority, $d579544f31d629f8$var$$c)));
}
function $d579544f31d629f8$var$bd(a) {
    function b(b) {
        return $d579544f31d629f8$var$ad(b, a);
    }
    if (0 < $d579544f31d629f8$var$Kc.length) {
        $d579544f31d629f8$var$ad($d579544f31d629f8$var$Kc[0], a);
        for(var c = 1; c < $d579544f31d629f8$var$Kc.length; c++){
            var d = $d579544f31d629f8$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $d579544f31d629f8$var$Lc && $d579544f31d629f8$var$ad($d579544f31d629f8$var$Lc, a);
    null !== $d579544f31d629f8$var$Mc && $d579544f31d629f8$var$ad($d579544f31d629f8$var$Mc, a);
    null !== $d579544f31d629f8$var$Nc && $d579544f31d629f8$var$ad($d579544f31d629f8$var$Nc, a);
    $d579544f31d629f8$var$Oc.forEach(b);
    $d579544f31d629f8$var$Pc.forEach(b);
    for(c = 0; c < $d579544f31d629f8$var$Qc.length; c++)d = $d579544f31d629f8$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $d579544f31d629f8$var$Qc.length && (c = $d579544f31d629f8$var$Qc[0], null === c.blockedOn);)$d579544f31d629f8$var$Vc(c), null === c.blockedOn && $d579544f31d629f8$var$Qc.shift();
}
var $d579544f31d629f8$var$cd = $d579544f31d629f8$var$ua.ReactCurrentBatchConfig, $d579544f31d629f8$var$dd = !0;
function $d579544f31d629f8$var$ed(a, b, c, d) {
    var e = $d579544f31d629f8$var$C, f = $d579544f31d629f8$var$cd.transition;
    $d579544f31d629f8$var$cd.transition = null;
    try {
        $d579544f31d629f8$var$C = 1, $d579544f31d629f8$var$fd(a, b, c, d);
    } finally{
        $d579544f31d629f8$var$C = e, $d579544f31d629f8$var$cd.transition = f;
    }
}
function $d579544f31d629f8$var$gd(a, b, c, d) {
    var e = $d579544f31d629f8$var$C, f = $d579544f31d629f8$var$cd.transition;
    $d579544f31d629f8$var$cd.transition = null;
    try {
        $d579544f31d629f8$var$C = 4, $d579544f31d629f8$var$fd(a, b, c, d);
    } finally{
        $d579544f31d629f8$var$C = e, $d579544f31d629f8$var$cd.transition = f;
    }
}
function $d579544f31d629f8$var$fd(a, b, c, d) {
    if ($d579544f31d629f8$var$dd) {
        var e = $d579544f31d629f8$var$Yc(a, b, c, d);
        if (null === e) $d579544f31d629f8$var$hd(a, b, d, $d579544f31d629f8$var$id, c), $d579544f31d629f8$var$Sc(a, d);
        else if ($d579544f31d629f8$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($d579544f31d629f8$var$Sc(a, d), b & 4 && -1 < $d579544f31d629f8$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $d579544f31d629f8$var$Cb(e);
                null !== f && $d579544f31d629f8$var$Ec(f);
                f = $d579544f31d629f8$var$Yc(a, b, c, d);
                null === f && $d579544f31d629f8$var$hd(a, b, d, $d579544f31d629f8$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $d579544f31d629f8$var$hd(a, b, d, null, c);
    }
}
var $d579544f31d629f8$var$id = null;
function $d579544f31d629f8$var$Yc(a, b, c, d) {
    $d579544f31d629f8$var$id = null;
    a = $d579544f31d629f8$var$xb(d);
    a = $d579544f31d629f8$var$Wc(a);
    if (null !== a) {
        if (b = $d579544f31d629f8$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $d579544f31d629f8$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $d579544f31d629f8$var$id = a;
    return null;
}
function $d579544f31d629f8$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($d579544f31d629f8$var$ec()){
                case $d579544f31d629f8$var$fc:
                    return 1;
                case $d579544f31d629f8$var$gc:
                    return 4;
                case $d579544f31d629f8$var$hc:
                case $d579544f31d629f8$var$ic:
                    return 16;
                case $d579544f31d629f8$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $d579544f31d629f8$var$kd = null, $d579544f31d629f8$var$ld = null, $d579544f31d629f8$var$md = null;
function $d579544f31d629f8$var$nd() {
    if ($d579544f31d629f8$var$md) return $d579544f31d629f8$var$md;
    var a, b = $d579544f31d629f8$var$ld, c = b.length, d, e = "value" in $d579544f31d629f8$var$kd ? $d579544f31d629f8$var$kd.value : $d579544f31d629f8$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d579544f31d629f8$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $d579544f31d629f8$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $d579544f31d629f8$var$pd() {
    return !0;
}
function $d579544f31d629f8$var$qd() {
    return !1;
}
function $d579544f31d629f8$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $d579544f31d629f8$var$pd : $d579544f31d629f8$var$qd;
        this.isPropagationStopped = $d579544f31d629f8$var$qd;
        return this;
    }
    $d579544f31d629f8$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $7fjaO._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $d579544f31d629f8$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $7fjaO._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $d579544f31d629f8$var$pd);
        },
        persist: function persist() {},
        isPersistent: $d579544f31d629f8$var$pd
    });
    return b;
}
var $d579544f31d629f8$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $d579544f31d629f8$var$td = $d579544f31d629f8$var$rd($d579544f31d629f8$var$sd), $d579544f31d629f8$var$ud = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$sd, {
    view: 0,
    detail: 0
}), $d579544f31d629f8$var$vd = $d579544f31d629f8$var$rd($d579544f31d629f8$var$ud), $d579544f31d629f8$var$wd, $d579544f31d629f8$var$xd, $d579544f31d629f8$var$yd, $d579544f31d629f8$var$Ad = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $d579544f31d629f8$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $d579544f31d629f8$var$yd && ($d579544f31d629f8$var$yd && "mousemove" === a.type ? ($d579544f31d629f8$var$wd = a.screenX - $d579544f31d629f8$var$yd.screenX, $d579544f31d629f8$var$xd = a.screenY - $d579544f31d629f8$var$yd.screenY) : $d579544f31d629f8$var$xd = $d579544f31d629f8$var$wd = 0, $d579544f31d629f8$var$yd = a);
        return $d579544f31d629f8$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $d579544f31d629f8$var$xd;
    }
}), $d579544f31d629f8$var$Bd = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Ad), $d579544f31d629f8$var$Cd = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$Ad, {
    dataTransfer: 0
}), $d579544f31d629f8$var$Dd = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Cd), $d579544f31d629f8$var$Ed = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$ud, {
    relatedTarget: 0
}), $d579544f31d629f8$var$Fd = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Ed), $d579544f31d629f8$var$Gd = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d579544f31d629f8$var$Hd = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Gd), $d579544f31d629f8$var$Id = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $d579544f31d629f8$var$Jd = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Id), $d579544f31d629f8$var$Kd = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$sd, {
    data: 0
}), $d579544f31d629f8$var$Ld = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Kd), $d579544f31d629f8$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $d579544f31d629f8$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $d579544f31d629f8$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $d579544f31d629f8$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $d579544f31d629f8$var$Od[a]) ? !!b[a] : !1;
}
function $d579544f31d629f8$var$zd() {
    return $d579544f31d629f8$var$Pd;
}
var $d579544f31d629f8$var$Qd = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $d579544f31d629f8$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $d579544f31d629f8$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $d579544f31d629f8$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $d579544f31d629f8$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $d579544f31d629f8$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $d579544f31d629f8$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $d579544f31d629f8$var$Rd = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Qd), $d579544f31d629f8$var$Sd = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $d579544f31d629f8$var$Td = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Sd), $d579544f31d629f8$var$Ud = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $d579544f31d629f8$var$zd
}), $d579544f31d629f8$var$Vd = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Ud), $d579544f31d629f8$var$Wd = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d579544f31d629f8$var$Xd = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Wd), $d579544f31d629f8$var$Yd = $d579544f31d629f8$var$A({}, $d579544f31d629f8$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $d579544f31d629f8$var$Zd = $d579544f31d629f8$var$rd($d579544f31d629f8$var$Yd), $d579544f31d629f8$var$$d = [
    9,
    13,
    27,
    32
], $d579544f31d629f8$var$ae = $d579544f31d629f8$var$ia && "CompositionEvent" in window, $d579544f31d629f8$var$be = null;
$d579544f31d629f8$var$ia && "documentMode" in document && ($d579544f31d629f8$var$be = document.documentMode);
var $d579544f31d629f8$var$ce = $d579544f31d629f8$var$ia && "TextEvent" in window && !$d579544f31d629f8$var$be, $d579544f31d629f8$var$de = $d579544f31d629f8$var$ia && (!$d579544f31d629f8$var$ae || $d579544f31d629f8$var$be && 8 < $d579544f31d629f8$var$be && 11 >= $d579544f31d629f8$var$be), $d579544f31d629f8$var$ee = String.fromCharCode(32), $d579544f31d629f8$var$fe = !1;
function $d579544f31d629f8$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d579544f31d629f8$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $d579544f31d629f8$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $d579544f31d629f8$var$ie = !1;
function $d579544f31d629f8$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $d579544f31d629f8$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $d579544f31d629f8$var$fe = !0;
            return $d579544f31d629f8$var$ee;
        case "textInput":
            return a = b.data, a === $d579544f31d629f8$var$ee && $d579544f31d629f8$var$fe ? null : a;
        default:
            return null;
    }
}
function $d579544f31d629f8$var$ke(a, b) {
    if ($d579544f31d629f8$var$ie) return "compositionend" === a || !$d579544f31d629f8$var$ae && $d579544f31d629f8$var$ge(a, b) ? (a = $d579544f31d629f8$var$nd(), $d579544f31d629f8$var$md = $d579544f31d629f8$var$ld = $d579544f31d629f8$var$kd = null, $d579544f31d629f8$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $d579544f31d629f8$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $d579544f31d629f8$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $d579544f31d629f8$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$d579544f31d629f8$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $d579544f31d629f8$var$ne(a, b, c, d) {
    $d579544f31d629f8$var$Eb(d);
    b = $d579544f31d629f8$var$oe(b, "onChange");
    0 < b.length && (c = new $d579544f31d629f8$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $d579544f31d629f8$var$pe = null, $d579544f31d629f8$var$qe = null;
function $d579544f31d629f8$var$re(a) {
    $d579544f31d629f8$var$se(a, 0);
}
function $d579544f31d629f8$var$te(a) {
    var b = $d579544f31d629f8$var$ue(a);
    if ($d579544f31d629f8$var$Wa(b)) return a;
}
function $d579544f31d629f8$var$ve(a, b) {
    if ("change" === a) return b;
}
var $d579544f31d629f8$var$we = !1;
if ($d579544f31d629f8$var$ia) {
    var $d579544f31d629f8$var$xe;
    if ($d579544f31d629f8$var$ia) {
        var $d579544f31d629f8$var$ye = "oninput" in document;
        if (!$d579544f31d629f8$var$ye) {
            var $d579544f31d629f8$var$ze = document.createElement("div");
            $d579544f31d629f8$var$ze.setAttribute("oninput", "return;");
            $d579544f31d629f8$var$ye = "function" === typeof $d579544f31d629f8$var$ze.oninput;
        }
        $d579544f31d629f8$var$xe = $d579544f31d629f8$var$ye;
    } else $d579544f31d629f8$var$xe = !1;
    $d579544f31d629f8$var$we = $d579544f31d629f8$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $d579544f31d629f8$var$Ae() {
    $d579544f31d629f8$var$pe && ($d579544f31d629f8$var$pe.detachEvent("onpropertychange", $d579544f31d629f8$var$Be), $d579544f31d629f8$var$qe = $d579544f31d629f8$var$pe = null);
}
function $d579544f31d629f8$var$Be(a) {
    if ("value" === a.propertyName && $d579544f31d629f8$var$te($d579544f31d629f8$var$qe)) {
        var b = [];
        $d579544f31d629f8$var$ne(b, $d579544f31d629f8$var$qe, a, $d579544f31d629f8$var$xb(a));
        $d579544f31d629f8$var$Jb($d579544f31d629f8$var$re, b);
    }
}
function $d579544f31d629f8$var$Ce(a, b, c) {
    "focusin" === a ? ($d579544f31d629f8$var$Ae(), $d579544f31d629f8$var$pe = b, $d579544f31d629f8$var$qe = c, $d579544f31d629f8$var$pe.attachEvent("onpropertychange", $d579544f31d629f8$var$Be)) : "focusout" === a && $d579544f31d629f8$var$Ae();
}
function $d579544f31d629f8$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $d579544f31d629f8$var$te($d579544f31d629f8$var$qe);
}
function $d579544f31d629f8$var$Ee(a, b) {
    if ("click" === a) return $d579544f31d629f8$var$te(b);
}
function $d579544f31d629f8$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $d579544f31d629f8$var$te(b);
}
function $d579544f31d629f8$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d579544f31d629f8$var$He = "function" === typeof Object.is ? Object.is : $d579544f31d629f8$var$Ge;
function $d579544f31d629f8$var$Ie(a, b) {
    if ($d579544f31d629f8$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$d579544f31d629f8$var$ja.call(b, e) || !$d579544f31d629f8$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $d579544f31d629f8$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $d579544f31d629f8$var$Ke(a, b) {
    var c = $d579544f31d629f8$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $d579544f31d629f8$var$Je(c);
    }
}
function $d579544f31d629f8$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $d579544f31d629f8$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $d579544f31d629f8$var$Me() {
    for(var a = window, b = $d579544f31d629f8$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $d579544f31d629f8$var$Xa(a.document);
    }
    return b;
}
function $d579544f31d629f8$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $d579544f31d629f8$var$Oe(a) {
    var b = $d579544f31d629f8$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $d579544f31d629f8$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $d579544f31d629f8$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $d579544f31d629f8$var$Ke(c, f);
                var g = $d579544f31d629f8$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $d579544f31d629f8$var$Pe = $d579544f31d629f8$var$ia && "documentMode" in document && 11 >= document.documentMode, $d579544f31d629f8$var$Qe = null, $d579544f31d629f8$var$Re = null, $d579544f31d629f8$var$Se = null, $d579544f31d629f8$var$Te = !1;
function $d579544f31d629f8$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $d579544f31d629f8$var$Te || null == $d579544f31d629f8$var$Qe || $d579544f31d629f8$var$Qe !== $d579544f31d629f8$var$Xa(d) || (d = $d579544f31d629f8$var$Qe, "selectionStart" in d && $d579544f31d629f8$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $d579544f31d629f8$var$Se && $d579544f31d629f8$var$Ie($d579544f31d629f8$var$Se, d) || ($d579544f31d629f8$var$Se = d, d = $d579544f31d629f8$var$oe($d579544f31d629f8$var$Re, "onSelect"), 0 < d.length && (b = new $d579544f31d629f8$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $d579544f31d629f8$var$Qe)));
}
function $d579544f31d629f8$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $d579544f31d629f8$var$We = {
    animationend: $d579544f31d629f8$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $d579544f31d629f8$var$Ve("Animation", "AnimationIteration"),
    animationstart: $d579544f31d629f8$var$Ve("Animation", "AnimationStart"),
    transitionend: $d579544f31d629f8$var$Ve("Transition", "TransitionEnd")
}, $d579544f31d629f8$var$Xe = {}, $d579544f31d629f8$var$Ye = {};
$d579544f31d629f8$var$ia && ($d579544f31d629f8$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $d579544f31d629f8$var$We.animationend.animation, delete $d579544f31d629f8$var$We.animationiteration.animation, delete $d579544f31d629f8$var$We.animationstart.animation), "TransitionEvent" in window || delete $d579544f31d629f8$var$We.transitionend.transition);
function $d579544f31d629f8$var$Ze(a) {
    if ($d579544f31d629f8$var$Xe[a]) return $d579544f31d629f8$var$Xe[a];
    if (!$d579544f31d629f8$var$We[a]) return a;
    var b = $d579544f31d629f8$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $d579544f31d629f8$var$Ye) return $d579544f31d629f8$var$Xe[a] = b[c];
    return a;
}
var $d579544f31d629f8$var$$e = $d579544f31d629f8$var$Ze("animationend"), $d579544f31d629f8$var$af = $d579544f31d629f8$var$Ze("animationiteration"), $d579544f31d629f8$var$bf = $d579544f31d629f8$var$Ze("animationstart"), $d579544f31d629f8$var$cf = $d579544f31d629f8$var$Ze("transitionend"), $d579544f31d629f8$var$df = new Map, $d579544f31d629f8$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $d579544f31d629f8$var$ff(a, b) {
    $d579544f31d629f8$var$df.set(a, b);
    $d579544f31d629f8$var$fa(b, [
        a
    ]);
}
for(var $d579544f31d629f8$var$gf = 0; $d579544f31d629f8$var$gf < $d579544f31d629f8$var$ef.length; $d579544f31d629f8$var$gf++){
    var $d579544f31d629f8$var$hf = $d579544f31d629f8$var$ef[$d579544f31d629f8$var$gf], $d579544f31d629f8$var$jf = $d579544f31d629f8$var$hf.toLowerCase(), $d579544f31d629f8$var$kf = $d579544f31d629f8$var$hf[0].toUpperCase() + $d579544f31d629f8$var$hf.slice(1);
    $d579544f31d629f8$var$ff($d579544f31d629f8$var$jf, "on" + $d579544f31d629f8$var$kf);
}
$d579544f31d629f8$var$ff($d579544f31d629f8$var$$e, "onAnimationEnd");
$d579544f31d629f8$var$ff($d579544f31d629f8$var$af, "onAnimationIteration");
$d579544f31d629f8$var$ff($d579544f31d629f8$var$bf, "onAnimationStart");
$d579544f31d629f8$var$ff("dblclick", "onDoubleClick");
$d579544f31d629f8$var$ff("focusin", "onFocus");
$d579544f31d629f8$var$ff("focusout", "onBlur");
$d579544f31d629f8$var$ff($d579544f31d629f8$var$cf, "onTransitionEnd");
$d579544f31d629f8$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$d579544f31d629f8$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$d579544f31d629f8$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$d579544f31d629f8$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$d579544f31d629f8$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$d579544f31d629f8$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$d579544f31d629f8$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$d579544f31d629f8$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$d579544f31d629f8$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$d579544f31d629f8$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $d579544f31d629f8$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $d579544f31d629f8$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($d579544f31d629f8$var$lf));
function $d579544f31d629f8$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $d579544f31d629f8$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $d579544f31d629f8$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $d579544f31d629f8$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $d579544f31d629f8$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($d579544f31d629f8$var$Qb) throw a = $d579544f31d629f8$var$Rb, $d579544f31d629f8$var$Qb = !1, $d579544f31d629f8$var$Rb = null, a;
}
function $d579544f31d629f8$var$D(a, b) {
    var c = b[$d579544f31d629f8$var$of];
    void 0 === c && (c = b[$d579544f31d629f8$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($d579544f31d629f8$var$pf(b, a, 2, !1), c.add(d));
}
function $d579544f31d629f8$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $d579544f31d629f8$var$pf(c, a, d, b);
}
var $d579544f31d629f8$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $d579544f31d629f8$var$sf(a) {
    if (!a[$d579544f31d629f8$var$rf]) {
        a[$d579544f31d629f8$var$rf] = !0;
        $d579544f31d629f8$var$da.forEach(function(b) {
            "selectionchange" !== b && ($d579544f31d629f8$var$mf.has(b) || $d579544f31d629f8$var$qf(b, !1, a), $d579544f31d629f8$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$d579544f31d629f8$var$rf] || (b[$d579544f31d629f8$var$rf] = !0, $d579544f31d629f8$var$qf("selectionchange", !1, b));
    }
}
function $d579544f31d629f8$var$pf(a, b, c, d) {
    switch($d579544f31d629f8$var$jd(b)){
        case 1:
            var e = $d579544f31d629f8$var$ed;
            break;
        case 4:
            e = $d579544f31d629f8$var$gd;
            break;
        default:
            e = $d579544f31d629f8$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$d579544f31d629f8$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $d579544f31d629f8$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $d579544f31d629f8$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $d579544f31d629f8$var$Jb(function() {
        var _$d = f, _$e = $d579544f31d629f8$var$xb(c), g = [];
        a: {
            var h = $d579544f31d629f8$var$df.get(a);
            if (void 0 !== h) {
                var k = $d579544f31d629f8$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $d579544f31d629f8$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $d579544f31d629f8$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $d579544f31d629f8$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $d579544f31d629f8$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $d579544f31d629f8$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $d579544f31d629f8$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $d579544f31d629f8$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $d579544f31d629f8$var$Vd;
                        break;
                    case $d579544f31d629f8$var$$e:
                    case $d579544f31d629f8$var$af:
                    case $d579544f31d629f8$var$bf:
                        k = $d579544f31d629f8$var$Hd;
                        break;
                    case $d579544f31d629f8$var$cf:
                        k = $d579544f31d629f8$var$Xd;
                        break;
                    case "scroll":
                        k = $d579544f31d629f8$var$vd;
                        break;
                    case "wheel":
                        k = $d579544f31d629f8$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $d579544f31d629f8$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $d579544f31d629f8$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $d579544f31d629f8$var$Kb(w, x), null != F && t.push($d579544f31d629f8$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $d579544f31d629f8$var$wb && (n = c.relatedTarget || c.fromElement) && ($d579544f31d629f8$var$Wc(n) || n[$d579544f31d629f8$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $d579544f31d629f8$var$Wc(n) : null, null !== n && (J = $d579544f31d629f8$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $d579544f31d629f8$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $d579544f31d629f8$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $d579544f31d629f8$var$ue(k);
                        u = null == n ? h : $d579544f31d629f8$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $d579544f31d629f8$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $d579544f31d629f8$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $d579544f31d629f8$var$vf(F))u++;
                            for(; 0 < w - u;)t = $d579544f31d629f8$var$vf(t), w--;
                            for(; 0 < u - w;)x = $d579544f31d629f8$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $d579544f31d629f8$var$vf(t);
                                x = $d579544f31d629f8$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $d579544f31d629f8$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $d579544f31d629f8$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $d579544f31d629f8$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $d579544f31d629f8$var$ve;
                else if ($d579544f31d629f8$var$me(h)) {
                    if ($d579544f31d629f8$var$we) na = $d579544f31d629f8$var$Fe;
                    else {
                        na = $d579544f31d629f8$var$De;
                        var xa = $d579544f31d629f8$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $d579544f31d629f8$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $d579544f31d629f8$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $d579544f31d629f8$var$cb(h, "number", h.value);
            }
            xa = _$d ? $d579544f31d629f8$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($d579544f31d629f8$var$me(xa) || "true" === xa.contentEditable) $d579544f31d629f8$var$Qe = xa, $d579544f31d629f8$var$Re = _$d, $d579544f31d629f8$var$Se = null;
                    break;
                case "focusout":
                    $d579544f31d629f8$var$Se = $d579544f31d629f8$var$Re = $d579544f31d629f8$var$Qe = null;
                    break;
                case "mousedown":
                    $d579544f31d629f8$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $d579544f31d629f8$var$Te = !1;
                    $d579544f31d629f8$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($d579544f31d629f8$var$Pe) break;
                case "keydown":
                case "keyup":
                    $d579544f31d629f8$var$Ue(g, c, _$e);
            }
            var $a;
            if ($d579544f31d629f8$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $d579544f31d629f8$var$ie ? $d579544f31d629f8$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($d579544f31d629f8$var$de && "ko" !== c.locale && ($d579544f31d629f8$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $d579544f31d629f8$var$ie && ($a = $d579544f31d629f8$var$nd()) : ($d579544f31d629f8$var$kd = _$e, $d579544f31d629f8$var$ld = "value" in $d579544f31d629f8$var$kd ? $d579544f31d629f8$var$kd.value : $d579544f31d629f8$var$kd.textContent, $d579544f31d629f8$var$ie = !0)), xa = $d579544f31d629f8$var$oe(_$d, ba), 0 < xa.length && (ba = new $d579544f31d629f8$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $d579544f31d629f8$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $d579544f31d629f8$var$ce ? $d579544f31d629f8$var$je(a, c) : $d579544f31d629f8$var$ke(a, c)) _$d = $d579544f31d629f8$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $d579544f31d629f8$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $d579544f31d629f8$var$se(g, b);
    });
}
function $d579544f31d629f8$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $d579544f31d629f8$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $d579544f31d629f8$var$Kb(a, c), null != f && d.unshift($d579544f31d629f8$var$tf(a, f, e)), f = $d579544f31d629f8$var$Kb(a, b), null != f && d.push($d579544f31d629f8$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $d579544f31d629f8$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $d579544f31d629f8$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $d579544f31d629f8$var$Kb(c, f), null != k && g.unshift($d579544f31d629f8$var$tf(c, k, h))) : e || (k = $d579544f31d629f8$var$Kb(c, f), null != k && g.push($d579544f31d629f8$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $d579544f31d629f8$var$xf = /\r\n?/g, $d579544f31d629f8$var$yf = /\u0000|\uFFFD/g;
function $d579544f31d629f8$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($d579544f31d629f8$var$xf, "\n").replace($d579544f31d629f8$var$yf, "");
}
function $d579544f31d629f8$var$Af(a, b, c) {
    b = $d579544f31d629f8$var$zf(b);
    if ($d579544f31d629f8$var$zf(a) !== b && c) throw Error($d579544f31d629f8$var$p(425));
}
function $d579544f31d629f8$var$Bf() {}
var $d579544f31d629f8$var$Cf = null, $d579544f31d629f8$var$Df = null;
function $d579544f31d629f8$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $d579544f31d629f8$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $d579544f31d629f8$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $d579544f31d629f8$var$Hf = "function" === typeof Promise ? Promise : void 0, $d579544f31d629f8$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $d579544f31d629f8$var$Hf ? function Jf(a) {
    return $d579544f31d629f8$var$Hf.resolve(null).then(a).catch($d579544f31d629f8$var$If);
} : $d579544f31d629f8$var$Ff;
function $d579544f31d629f8$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $d579544f31d629f8$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $d579544f31d629f8$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $d579544f31d629f8$var$bd(b);
}
function $d579544f31d629f8$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $d579544f31d629f8$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $d579544f31d629f8$var$Nf = Math.random().toString(36).slice(2), $d579544f31d629f8$var$Of = "__reactFiber$" + $d579544f31d629f8$var$Nf, $d579544f31d629f8$var$Pf = "__reactProps$" + $d579544f31d629f8$var$Nf, $d579544f31d629f8$var$uf = "__reactContainer$" + $d579544f31d629f8$var$Nf, $d579544f31d629f8$var$of = "__reactEvents$" + $d579544f31d629f8$var$Nf, $d579544f31d629f8$var$Qf = "__reactListeners$" + $d579544f31d629f8$var$Nf, $d579544f31d629f8$var$Rf = "__reactHandles$" + $d579544f31d629f8$var$Nf;
function $d579544f31d629f8$var$Wc(a) {
    var b = a[$d579544f31d629f8$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$d579544f31d629f8$var$uf] || c[$d579544f31d629f8$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $d579544f31d629f8$var$Mf(a); null !== a;){
                if (c = a[$d579544f31d629f8$var$Of]) return c;
                a = $d579544f31d629f8$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $d579544f31d629f8$var$Cb(a) {
    a = a[$d579544f31d629f8$var$Of] || a[$d579544f31d629f8$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $d579544f31d629f8$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($d579544f31d629f8$var$p(33));
}
function $d579544f31d629f8$var$Db(a) {
    return a[$d579544f31d629f8$var$Pf] || null;
}
var $d579544f31d629f8$var$Sf = [], $d579544f31d629f8$var$Tf = -1;
function $d579544f31d629f8$var$Uf(a) {
    return {
        current: a
    };
}
function $d579544f31d629f8$var$E(a) {
    0 > $d579544f31d629f8$var$Tf || (a.current = $d579544f31d629f8$var$Sf[$d579544f31d629f8$var$Tf], $d579544f31d629f8$var$Sf[$d579544f31d629f8$var$Tf] = null, $d579544f31d629f8$var$Tf--);
}
function $d579544f31d629f8$var$G(a, b) {
    $d579544f31d629f8$var$Tf++;
    $d579544f31d629f8$var$Sf[$d579544f31d629f8$var$Tf] = a.current;
    a.current = b;
}
var $d579544f31d629f8$var$Vf = {}, $d579544f31d629f8$var$H = $d579544f31d629f8$var$Uf($d579544f31d629f8$var$Vf), $d579544f31d629f8$var$Wf = $d579544f31d629f8$var$Uf(!1), $d579544f31d629f8$var$Xf = $d579544f31d629f8$var$Vf;
function $d579544f31d629f8$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $d579544f31d629f8$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $d579544f31d629f8$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $d579544f31d629f8$var$$f() {
    $d579544f31d629f8$var$E($d579544f31d629f8$var$Wf);
    $d579544f31d629f8$var$E($d579544f31d629f8$var$H);
}
function $d579544f31d629f8$var$ag(a, b, c) {
    if ($d579544f31d629f8$var$H.current !== $d579544f31d629f8$var$Vf) throw Error($d579544f31d629f8$var$p(168));
    $d579544f31d629f8$var$G($d579544f31d629f8$var$H, b);
    $d579544f31d629f8$var$G($d579544f31d629f8$var$Wf, c);
}
function $d579544f31d629f8$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($d579544f31d629f8$var$p(108, $d579544f31d629f8$var$Ra(a) || "Unknown", e));
    return $d579544f31d629f8$var$A({}, c, d);
}
function $d579544f31d629f8$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $d579544f31d629f8$var$Vf;
    $d579544f31d629f8$var$Xf = $d579544f31d629f8$var$H.current;
    $d579544f31d629f8$var$G($d579544f31d629f8$var$H, a);
    $d579544f31d629f8$var$G($d579544f31d629f8$var$Wf, $d579544f31d629f8$var$Wf.current);
    return !0;
}
function $d579544f31d629f8$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($d579544f31d629f8$var$p(169));
    c ? (a = $d579544f31d629f8$var$bg(a, b, $d579544f31d629f8$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $d579544f31d629f8$var$E($d579544f31d629f8$var$Wf), $d579544f31d629f8$var$E($d579544f31d629f8$var$H), $d579544f31d629f8$var$G($d579544f31d629f8$var$H, a)) : $d579544f31d629f8$var$E($d579544f31d629f8$var$Wf);
    $d579544f31d629f8$var$G($d579544f31d629f8$var$Wf, c);
}
var $d579544f31d629f8$var$eg = null, $d579544f31d629f8$var$fg = !1, $d579544f31d629f8$var$gg = !1;
function $d579544f31d629f8$var$hg(a) {
    null === $d579544f31d629f8$var$eg ? $d579544f31d629f8$var$eg = [
        a
    ] : $d579544f31d629f8$var$eg.push(a);
}
function $d579544f31d629f8$var$ig(a) {
    $d579544f31d629f8$var$fg = !0;
    $d579544f31d629f8$var$hg(a);
}
function $d579544f31d629f8$var$jg() {
    if (!$d579544f31d629f8$var$gg && null !== $d579544f31d629f8$var$eg) {
        $d579544f31d629f8$var$gg = !0;
        var a = 0, b = $d579544f31d629f8$var$C;
        try {
            var c = $d579544f31d629f8$var$eg;
            for($d579544f31d629f8$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $d579544f31d629f8$var$eg = null;
            $d579544f31d629f8$var$fg = !1;
        } catch (e) {
            throw null !== $d579544f31d629f8$var$eg && ($d579544f31d629f8$var$eg = $d579544f31d629f8$var$eg.slice(a + 1)), $d579544f31d629f8$var$ac($d579544f31d629f8$var$fc, $d579544f31d629f8$var$jg), e;
        } finally{
            $d579544f31d629f8$var$C = b, $d579544f31d629f8$var$gg = !1;
        }
    }
    return null;
}
var $d579544f31d629f8$var$kg = [], $d579544f31d629f8$var$lg = 0, $d579544f31d629f8$var$mg = null, $d579544f31d629f8$var$ng = 0, $d579544f31d629f8$var$og = [], $d579544f31d629f8$var$pg = 0, $d579544f31d629f8$var$qg = null, $d579544f31d629f8$var$rg = 1, $d579544f31d629f8$var$sg = "";
function $d579544f31d629f8$var$tg(a, b) {
    $d579544f31d629f8$var$kg[$d579544f31d629f8$var$lg++] = $d579544f31d629f8$var$ng;
    $d579544f31d629f8$var$kg[$d579544f31d629f8$var$lg++] = $d579544f31d629f8$var$mg;
    $d579544f31d629f8$var$mg = a;
    $d579544f31d629f8$var$ng = b;
}
function $d579544f31d629f8$var$ug(a, b, c) {
    $d579544f31d629f8$var$og[$d579544f31d629f8$var$pg++] = $d579544f31d629f8$var$rg;
    $d579544f31d629f8$var$og[$d579544f31d629f8$var$pg++] = $d579544f31d629f8$var$sg;
    $d579544f31d629f8$var$og[$d579544f31d629f8$var$pg++] = $d579544f31d629f8$var$qg;
    $d579544f31d629f8$var$qg = a;
    var d = $d579544f31d629f8$var$rg;
    a = $d579544f31d629f8$var$sg;
    var e = 32 - $d579544f31d629f8$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $d579544f31d629f8$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $d579544f31d629f8$var$rg = 1 << 32 - $d579544f31d629f8$var$oc(b) + e | c << e | d;
        $d579544f31d629f8$var$sg = f + a;
    } else $d579544f31d629f8$var$rg = 1 << f | c << e | d, $d579544f31d629f8$var$sg = a;
}
function $d579544f31d629f8$var$vg(a) {
    null !== a.return && ($d579544f31d629f8$var$tg(a, 1), $d579544f31d629f8$var$ug(a, 1, 0));
}
function $d579544f31d629f8$var$wg(a) {
    for(; a === $d579544f31d629f8$var$mg;)$d579544f31d629f8$var$mg = $d579544f31d629f8$var$kg[--$d579544f31d629f8$var$lg], $d579544f31d629f8$var$kg[$d579544f31d629f8$var$lg] = null, $d579544f31d629f8$var$ng = $d579544f31d629f8$var$kg[--$d579544f31d629f8$var$lg], $d579544f31d629f8$var$kg[$d579544f31d629f8$var$lg] = null;
    for(; a === $d579544f31d629f8$var$qg;)$d579544f31d629f8$var$qg = $d579544f31d629f8$var$og[--$d579544f31d629f8$var$pg], $d579544f31d629f8$var$og[$d579544f31d629f8$var$pg] = null, $d579544f31d629f8$var$sg = $d579544f31d629f8$var$og[--$d579544f31d629f8$var$pg], $d579544f31d629f8$var$og[$d579544f31d629f8$var$pg] = null, $d579544f31d629f8$var$rg = $d579544f31d629f8$var$og[--$d579544f31d629f8$var$pg], $d579544f31d629f8$var$og[$d579544f31d629f8$var$pg] = null;
}
var $d579544f31d629f8$var$xg = null, $d579544f31d629f8$var$yg = null, $d579544f31d629f8$var$I = !1, $d579544f31d629f8$var$zg = null;
function $d579544f31d629f8$var$Ag(a, b) {
    var c = $d579544f31d629f8$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $d579544f31d629f8$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $d579544f31d629f8$var$xg = a, $d579544f31d629f8$var$yg = $d579544f31d629f8$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $d579544f31d629f8$var$xg = a, $d579544f31d629f8$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $d579544f31d629f8$var$qg ? {
                id: $d579544f31d629f8$var$rg,
                overflow: $d579544f31d629f8$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $d579544f31d629f8$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $d579544f31d629f8$var$xg = a, $d579544f31d629f8$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $d579544f31d629f8$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $d579544f31d629f8$var$Eg(a) {
    if ($d579544f31d629f8$var$I) {
        var b = $d579544f31d629f8$var$yg;
        if (b) {
            var c = b;
            if (!$d579544f31d629f8$var$Cg(a, b)) {
                if ($d579544f31d629f8$var$Dg(a)) throw Error($d579544f31d629f8$var$p(418));
                b = $d579544f31d629f8$var$Lf(c.nextSibling);
                var d = $d579544f31d629f8$var$xg;
                b && $d579544f31d629f8$var$Cg(a, b) ? $d579544f31d629f8$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $d579544f31d629f8$var$I = !1, $d579544f31d629f8$var$xg = a);
            }
        } else {
            if ($d579544f31d629f8$var$Dg(a)) throw Error($d579544f31d629f8$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $d579544f31d629f8$var$I = !1;
            $d579544f31d629f8$var$xg = a;
        }
    }
}
function $d579544f31d629f8$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $d579544f31d629f8$var$xg = a;
}
function $d579544f31d629f8$var$Gg(a) {
    if (a !== $d579544f31d629f8$var$xg) return !1;
    if (!$d579544f31d629f8$var$I) return $d579544f31d629f8$var$Fg(a), $d579544f31d629f8$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$d579544f31d629f8$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $d579544f31d629f8$var$yg)) {
        if ($d579544f31d629f8$var$Dg(a)) throw $d579544f31d629f8$var$Hg(), Error($d579544f31d629f8$var$p(418));
        for(; b;)$d579544f31d629f8$var$Ag(a, b), b = $d579544f31d629f8$var$Lf(b.nextSibling);
    }
    $d579544f31d629f8$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($d579544f31d629f8$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $d579544f31d629f8$var$yg = $d579544f31d629f8$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $d579544f31d629f8$var$yg = null;
        }
    } else $d579544f31d629f8$var$yg = $d579544f31d629f8$var$xg ? $d579544f31d629f8$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $d579544f31d629f8$var$Hg() {
    for(var a = $d579544f31d629f8$var$yg; a;)a = $d579544f31d629f8$var$Lf(a.nextSibling);
}
function $d579544f31d629f8$var$Ig() {
    $d579544f31d629f8$var$yg = $d579544f31d629f8$var$xg = null;
    $d579544f31d629f8$var$I = !1;
}
function $d579544f31d629f8$var$Jg(a) {
    null === $d579544f31d629f8$var$zg ? $d579544f31d629f8$var$zg = [
        a
    ] : $d579544f31d629f8$var$zg.push(a);
}
var $d579544f31d629f8$var$Kg = $d579544f31d629f8$var$ua.ReactCurrentBatchConfig;
function $d579544f31d629f8$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $d579544f31d629f8$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $d579544f31d629f8$var$Mg = $d579544f31d629f8$var$Uf(null), $d579544f31d629f8$var$Ng = null, $d579544f31d629f8$var$Og = null, $d579544f31d629f8$var$Pg = null;
function $d579544f31d629f8$var$Qg() {
    $d579544f31d629f8$var$Pg = $d579544f31d629f8$var$Og = $d579544f31d629f8$var$Ng = null;
}
function $d579544f31d629f8$var$Rg(a) {
    var b = $d579544f31d629f8$var$Mg.current;
    $d579544f31d629f8$var$E($d579544f31d629f8$var$Mg);
    a._currentValue = b;
}
function $d579544f31d629f8$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $d579544f31d629f8$var$Tg(a, b) {
    $d579544f31d629f8$var$Ng = a;
    $d579544f31d629f8$var$Pg = $d579544f31d629f8$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($d579544f31d629f8$var$Ug = !0), a.firstContext = null);
}
function $d579544f31d629f8$var$Vg(a) {
    var b = a._currentValue;
    if ($d579544f31d629f8$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $d579544f31d629f8$var$Og) {
            if (null === $d579544f31d629f8$var$Ng) throw Error($d579544f31d629f8$var$p(308));
            $d579544f31d629f8$var$Og = a;
            $d579544f31d629f8$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $d579544f31d629f8$var$Og = $d579544f31d629f8$var$Og.next = a;
    }
    return b;
}
var $d579544f31d629f8$var$Wg = null;
function $d579544f31d629f8$var$Xg(a) {
    null === $d579544f31d629f8$var$Wg ? $d579544f31d629f8$var$Wg = [
        a
    ] : $d579544f31d629f8$var$Wg.push(a);
}
function $d579544f31d629f8$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $d579544f31d629f8$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $d579544f31d629f8$var$Zg(a, d);
}
function $d579544f31d629f8$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $d579544f31d629f8$var$$g = !1;
function $d579544f31d629f8$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $d579544f31d629f8$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $d579544f31d629f8$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $d579544f31d629f8$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($d579544f31d629f8$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $d579544f31d629f8$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $d579544f31d629f8$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $d579544f31d629f8$var$Zg(a, c);
}
function $d579544f31d629f8$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $d579544f31d629f8$var$Cc(a, c);
    }
}
function $d579544f31d629f8$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $d579544f31d629f8$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $d579544f31d629f8$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $d579544f31d629f8$var$A({}, q, r);
                            break a;
                        case 2:
                            $d579544f31d629f8$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $d579544f31d629f8$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $d579544f31d629f8$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($d579544f31d629f8$var$p(191, e));
            e.call(d);
        }
    }
}
var $d579544f31d629f8$var$jh = (new $f6C7p.Component).refs;
function $d579544f31d629f8$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $d579544f31d629f8$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $d579544f31d629f8$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $d579544f31d629f8$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $d579544f31d629f8$var$L(), e = $d579544f31d629f8$var$lh(a), f = $d579544f31d629f8$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $d579544f31d629f8$var$dh(a, f, e);
        null !== b && ($d579544f31d629f8$var$mh(b, a, e, d), $d579544f31d629f8$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $d579544f31d629f8$var$L(), e = $d579544f31d629f8$var$lh(a), f = $d579544f31d629f8$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $d579544f31d629f8$var$dh(a, f, e);
        null !== b && ($d579544f31d629f8$var$mh(b, a, e, d), $d579544f31d629f8$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $d579544f31d629f8$var$L(), d = $d579544f31d629f8$var$lh(a), e = $d579544f31d629f8$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $d579544f31d629f8$var$dh(a, e, d);
        null !== b && ($d579544f31d629f8$var$mh(b, a, d, c), $d579544f31d629f8$var$eh(b, a, d));
    }
};
function $d579544f31d629f8$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$d579544f31d629f8$var$Ie(c, d) || !$d579544f31d629f8$var$Ie(e, f) : !0;
}
function $d579544f31d629f8$var$ph(a, b, c) {
    var d = !1, e = $d579544f31d629f8$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $d579544f31d629f8$var$Vg(f) : (e = $d579544f31d629f8$var$Zf(b) ? $d579544f31d629f8$var$Xf : $d579544f31d629f8$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $d579544f31d629f8$var$Yf(a, e) : $d579544f31d629f8$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $d579544f31d629f8$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $d579544f31d629f8$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $d579544f31d629f8$var$nh.enqueueReplaceState(b, b.state, null);
}
function $d579544f31d629f8$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $d579544f31d629f8$var$jh;
    $d579544f31d629f8$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $d579544f31d629f8$var$Vg(f) : (f = $d579544f31d629f8$var$Zf(b) ? $d579544f31d629f8$var$Xf : $d579544f31d629f8$var$H.current, e.context = $d579544f31d629f8$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($d579544f31d629f8$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $d579544f31d629f8$var$nh.enqueueReplaceState(e, e.state, null), $d579544f31d629f8$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $d579544f31d629f8$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($d579544f31d629f8$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($d579544f31d629f8$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $d579544f31d629f8$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($d579544f31d629f8$var$p(284));
        if (!c._owner) throw Error($d579544f31d629f8$var$p(290, a));
    }
    return a;
}
function $d579544f31d629f8$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($d579544f31d629f8$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $d579544f31d629f8$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $d579544f31d629f8$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $d579544f31d629f8$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $d579544f31d629f8$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $d579544f31d629f8$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $d579544f31d629f8$var$Ha && $d579544f31d629f8$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $d579544f31d629f8$var$sh(a, b, c), d.return = a, d;
        d = $d579544f31d629f8$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $d579544f31d629f8$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $d579544f31d629f8$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $d579544f31d629f8$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $d579544f31d629f8$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $d579544f31d629f8$var$va:
                    return c = $d579544f31d629f8$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $d579544f31d629f8$var$sh(a, null, b), c.return = a, c;
                case $d579544f31d629f8$var$wa:
                    return b = $d579544f31d629f8$var$zh(b, a.mode, c), b.return = a, b;
                case $d579544f31d629f8$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($d579544f31d629f8$var$eb(b) || $d579544f31d629f8$var$Ka(b)) return b = $d579544f31d629f8$var$Ah(b, a.mode, c, null), b.return = a, b;
            $d579544f31d629f8$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $d579544f31d629f8$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $d579544f31d629f8$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $d579544f31d629f8$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($d579544f31d629f8$var$eb(c) || $d579544f31d629f8$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $d579544f31d629f8$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $d579544f31d629f8$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $d579544f31d629f8$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $d579544f31d629f8$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($d579544f31d629f8$var$eb(d) || $d579544f31d629f8$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $d579544f31d629f8$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $d579544f31d629f8$var$I && $d579544f31d629f8$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $d579544f31d629f8$var$I && $d579544f31d629f8$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $d579544f31d629f8$var$I && $d579544f31d629f8$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $d579544f31d629f8$var$Ka(h);
        if ("function" !== typeof l) throw Error($d579544f31d629f8$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($d579544f31d629f8$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $d579544f31d629f8$var$I && $d579544f31d629f8$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $d579544f31d629f8$var$I && $d579544f31d629f8$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $d579544f31d629f8$var$I && $d579544f31d629f8$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $d579544f31d629f8$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $d579544f31d629f8$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $d579544f31d629f8$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $d579544f31d629f8$var$Ha && $d579544f31d629f8$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $d579544f31d629f8$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $d579544f31d629f8$var$ya ? (d = $d579544f31d629f8$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $d579544f31d629f8$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $d579544f31d629f8$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $d579544f31d629f8$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $d579544f31d629f8$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $d579544f31d629f8$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($d579544f31d629f8$var$eb(f)) return n(a, d, f, h);
            if ($d579544f31d629f8$var$Ka(f)) return t(a, d, f, h);
            $d579544f31d629f8$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $d579544f31d629f8$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $d579544f31d629f8$var$Bh = $d579544f31d629f8$var$vh(!0), $d579544f31d629f8$var$Ch = $d579544f31d629f8$var$vh(!1), $d579544f31d629f8$var$Dh = {}, $d579544f31d629f8$var$Eh = $d579544f31d629f8$var$Uf($d579544f31d629f8$var$Dh), $d579544f31d629f8$var$Fh = $d579544f31d629f8$var$Uf($d579544f31d629f8$var$Dh), $d579544f31d629f8$var$Gh = $d579544f31d629f8$var$Uf($d579544f31d629f8$var$Dh);
function $d579544f31d629f8$var$Hh(a) {
    if (a === $d579544f31d629f8$var$Dh) throw Error($d579544f31d629f8$var$p(174));
    return a;
}
function $d579544f31d629f8$var$Ih(a, b) {
    $d579544f31d629f8$var$G($d579544f31d629f8$var$Gh, b);
    $d579544f31d629f8$var$G($d579544f31d629f8$var$Fh, a);
    $d579544f31d629f8$var$G($d579544f31d629f8$var$Eh, $d579544f31d629f8$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $d579544f31d629f8$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $d579544f31d629f8$var$lb(b, a);
    }
    $d579544f31d629f8$var$E($d579544f31d629f8$var$Eh);
    $d579544f31d629f8$var$G($d579544f31d629f8$var$Eh, b);
}
function $d579544f31d629f8$var$Jh() {
    $d579544f31d629f8$var$E($d579544f31d629f8$var$Eh);
    $d579544f31d629f8$var$E($d579544f31d629f8$var$Fh);
    $d579544f31d629f8$var$E($d579544f31d629f8$var$Gh);
}
function $d579544f31d629f8$var$Kh(a) {
    $d579544f31d629f8$var$Hh($d579544f31d629f8$var$Gh.current);
    var b = $d579544f31d629f8$var$Hh($d579544f31d629f8$var$Eh.current);
    var c = $d579544f31d629f8$var$lb(b, a.type);
    b !== c && ($d579544f31d629f8$var$G($d579544f31d629f8$var$Fh, a), $d579544f31d629f8$var$G($d579544f31d629f8$var$Eh, c));
}
function $d579544f31d629f8$var$Lh(a) {
    $d579544f31d629f8$var$Fh.current === a && ($d579544f31d629f8$var$E($d579544f31d629f8$var$Eh), $d579544f31d629f8$var$E($d579544f31d629f8$var$Fh));
}
var $d579544f31d629f8$var$M = $d579544f31d629f8$var$Uf(0);
function $d579544f31d629f8$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $d579544f31d629f8$var$Nh = [];
function $d579544f31d629f8$var$Oh() {
    for(var a = 0; a < $d579544f31d629f8$var$Nh.length; a++)$d579544f31d629f8$var$Nh[a]._workInProgressVersionPrimary = null;
    $d579544f31d629f8$var$Nh.length = 0;
}
var $d579544f31d629f8$var$Ph = $d579544f31d629f8$var$ua.ReactCurrentDispatcher, $d579544f31d629f8$var$Qh = $d579544f31d629f8$var$ua.ReactCurrentBatchConfig, $d579544f31d629f8$var$Rh = 0, $d579544f31d629f8$var$N = null, $d579544f31d629f8$var$O = null, $d579544f31d629f8$var$P = null, $d579544f31d629f8$var$Sh = !1, $d579544f31d629f8$var$Th = !1, $d579544f31d629f8$var$Uh = 0, $d579544f31d629f8$var$Vh = 0;
function $d579544f31d629f8$var$Q() {
    throw Error($d579544f31d629f8$var$p(321));
}
function $d579544f31d629f8$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$d579544f31d629f8$var$He(a[c], b[c])) return !1;
    return !0;
}
function $d579544f31d629f8$var$Xh(a, b, c, d, e, f) {
    $d579544f31d629f8$var$Rh = f;
    $d579544f31d629f8$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $d579544f31d629f8$var$Ph.current = null === a || null === a.memoizedState ? $d579544f31d629f8$var$Yh : $d579544f31d629f8$var$Zh;
    a = c(d, e);
    if ($d579544f31d629f8$var$Th) {
        f = 0;
        do {
            $d579544f31d629f8$var$Th = !1;
            $d579544f31d629f8$var$Uh = 0;
            if (25 <= f) throw Error($d579544f31d629f8$var$p(301));
            f += 1;
            $d579544f31d629f8$var$P = $d579544f31d629f8$var$O = null;
            b.updateQueue = null;
            $d579544f31d629f8$var$Ph.current = $d579544f31d629f8$var$$h;
            a = c(d, e);
        }while ($d579544f31d629f8$var$Th);
    }
    $d579544f31d629f8$var$Ph.current = $d579544f31d629f8$var$ai;
    b = null !== $d579544f31d629f8$var$O && null !== $d579544f31d629f8$var$O.next;
    $d579544f31d629f8$var$Rh = 0;
    $d579544f31d629f8$var$P = $d579544f31d629f8$var$O = $d579544f31d629f8$var$N = null;
    $d579544f31d629f8$var$Sh = !1;
    if (b) throw Error($d579544f31d629f8$var$p(300));
    return a;
}
function $d579544f31d629f8$var$bi() {
    var a = 0 !== $d579544f31d629f8$var$Uh;
    $d579544f31d629f8$var$Uh = 0;
    return a;
}
function $d579544f31d629f8$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $d579544f31d629f8$var$P ? $d579544f31d629f8$var$N.memoizedState = $d579544f31d629f8$var$P = a : $d579544f31d629f8$var$P = $d579544f31d629f8$var$P.next = a;
    return $d579544f31d629f8$var$P;
}
function $d579544f31d629f8$var$di() {
    if (null === $d579544f31d629f8$var$O) {
        var a = $d579544f31d629f8$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $d579544f31d629f8$var$O.next;
    var b = null === $d579544f31d629f8$var$P ? $d579544f31d629f8$var$N.memoizedState : $d579544f31d629f8$var$P.next;
    if (null !== b) $d579544f31d629f8$var$P = b, $d579544f31d629f8$var$O = a;
    else {
        if (null === a) throw Error($d579544f31d629f8$var$p(310));
        $d579544f31d629f8$var$O = a;
        a = {
            memoizedState: $d579544f31d629f8$var$O.memoizedState,
            baseState: $d579544f31d629f8$var$O.baseState,
            baseQueue: $d579544f31d629f8$var$O.baseQueue,
            queue: $d579544f31d629f8$var$O.queue,
            next: null
        };
        null === $d579544f31d629f8$var$P ? $d579544f31d629f8$var$N.memoizedState = $d579544f31d629f8$var$P = a : $d579544f31d629f8$var$P = $d579544f31d629f8$var$P.next = a;
    }
    return $d579544f31d629f8$var$P;
}
function $d579544f31d629f8$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $d579544f31d629f8$var$fi(a) {
    var b = $d579544f31d629f8$var$di(), c = b.queue;
    if (null === c) throw Error($d579544f31d629f8$var$p(311));
    c.lastRenderedReducer = a;
    var d = $d579544f31d629f8$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($d579544f31d629f8$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $d579544f31d629f8$var$N.lanes |= m;
                $d579544f31d629f8$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $d579544f31d629f8$var$He(d, b.memoizedState) || ($d579544f31d629f8$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $d579544f31d629f8$var$N.lanes |= f, $d579544f31d629f8$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $d579544f31d629f8$var$gi(a) {
    var b = $d579544f31d629f8$var$di(), c = b.queue;
    if (null === c) throw Error($d579544f31d629f8$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $d579544f31d629f8$var$He(f, b.memoizedState) || ($d579544f31d629f8$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $d579544f31d629f8$var$hi() {}
function $d579544f31d629f8$var$ii(a, b) {
    var c = $d579544f31d629f8$var$N, d = $d579544f31d629f8$var$di(), e = b(), f = !$d579544f31d629f8$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $d579544f31d629f8$var$Ug = !0);
    d = d.queue;
    $d579544f31d629f8$var$ji($d579544f31d629f8$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $d579544f31d629f8$var$P && $d579544f31d629f8$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $d579544f31d629f8$var$li(9, $d579544f31d629f8$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $d579544f31d629f8$var$R) throw Error($d579544f31d629f8$var$p(349));
        0 !== ($d579544f31d629f8$var$Rh & 30) || $d579544f31d629f8$var$ni(c, b, e);
    }
    return e;
}
function $d579544f31d629f8$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $d579544f31d629f8$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $d579544f31d629f8$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $d579544f31d629f8$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $d579544f31d629f8$var$oi(b) && $d579544f31d629f8$var$pi(a);
}
function $d579544f31d629f8$var$ki(a, b, c) {
    return c(function() {
        $d579544f31d629f8$var$oi(b) && $d579544f31d629f8$var$pi(a);
    });
}
function $d579544f31d629f8$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$d579544f31d629f8$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $d579544f31d629f8$var$pi(a) {
    var b = $d579544f31d629f8$var$Zg(a, 1);
    null !== b && $d579544f31d629f8$var$mh(b, a, 1, -1);
}
function $d579544f31d629f8$var$qi(a) {
    var b = $d579544f31d629f8$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d579544f31d629f8$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $d579544f31d629f8$var$ri.bind(null, $d579544f31d629f8$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $d579544f31d629f8$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $d579544f31d629f8$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $d579544f31d629f8$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $d579544f31d629f8$var$si() {
    return $d579544f31d629f8$var$di().memoizedState;
}
function $d579544f31d629f8$var$ti(a, b, c, d) {
    var e = $d579544f31d629f8$var$ci();
    $d579544f31d629f8$var$N.flags |= a;
    e.memoizedState = $d579544f31d629f8$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $d579544f31d629f8$var$ui(a, b, c, d) {
    var e = $d579544f31d629f8$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $d579544f31d629f8$var$O) {
        var g = $d579544f31d629f8$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $d579544f31d629f8$var$Wh(d, g.deps)) {
            e.memoizedState = $d579544f31d629f8$var$li(b, c, f, d);
            return;
        }
    }
    $d579544f31d629f8$var$N.flags |= a;
    e.memoizedState = $d579544f31d629f8$var$li(1 | b, c, f, d);
}
function $d579544f31d629f8$var$vi(a, b) {
    return $d579544f31d629f8$var$ti(8390656, 8, a, b);
}
function $d579544f31d629f8$var$ji(a, b) {
    return $d579544f31d629f8$var$ui(2048, 8, a, b);
}
function $d579544f31d629f8$var$wi(a, b) {
    return $d579544f31d629f8$var$ui(4, 2, a, b);
}
function $d579544f31d629f8$var$xi(a, b) {
    return $d579544f31d629f8$var$ui(4, 4, a, b);
}
function $d579544f31d629f8$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $d579544f31d629f8$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $d579544f31d629f8$var$ui(4, 4, $d579544f31d629f8$var$yi.bind(null, b, a), c);
}
function $d579544f31d629f8$var$Ai() {}
function $d579544f31d629f8$var$Bi(a, b) {
    var c = $d579544f31d629f8$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $d579544f31d629f8$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d579544f31d629f8$var$Ci(a, b) {
    var c = $d579544f31d629f8$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $d579544f31d629f8$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d579544f31d629f8$var$Di(a, b, c) {
    if (0 === ($d579544f31d629f8$var$Rh & 21)) return a.baseState && (a.baseState = !1, $d579544f31d629f8$var$Ug = !0), a.memoizedState = c;
    $d579544f31d629f8$var$He(c, b) || (c = $d579544f31d629f8$var$yc(), $d579544f31d629f8$var$N.lanes |= c, $d579544f31d629f8$var$hh |= c, a.baseState = !0);
    return b;
}
function $d579544f31d629f8$var$Ei(a, b) {
    var c = $d579544f31d629f8$var$C;
    $d579544f31d629f8$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $d579544f31d629f8$var$Qh.transition;
    $d579544f31d629f8$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $d579544f31d629f8$var$C = c, $d579544f31d629f8$var$Qh.transition = d;
    }
}
function $d579544f31d629f8$var$Fi() {
    return $d579544f31d629f8$var$di().memoizedState;
}
function $d579544f31d629f8$var$Gi(a, b, c) {
    var d = $d579544f31d629f8$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d579544f31d629f8$var$Hi(a)) $d579544f31d629f8$var$Ii(b, c);
    else if (c = $d579544f31d629f8$var$Yg(a, b, c, d), null !== c) {
        var e = $d579544f31d629f8$var$L();
        $d579544f31d629f8$var$mh(c, a, d, e);
        $d579544f31d629f8$var$Ji(c, b, d);
    }
}
function $d579544f31d629f8$var$ri(a, b, c) {
    var d = $d579544f31d629f8$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d579544f31d629f8$var$Hi(a)) $d579544f31d629f8$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($d579544f31d629f8$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $d579544f31d629f8$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $d579544f31d629f8$var$Yg(a, b, e, d);
        null !== c && (e = $d579544f31d629f8$var$L(), $d579544f31d629f8$var$mh(c, a, d, e), $d579544f31d629f8$var$Ji(c, b, d));
    }
}
function $d579544f31d629f8$var$Hi(a) {
    var b = a.alternate;
    return a === $d579544f31d629f8$var$N || null !== b && b === $d579544f31d629f8$var$N;
}
function $d579544f31d629f8$var$Ii(a, b) {
    $d579544f31d629f8$var$Th = $d579544f31d629f8$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $d579544f31d629f8$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $d579544f31d629f8$var$Cc(a, c);
    }
}
var $d579544f31d629f8$var$ai = {
    readContext: $d579544f31d629f8$var$Vg,
    useCallback: $d579544f31d629f8$var$Q,
    useContext: $d579544f31d629f8$var$Q,
    useEffect: $d579544f31d629f8$var$Q,
    useImperativeHandle: $d579544f31d629f8$var$Q,
    useInsertionEffect: $d579544f31d629f8$var$Q,
    useLayoutEffect: $d579544f31d629f8$var$Q,
    useMemo: $d579544f31d629f8$var$Q,
    useReducer: $d579544f31d629f8$var$Q,
    useRef: $d579544f31d629f8$var$Q,
    useState: $d579544f31d629f8$var$Q,
    useDebugValue: $d579544f31d629f8$var$Q,
    useDeferredValue: $d579544f31d629f8$var$Q,
    useTransition: $d579544f31d629f8$var$Q,
    useMutableSource: $d579544f31d629f8$var$Q,
    useSyncExternalStore: $d579544f31d629f8$var$Q,
    useId: $d579544f31d629f8$var$Q,
    unstable_isNewReconciler: !1
}, $d579544f31d629f8$var$Yh = {
    readContext: $d579544f31d629f8$var$Vg,
    useCallback: function useCallback(a, b) {
        $d579544f31d629f8$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $d579544f31d629f8$var$Vg,
    useEffect: $d579544f31d629f8$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $d579544f31d629f8$var$ti(4194308, 4, $d579544f31d629f8$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $d579544f31d629f8$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $d579544f31d629f8$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $d579544f31d629f8$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $d579544f31d629f8$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $d579544f31d629f8$var$Gi.bind(null, $d579544f31d629f8$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $d579544f31d629f8$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $d579544f31d629f8$var$qi,
    useDebugValue: $d579544f31d629f8$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $d579544f31d629f8$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $d579544f31d629f8$var$qi(!1), b = a[0];
        a = $d579544f31d629f8$var$Ei.bind(null, a[1]);
        $d579544f31d629f8$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $d579544f31d629f8$var$N, e = $d579544f31d629f8$var$ci();
        if ($d579544f31d629f8$var$I) {
            if (void 0 === c) throw Error($d579544f31d629f8$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $d579544f31d629f8$var$R) throw Error($d579544f31d629f8$var$p(349));
            0 !== ($d579544f31d629f8$var$Rh & 30) || $d579544f31d629f8$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $d579544f31d629f8$var$vi($d579544f31d629f8$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $d579544f31d629f8$var$li(9, $d579544f31d629f8$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $d579544f31d629f8$var$ci(), b = $d579544f31d629f8$var$R.identifierPrefix;
        if ($d579544f31d629f8$var$I) {
            var c = $d579544f31d629f8$var$sg;
            var d = $d579544f31d629f8$var$rg;
            c = (d & ~(1 << 32 - $d579544f31d629f8$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $d579544f31d629f8$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $d579544f31d629f8$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $d579544f31d629f8$var$Zh = {
    readContext: $d579544f31d629f8$var$Vg,
    useCallback: $d579544f31d629f8$var$Bi,
    useContext: $d579544f31d629f8$var$Vg,
    useEffect: $d579544f31d629f8$var$ji,
    useImperativeHandle: $d579544f31d629f8$var$zi,
    useInsertionEffect: $d579544f31d629f8$var$wi,
    useLayoutEffect: $d579544f31d629f8$var$xi,
    useMemo: $d579544f31d629f8$var$Ci,
    useReducer: $d579544f31d629f8$var$fi,
    useRef: $d579544f31d629f8$var$si,
    useState: function useState() {
        return $d579544f31d629f8$var$fi($d579544f31d629f8$var$ei);
    },
    useDebugValue: $d579544f31d629f8$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $d579544f31d629f8$var$di();
        return $d579544f31d629f8$var$Di(b, $d579544f31d629f8$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $d579544f31d629f8$var$fi($d579544f31d629f8$var$ei)[0], b = $d579544f31d629f8$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $d579544f31d629f8$var$hi,
    useSyncExternalStore: $d579544f31d629f8$var$ii,
    useId: $d579544f31d629f8$var$Fi,
    unstable_isNewReconciler: !1
}, $d579544f31d629f8$var$$h = {
    readContext: $d579544f31d629f8$var$Vg,
    useCallback: $d579544f31d629f8$var$Bi,
    useContext: $d579544f31d629f8$var$Vg,
    useEffect: $d579544f31d629f8$var$ji,
    useImperativeHandle: $d579544f31d629f8$var$zi,
    useInsertionEffect: $d579544f31d629f8$var$wi,
    useLayoutEffect: $d579544f31d629f8$var$xi,
    useMemo: $d579544f31d629f8$var$Ci,
    useReducer: $d579544f31d629f8$var$gi,
    useRef: $d579544f31d629f8$var$si,
    useState: function useState() {
        return $d579544f31d629f8$var$gi($d579544f31d629f8$var$ei);
    },
    useDebugValue: $d579544f31d629f8$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $d579544f31d629f8$var$di();
        return null === $d579544f31d629f8$var$O ? b.memoizedState = a : $d579544f31d629f8$var$Di(b, $d579544f31d629f8$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $d579544f31d629f8$var$gi($d579544f31d629f8$var$ei)[0], b = $d579544f31d629f8$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $d579544f31d629f8$var$hi,
    useSyncExternalStore: $d579544f31d629f8$var$ii,
    useId: $d579544f31d629f8$var$Fi,
    unstable_isNewReconciler: !1
};
function $d579544f31d629f8$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $d579544f31d629f8$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $d579544f31d629f8$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $d579544f31d629f8$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $d579544f31d629f8$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $d579544f31d629f8$var$Oi(a, b, c) {
    c = $d579544f31d629f8$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $d579544f31d629f8$var$Pi || ($d579544f31d629f8$var$Pi = !0, $d579544f31d629f8$var$Qi = d);
        $d579544f31d629f8$var$Mi(a, b);
    };
    return c;
}
function $d579544f31d629f8$var$Ri(a, b, c) {
    c = $d579544f31d629f8$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $d579544f31d629f8$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $d579544f31d629f8$var$Mi(a, b);
        "function" !== typeof d && (null === $d579544f31d629f8$var$Si ? $d579544f31d629f8$var$Si = new Set([
            this
        ]) : $d579544f31d629f8$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $d579544f31d629f8$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $d579544f31d629f8$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $d579544f31d629f8$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $d579544f31d629f8$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $d579544f31d629f8$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $d579544f31d629f8$var$ch(-1, 1), b.tag = 2, $d579544f31d629f8$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $d579544f31d629f8$var$Xi = $d579544f31d629f8$var$ua.ReactCurrentOwner, $d579544f31d629f8$var$Ug = !1;
function $d579544f31d629f8$var$Yi(a, b, c, d) {
    b.child = null === a ? $d579544f31d629f8$var$Ch(b, null, c, d) : $d579544f31d629f8$var$Bh(b, a.child, c, d);
}
function $d579544f31d629f8$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $d579544f31d629f8$var$Tg(b, e);
    d = $d579544f31d629f8$var$Xh(a, b, c, d, f, e);
    c = $d579544f31d629f8$var$bi();
    if (null !== a && !$d579544f31d629f8$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $d579544f31d629f8$var$$i(a, b, e);
    $d579544f31d629f8$var$I && c && $d579544f31d629f8$var$vg(b);
    b.flags |= 1;
    $d579544f31d629f8$var$Yi(a, b, d, e);
    return b.child;
}
function $d579544f31d629f8$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$d579544f31d629f8$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $d579544f31d629f8$var$cj(a, b, f, d, e);
        a = $d579544f31d629f8$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $d579544f31d629f8$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $d579544f31d629f8$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $d579544f31d629f8$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $d579544f31d629f8$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($d579544f31d629f8$var$Ie(f, d) && a.ref === b.ref) {
            if ($d579544f31d629f8$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($d579544f31d629f8$var$Ug = !0);
            else return b.lanes = a.lanes, $d579544f31d629f8$var$$i(a, b, e);
        }
    }
    return $d579544f31d629f8$var$dj(a, b, c, d, e);
}
function $d579544f31d629f8$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $d579544f31d629f8$var$G($d579544f31d629f8$var$fj, $d579544f31d629f8$var$gj), $d579544f31d629f8$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $d579544f31d629f8$var$G($d579544f31d629f8$var$fj, $d579544f31d629f8$var$gj), $d579544f31d629f8$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $d579544f31d629f8$var$G($d579544f31d629f8$var$fj, $d579544f31d629f8$var$gj);
            $d579544f31d629f8$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $d579544f31d629f8$var$G($d579544f31d629f8$var$fj, $d579544f31d629f8$var$gj), $d579544f31d629f8$var$gj |= d;
    $d579544f31d629f8$var$Yi(a, b, e, c);
    return b.child;
}
function $d579544f31d629f8$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $d579544f31d629f8$var$dj(a, b, c, d, e) {
    var f = $d579544f31d629f8$var$Zf(c) ? $d579544f31d629f8$var$Xf : $d579544f31d629f8$var$H.current;
    f = $d579544f31d629f8$var$Yf(b, f);
    $d579544f31d629f8$var$Tg(b, e);
    c = $d579544f31d629f8$var$Xh(a, b, c, d, f, e);
    d = $d579544f31d629f8$var$bi();
    if (null !== a && !$d579544f31d629f8$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $d579544f31d629f8$var$$i(a, b, e);
    $d579544f31d629f8$var$I && d && $d579544f31d629f8$var$vg(b);
    b.flags |= 1;
    $d579544f31d629f8$var$Yi(a, b, c, e);
    return b.child;
}
function $d579544f31d629f8$var$ij(a, b, c, d, e) {
    if ($d579544f31d629f8$var$Zf(c)) {
        var f = !0;
        $d579544f31d629f8$var$cg(b);
    } else f = !1;
    $d579544f31d629f8$var$Tg(b, e);
    if (null === b.stateNode) $d579544f31d629f8$var$jj(a, b), $d579544f31d629f8$var$ph(b, c, d), $d579544f31d629f8$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $d579544f31d629f8$var$Vg(l) : (l = $d579544f31d629f8$var$Zf(c) ? $d579544f31d629f8$var$Xf : $d579544f31d629f8$var$H.current, l = $d579544f31d629f8$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $d579544f31d629f8$var$qh(b, g, d, l);
        $d579544f31d629f8$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $d579544f31d629f8$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $d579544f31d629f8$var$Wf.current || $d579544f31d629f8$var$$g ? ("function" === typeof m && ($d579544f31d629f8$var$kh(b, c, m, d), k = b.memoizedState), (h = $d579544f31d629f8$var$$g || $d579544f31d629f8$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $d579544f31d629f8$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $d579544f31d629f8$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $d579544f31d629f8$var$Vg(k) : (k = $d579544f31d629f8$var$Zf(c) ? $d579544f31d629f8$var$Xf : $d579544f31d629f8$var$H.current, k = $d579544f31d629f8$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $d579544f31d629f8$var$qh(b, g, d, k);
        $d579544f31d629f8$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $d579544f31d629f8$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $d579544f31d629f8$var$Wf.current || $d579544f31d629f8$var$$g ? ("function" === typeof y && ($d579544f31d629f8$var$kh(b, c, y, d), n = b.memoizedState), (l = $d579544f31d629f8$var$$g || $d579544f31d629f8$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $d579544f31d629f8$var$kj(a, b, c, d, f, e);
}
function $d579544f31d629f8$var$kj(a, b, c, d, e, f) {
    $d579544f31d629f8$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $d579544f31d629f8$var$dg(b, c, !1), $d579544f31d629f8$var$$i(a, b, f);
    d = b.stateNode;
    $d579544f31d629f8$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $d579544f31d629f8$var$Bh(b, a.child, null, f), b.child = $d579544f31d629f8$var$Bh(b, null, h, f)) : $d579544f31d629f8$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $d579544f31d629f8$var$dg(b, c, !0);
    return b.child;
}
function $d579544f31d629f8$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $d579544f31d629f8$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $d579544f31d629f8$var$ag(a, b.context, !1);
    $d579544f31d629f8$var$Ih(a, b.containerInfo);
}
function $d579544f31d629f8$var$mj(a, b, c, d, e) {
    $d579544f31d629f8$var$Ig();
    $d579544f31d629f8$var$Jg(e);
    b.flags |= 256;
    $d579544f31d629f8$var$Yi(a, b, c, d);
    return b.child;
}
var $d579544f31d629f8$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $d579544f31d629f8$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $d579544f31d629f8$var$pj(a, b, c) {
    var d = b.pendingProps, e = $d579544f31d629f8$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $d579544f31d629f8$var$G($d579544f31d629f8$var$M, e & 1);
    if (null === a) {
        $d579544f31d629f8$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $d579544f31d629f8$var$qj(g, d, 0, null), a = $d579544f31d629f8$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $d579544f31d629f8$var$oj(c), b.memoizedState = $d579544f31d629f8$var$nj, a) : $d579544f31d629f8$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $d579544f31d629f8$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $d579544f31d629f8$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $d579544f31d629f8$var$wh(h, f) : (f = $d579544f31d629f8$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $d579544f31d629f8$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $d579544f31d629f8$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $d579544f31d629f8$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $d579544f31d629f8$var$rj(a, b) {
    b = $d579544f31d629f8$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $d579544f31d629f8$var$tj(a, b, c, d) {
    null !== d && $d579544f31d629f8$var$Jg(d);
    $d579544f31d629f8$var$Bh(b, a.child, null, c);
    a = $d579544f31d629f8$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $d579544f31d629f8$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $d579544f31d629f8$var$Li(Error($d579544f31d629f8$var$p(422))), $d579544f31d629f8$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $d579544f31d629f8$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $d579544f31d629f8$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $d579544f31d629f8$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $d579544f31d629f8$var$oj(g);
        b.memoizedState = $d579544f31d629f8$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $d579544f31d629f8$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($d579544f31d629f8$var$p(419));
        d = $d579544f31d629f8$var$Li(f, d, void 0);
        return $d579544f31d629f8$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($d579544f31d629f8$var$Ug || h) {
        d = $d579544f31d629f8$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $d579544f31d629f8$var$Zg(a, e), $d579544f31d629f8$var$mh(d, a, e, -1));
        }
        $d579544f31d629f8$var$uj();
        d = $d579544f31d629f8$var$Li(Error($d579544f31d629f8$var$p(421)));
        return $d579544f31d629f8$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $d579544f31d629f8$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $d579544f31d629f8$var$yg = $d579544f31d629f8$var$Lf(e.nextSibling);
    $d579544f31d629f8$var$xg = b;
    $d579544f31d629f8$var$I = !0;
    $d579544f31d629f8$var$zg = null;
    null !== a && ($d579544f31d629f8$var$og[$d579544f31d629f8$var$pg++] = $d579544f31d629f8$var$rg, $d579544f31d629f8$var$og[$d579544f31d629f8$var$pg++] = $d579544f31d629f8$var$sg, $d579544f31d629f8$var$og[$d579544f31d629f8$var$pg++] = $d579544f31d629f8$var$qg, $d579544f31d629f8$var$rg = a.id, $d579544f31d629f8$var$sg = a.overflow, $d579544f31d629f8$var$qg = b);
    b = $d579544f31d629f8$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $d579544f31d629f8$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $d579544f31d629f8$var$Sg(a.return, b, c);
}
function $d579544f31d629f8$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $d579544f31d629f8$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $d579544f31d629f8$var$Yi(a, b, d.children, c);
    d = $d579544f31d629f8$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $d579544f31d629f8$var$wj(a, c, b);
            else if (19 === a.tag) $d579544f31d629f8$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $d579544f31d629f8$var$G($d579544f31d629f8$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $d579544f31d629f8$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $d579544f31d629f8$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $d579544f31d629f8$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $d579544f31d629f8$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $d579544f31d629f8$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $d579544f31d629f8$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $d579544f31d629f8$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $d579544f31d629f8$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($d579544f31d629f8$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $d579544f31d629f8$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $d579544f31d629f8$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $d579544f31d629f8$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $d579544f31d629f8$var$lj(b);
            $d579544f31d629f8$var$Ig();
            break;
        case 5:
            $d579544f31d629f8$var$Kh(b);
            break;
        case 1:
            $d579544f31d629f8$var$Zf(b.type) && $d579544f31d629f8$var$cg(b);
            break;
        case 4:
            $d579544f31d629f8$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $d579544f31d629f8$var$G($d579544f31d629f8$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $d579544f31d629f8$var$G($d579544f31d629f8$var$M, $d579544f31d629f8$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $d579544f31d629f8$var$pj(a, b, c);
                $d579544f31d629f8$var$G($d579544f31d629f8$var$M, $d579544f31d629f8$var$M.current & 1);
                a = $d579544f31d629f8$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $d579544f31d629f8$var$G($d579544f31d629f8$var$M, $d579544f31d629f8$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $d579544f31d629f8$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $d579544f31d629f8$var$G($d579544f31d629f8$var$M, $d579544f31d629f8$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $d579544f31d629f8$var$ej(a, b, c);
    }
    return $d579544f31d629f8$var$$i(a, b, c);
}
var $d579544f31d629f8$var$Aj, $d579544f31d629f8$var$Bj, $d579544f31d629f8$var$Cj, $d579544f31d629f8$var$Dj;
$d579544f31d629f8$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$d579544f31d629f8$var$Bj = function Bj() {};
$d579544f31d629f8$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $d579544f31d629f8$var$Hh($d579544f31d629f8$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $d579544f31d629f8$var$Ya(a, e);
                d = $d579544f31d629f8$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $d579544f31d629f8$var$A({}, e, {
                    value: void 0
                });
                d = $d579544f31d629f8$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $d579544f31d629f8$var$gb(a, e);
                d = $d579544f31d629f8$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $d579544f31d629f8$var$Bf);
        }
        $d579544f31d629f8$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($d579544f31d629f8$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($d579544f31d629f8$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $d579544f31d629f8$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$d579544f31d629f8$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $d579544f31d629f8$var$Ej(a, b) {
    if (!$d579544f31d629f8$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $d579544f31d629f8$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $d579544f31d629f8$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $d579544f31d629f8$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $d579544f31d629f8$var$S(b), null;
        case 1:
            return $d579544f31d629f8$var$Zf(b.type) && $d579544f31d629f8$var$$f(), $d579544f31d629f8$var$S(b), null;
        case 3:
            d = b.stateNode;
            $d579544f31d629f8$var$Jh();
            $d579544f31d629f8$var$E($d579544f31d629f8$var$Wf);
            $d579544f31d629f8$var$E($d579544f31d629f8$var$H);
            $d579544f31d629f8$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $d579544f31d629f8$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $d579544f31d629f8$var$zg && ($d579544f31d629f8$var$Gj($d579544f31d629f8$var$zg), $d579544f31d629f8$var$zg = null));
            $d579544f31d629f8$var$Bj(a, b);
            $d579544f31d629f8$var$S(b);
            return null;
        case 5:
            $d579544f31d629f8$var$Lh(b);
            var e = $d579544f31d629f8$var$Hh($d579544f31d629f8$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $d579544f31d629f8$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($d579544f31d629f8$var$p(166));
                    $d579544f31d629f8$var$S(b);
                    return null;
                }
                a = $d579544f31d629f8$var$Hh($d579544f31d629f8$var$Eh.current);
                if ($d579544f31d629f8$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$d579544f31d629f8$var$Of] = b;
                    d[$d579544f31d629f8$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $d579544f31d629f8$var$D("cancel", d);
                            $d579544f31d629f8$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $d579544f31d629f8$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $d579544f31d629f8$var$lf.length; e++)$d579544f31d629f8$var$D($d579544f31d629f8$var$lf[e], d);
                            break;
                        case "source":
                            $d579544f31d629f8$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $d579544f31d629f8$var$D("error", d);
                            $d579544f31d629f8$var$D("load", d);
                            break;
                        case "details":
                            $d579544f31d629f8$var$D("toggle", d);
                            break;
                        case "input":
                            $d579544f31d629f8$var$Za(d, f);
                            $d579544f31d629f8$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $d579544f31d629f8$var$D("invalid", d);
                            break;
                        case "textarea":
                            $d579544f31d629f8$var$hb(d, f), $d579544f31d629f8$var$D("invalid", d);
                    }
                    $d579544f31d629f8$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $d579544f31d629f8$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $d579544f31d629f8$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $d579544f31d629f8$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $d579544f31d629f8$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $d579544f31d629f8$var$Va(d);
                            $d579544f31d629f8$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $d579544f31d629f8$var$Va(d);
                            $d579544f31d629f8$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $d579544f31d629f8$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $d579544f31d629f8$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$d579544f31d629f8$var$Of] = b;
                    a[$d579544f31d629f8$var$Pf] = d;
                    $d579544f31d629f8$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $d579544f31d629f8$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $d579544f31d629f8$var$D("cancel", a);
                                $d579544f31d629f8$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $d579544f31d629f8$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $d579544f31d629f8$var$lf.length; e++)$d579544f31d629f8$var$D($d579544f31d629f8$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $d579544f31d629f8$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $d579544f31d629f8$var$D("error", a);
                                $d579544f31d629f8$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $d579544f31d629f8$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $d579544f31d629f8$var$Za(a, d);
                                e = $d579544f31d629f8$var$Ya(a, d);
                                $d579544f31d629f8$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $d579544f31d629f8$var$A({}, d, {
                                    value: void 0
                                });
                                $d579544f31d629f8$var$D("invalid", a);
                                break;
                            case "textarea":
                                $d579544f31d629f8$var$hb(a, d);
                                e = $d579544f31d629f8$var$gb(a, d);
                                $d579544f31d629f8$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $d579544f31d629f8$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $d579544f31d629f8$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $d579544f31d629f8$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $d579544f31d629f8$var$ob(a, k) : "number" === typeof k && $d579544f31d629f8$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($d579544f31d629f8$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $d579544f31d629f8$var$D("scroll", a) : null != k && $d579544f31d629f8$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $d579544f31d629f8$var$Va(a);
                                $d579544f31d629f8$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $d579544f31d629f8$var$Va(a);
                                $d579544f31d629f8$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $d579544f31d629f8$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $d579544f31d629f8$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $d579544f31d629f8$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $d579544f31d629f8$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $d579544f31d629f8$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $d579544f31d629f8$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($d579544f31d629f8$var$p(166));
                c = $d579544f31d629f8$var$Hh($d579544f31d629f8$var$Gh.current);
                $d579544f31d629f8$var$Hh($d579544f31d629f8$var$Eh.current);
                if ($d579544f31d629f8$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$d579544f31d629f8$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $d579544f31d629f8$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $d579544f31d629f8$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $d579544f31d629f8$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$d579544f31d629f8$var$Of] = b, b.stateNode = d;
            }
            $d579544f31d629f8$var$S(b);
            return null;
        case 13:
            $d579544f31d629f8$var$E($d579544f31d629f8$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($d579544f31d629f8$var$I && null !== $d579544f31d629f8$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $d579544f31d629f8$var$Hg(), $d579544f31d629f8$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $d579544f31d629f8$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($d579544f31d629f8$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($d579544f31d629f8$var$p(317));
                        f[$d579544f31d629f8$var$Of] = b;
                    } else $d579544f31d629f8$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $d579544f31d629f8$var$S(b);
                    f = !1;
                } else null !== $d579544f31d629f8$var$zg && ($d579544f31d629f8$var$Gj($d579544f31d629f8$var$zg), $d579544f31d629f8$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($d579544f31d629f8$var$M.current & 1) ? 0 === $d579544f31d629f8$var$T && ($d579544f31d629f8$var$T = 3) : $d579544f31d629f8$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $d579544f31d629f8$var$S(b);
            return null;
        case 4:
            return $d579544f31d629f8$var$Jh(), $d579544f31d629f8$var$Bj(a, b), null === a && $d579544f31d629f8$var$sf(b.stateNode.containerInfo), $d579544f31d629f8$var$S(b), null;
        case 10:
            return $d579544f31d629f8$var$Rg(b.type._context), $d579544f31d629f8$var$S(b), null;
        case 17:
            return $d579544f31d629f8$var$Zf(b.type) && $d579544f31d629f8$var$$f(), $d579544f31d629f8$var$S(b), null;
        case 19:
            $d579544f31d629f8$var$E($d579544f31d629f8$var$M);
            f = b.memoizedState;
            if (null === f) return $d579544f31d629f8$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $d579544f31d629f8$var$Ej(f, !1);
                else {
                    if (0 !== $d579544f31d629f8$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $d579544f31d629f8$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $d579544f31d629f8$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $d579544f31d629f8$var$G($d579544f31d629f8$var$M, $d579544f31d629f8$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $d579544f31d629f8$var$B() > $d579544f31d629f8$var$Hj && (b.flags |= 128, d = !0, $d579544f31d629f8$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $d579544f31d629f8$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $d579544f31d629f8$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$d579544f31d629f8$var$I) return $d579544f31d629f8$var$S(b), null;
                    } else 2 * $d579544f31d629f8$var$B() - f.renderingStartTime > $d579544f31d629f8$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $d579544f31d629f8$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $d579544f31d629f8$var$B(), b.sibling = null, c = $d579544f31d629f8$var$M.current, $d579544f31d629f8$var$G($d579544f31d629f8$var$M, d ? c & 1 | 2 : c & 1), b;
            $d579544f31d629f8$var$S(b);
            return null;
        case 22:
        case 23:
            return $d579544f31d629f8$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($d579544f31d629f8$var$gj & 1073741824) && ($d579544f31d629f8$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $d579544f31d629f8$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($d579544f31d629f8$var$p(156, b.tag));
}
function $d579544f31d629f8$var$Jj(a, b) {
    $d579544f31d629f8$var$wg(b);
    switch(b.tag){
        case 1:
            return $d579544f31d629f8$var$Zf(b.type) && $d579544f31d629f8$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $d579544f31d629f8$var$Jh(), $d579544f31d629f8$var$E($d579544f31d629f8$var$Wf), $d579544f31d629f8$var$E($d579544f31d629f8$var$H), $d579544f31d629f8$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $d579544f31d629f8$var$Lh(b), null;
        case 13:
            $d579544f31d629f8$var$E($d579544f31d629f8$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($d579544f31d629f8$var$p(340));
                $d579544f31d629f8$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $d579544f31d629f8$var$E($d579544f31d629f8$var$M), null;
        case 4:
            return $d579544f31d629f8$var$Jh(), null;
        case 10:
            return $d579544f31d629f8$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $d579544f31d629f8$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $d579544f31d629f8$var$Kj = !1, $d579544f31d629f8$var$U = !1, $d579544f31d629f8$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $d579544f31d629f8$var$V = null;
function $d579544f31d629f8$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $d579544f31d629f8$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $d579544f31d629f8$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $d579544f31d629f8$var$W(a, b, d);
    }
}
var $d579544f31d629f8$var$Oj = !1;
function $d579544f31d629f8$var$Pj(a, b) {
    $d579544f31d629f8$var$Cf = $d579544f31d629f8$var$dd;
    a = $d579544f31d629f8$var$Me();
    if ($d579544f31d629f8$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $d579544f31d629f8$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $d579544f31d629f8$var$dd = !1;
    for($d579544f31d629f8$var$V = b; null !== $d579544f31d629f8$var$V;)if (b = $d579544f31d629f8$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $d579544f31d629f8$var$V = a;
    else for(; null !== $d579544f31d629f8$var$V;){
        b = $d579544f31d629f8$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $d579544f31d629f8$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($d579544f31d629f8$var$p(163));
            }
        } catch (F) {
            $d579544f31d629f8$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $d579544f31d629f8$var$V = a;
            break;
        }
        $d579544f31d629f8$var$V = b.return;
    }
    n = $d579544f31d629f8$var$Oj;
    $d579544f31d629f8$var$Oj = !1;
    return n;
}
function $d579544f31d629f8$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $d579544f31d629f8$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $d579544f31d629f8$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $d579544f31d629f8$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $d579544f31d629f8$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $d579544f31d629f8$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$d579544f31d629f8$var$Of], delete b[$d579544f31d629f8$var$Pf], delete b[$d579544f31d629f8$var$of], delete b[$d579544f31d629f8$var$Qf], delete b[$d579544f31d629f8$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $d579544f31d629f8$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $d579544f31d629f8$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $d579544f31d629f8$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $d579544f31d629f8$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $d579544f31d629f8$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($d579544f31d629f8$var$Wj(a, b, c), a = a.sibling; null !== a;)$d579544f31d629f8$var$Wj(a, b, c), a = a.sibling;
}
function $d579544f31d629f8$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($d579544f31d629f8$var$Xj(a, b, c), a = a.sibling; null !== a;)$d579544f31d629f8$var$Xj(a, b, c), a = a.sibling;
}
var $d579544f31d629f8$var$X = null, $d579544f31d629f8$var$Yj = !1;
function $d579544f31d629f8$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$d579544f31d629f8$var$ak(a, b, c), c = c.sibling;
}
function $d579544f31d629f8$var$ak(a, b, c) {
    if ($d579544f31d629f8$var$lc && "function" === typeof $d579544f31d629f8$var$lc.onCommitFiberUnmount) try {
        $d579544f31d629f8$var$lc.onCommitFiberUnmount($d579544f31d629f8$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $d579544f31d629f8$var$U || $d579544f31d629f8$var$Mj(c, b);
        case 6:
            var d = $d579544f31d629f8$var$X, e = $d579544f31d629f8$var$Yj;
            $d579544f31d629f8$var$X = null;
            $d579544f31d629f8$var$Zj(a, b, c);
            $d579544f31d629f8$var$X = d;
            $d579544f31d629f8$var$Yj = e;
            null !== $d579544f31d629f8$var$X && ($d579544f31d629f8$var$Yj ? (a = $d579544f31d629f8$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $d579544f31d629f8$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $d579544f31d629f8$var$X && ($d579544f31d629f8$var$Yj ? (a = $d579544f31d629f8$var$X, c = c.stateNode, 8 === a.nodeType ? $d579544f31d629f8$var$Kf(a.parentNode, c) : 1 === a.nodeType && $d579544f31d629f8$var$Kf(a, c), $d579544f31d629f8$var$bd(a)) : $d579544f31d629f8$var$Kf($d579544f31d629f8$var$X, c.stateNode));
            break;
        case 4:
            d = $d579544f31d629f8$var$X;
            e = $d579544f31d629f8$var$Yj;
            $d579544f31d629f8$var$X = c.stateNode.containerInfo;
            $d579544f31d629f8$var$Yj = !0;
            $d579544f31d629f8$var$Zj(a, b, c);
            $d579544f31d629f8$var$X = d;
            $d579544f31d629f8$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$d579544f31d629f8$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $d579544f31d629f8$var$Nj(c, b, g) : 0 !== (f & 4) && $d579544f31d629f8$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $d579544f31d629f8$var$Zj(a, b, c);
            break;
        case 1:
            if (!$d579544f31d629f8$var$U && ($d579544f31d629f8$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $d579544f31d629f8$var$W(c, b, h);
            }
            $d579544f31d629f8$var$Zj(a, b, c);
            break;
        case 21:
            $d579544f31d629f8$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($d579544f31d629f8$var$U = (d = $d579544f31d629f8$var$U) || null !== c.memoizedState, $d579544f31d629f8$var$Zj(a, b, c), $d579544f31d629f8$var$U = d) : $d579544f31d629f8$var$Zj(a, b, c);
            break;
        default:
            $d579544f31d629f8$var$Zj(a, b, c);
    }
}
function $d579544f31d629f8$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $d579544f31d629f8$var$Lj);
        b.forEach(function(b) {
            var d = $d579544f31d629f8$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $d579544f31d629f8$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $d579544f31d629f8$var$X = h.stateNode;
                        $d579544f31d629f8$var$Yj = !1;
                        break a;
                    case 3:
                        $d579544f31d629f8$var$X = h.stateNode.containerInfo;
                        $d579544f31d629f8$var$Yj = !0;
                        break a;
                    case 4:
                        $d579544f31d629f8$var$X = h.stateNode.containerInfo;
                        $d579544f31d629f8$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $d579544f31d629f8$var$X) throw Error($d579544f31d629f8$var$p(160));
            $d579544f31d629f8$var$ak(f, g, e);
            $d579544f31d629f8$var$X = null;
            $d579544f31d629f8$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $d579544f31d629f8$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$d579544f31d629f8$var$ek(b, a), b = b.sibling;
}
function $d579544f31d629f8$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $d579544f31d629f8$var$dk(b, a);
            $d579544f31d629f8$var$fk(a);
            if (d & 4) {
                try {
                    $d579544f31d629f8$var$Qj(3, a, a.return), $d579544f31d629f8$var$Rj(3, a);
                } catch (t) {
                    $d579544f31d629f8$var$W(a, a.return, t);
                }
                try {
                    $d579544f31d629f8$var$Qj(5, a, a.return);
                } catch (t) {
                    $d579544f31d629f8$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $d579544f31d629f8$var$dk(b, a);
            $d579544f31d629f8$var$fk(a);
            d & 512 && null !== c && $d579544f31d629f8$var$Mj(c, c.return);
            break;
        case 5:
            $d579544f31d629f8$var$dk(b, a);
            $d579544f31d629f8$var$fk(a);
            d & 512 && null !== c && $d579544f31d629f8$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $d579544f31d629f8$var$ob(e, "");
                } catch (t) {
                    $d579544f31d629f8$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $d579544f31d629f8$var$ab(e, f);
                    $d579544f31d629f8$var$vb(h, g);
                    var l = $d579544f31d629f8$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $d579544f31d629f8$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $d579544f31d629f8$var$nb(e, q) : "children" === m ? $d579544f31d629f8$var$ob(e, q) : $d579544f31d629f8$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $d579544f31d629f8$var$bb(e, f);
                            break;
                        case "textarea":
                            $d579544f31d629f8$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $d579544f31d629f8$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $d579544f31d629f8$var$fb(e, !!f.multiple, f.defaultValue, !0) : $d579544f31d629f8$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$d579544f31d629f8$var$Pf] = f;
                } catch (t) {
                    $d579544f31d629f8$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $d579544f31d629f8$var$dk(b, a);
            $d579544f31d629f8$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($d579544f31d629f8$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $d579544f31d629f8$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $d579544f31d629f8$var$dk(b, a);
            $d579544f31d629f8$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $d579544f31d629f8$var$bd(b.containerInfo);
            } catch (t) {
                $d579544f31d629f8$var$W(a, a.return, t);
            }
            break;
        case 4:
            $d579544f31d629f8$var$dk(b, a);
            $d579544f31d629f8$var$fk(a);
            break;
        case 13:
            $d579544f31d629f8$var$dk(b, a);
            $d579544f31d629f8$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($d579544f31d629f8$var$gk = $d579544f31d629f8$var$B()));
            d & 4 && $d579544f31d629f8$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($d579544f31d629f8$var$U = (l = $d579544f31d629f8$var$U) || m, $d579544f31d629f8$var$dk(b, a), $d579544f31d629f8$var$U = l) : $d579544f31d629f8$var$dk(b, a);
            $d579544f31d629f8$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($d579544f31d629f8$var$V = a, m = a.child; null !== m;){
                    for(q = $d579544f31d629f8$var$V = m; null !== $d579544f31d629f8$var$V;){
                        r = $d579544f31d629f8$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $d579544f31d629f8$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $d579544f31d629f8$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $d579544f31d629f8$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $d579544f31d629f8$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $d579544f31d629f8$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $d579544f31d629f8$var$V = y) : $d579544f31d629f8$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $d579544f31d629f8$var$rb("display", g));
                            } catch (t) {
                                $d579544f31d629f8$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $d579544f31d629f8$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $d579544f31d629f8$var$dk(b, a);
            $d579544f31d629f8$var$fk(a);
            d & 4 && $d579544f31d629f8$var$bk(a);
            break;
        case 21:
            break;
        default:
            $d579544f31d629f8$var$dk(b, a), $d579544f31d629f8$var$fk(a);
    }
}
function $d579544f31d629f8$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($d579544f31d629f8$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($d579544f31d629f8$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($d579544f31d629f8$var$ob(e, ""), d.flags &= -33);
                    var f = $d579544f31d629f8$var$Vj(a);
                    $d579544f31d629f8$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $d579544f31d629f8$var$Vj(a);
                    $d579544f31d629f8$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($d579544f31d629f8$var$p(161));
            }
        } catch (k) {
            $d579544f31d629f8$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $d579544f31d629f8$var$ik(a, b, c) {
    $d579544f31d629f8$var$V = a;
    $d579544f31d629f8$var$jk(a, b, c);
}
function $d579544f31d629f8$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $d579544f31d629f8$var$V;){
        var e = $d579544f31d629f8$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $d579544f31d629f8$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $d579544f31d629f8$var$U;
                h = $d579544f31d629f8$var$Kj;
                var l = $d579544f31d629f8$var$U;
                $d579544f31d629f8$var$Kj = g;
                if (($d579544f31d629f8$var$U = k) && !l) for($d579544f31d629f8$var$V = e; null !== $d579544f31d629f8$var$V;)g = $d579544f31d629f8$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $d579544f31d629f8$var$kk(e) : null !== k ? (k.return = g, $d579544f31d629f8$var$V = k) : $d579544f31d629f8$var$kk(e);
                for(; null !== f;)$d579544f31d629f8$var$V = f, $d579544f31d629f8$var$jk(f, b, c), f = f.sibling;
                $d579544f31d629f8$var$V = e;
                $d579544f31d629f8$var$Kj = h;
                $d579544f31d629f8$var$U = l;
            }
            $d579544f31d629f8$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $d579544f31d629f8$var$V = f) : $d579544f31d629f8$var$lk(a, b, c);
    }
}
function $d579544f31d629f8$var$lk(a) {
    for(; null !== $d579544f31d629f8$var$V;){
        var b = $d579544f31d629f8$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $d579544f31d629f8$var$U || $d579544f31d629f8$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$d579544f31d629f8$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $d579544f31d629f8$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $d579544f31d629f8$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $d579544f31d629f8$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $d579544f31d629f8$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($d579544f31d629f8$var$p(163));
                }
                $d579544f31d629f8$var$U || b.flags & 512 && $d579544f31d629f8$var$Sj(b);
            } catch (r) {
                $d579544f31d629f8$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $d579544f31d629f8$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $d579544f31d629f8$var$V = c;
            break;
        }
        $d579544f31d629f8$var$V = b.return;
    }
}
function $d579544f31d629f8$var$hk(a) {
    for(; null !== $d579544f31d629f8$var$V;){
        var b = $d579544f31d629f8$var$V;
        if (b === a) {
            $d579544f31d629f8$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $d579544f31d629f8$var$V = c;
            break;
        }
        $d579544f31d629f8$var$V = b.return;
    }
}
function $d579544f31d629f8$var$kk(a) {
    for(; null !== $d579544f31d629f8$var$V;){
        var b = $d579544f31d629f8$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $d579544f31d629f8$var$Rj(4, b);
                    } catch (k) {
                        $d579544f31d629f8$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $d579544f31d629f8$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $d579544f31d629f8$var$Sj(b);
                    } catch (k) {
                        $d579544f31d629f8$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $d579544f31d629f8$var$Sj(b);
                    } catch (k) {
                        $d579544f31d629f8$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $d579544f31d629f8$var$W(b, b.return, k);
        }
        if (b === a) {
            $d579544f31d629f8$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $d579544f31d629f8$var$V = h;
            break;
        }
        $d579544f31d629f8$var$V = b.return;
    }
}
var $d579544f31d629f8$var$mk = Math.ceil, $d579544f31d629f8$var$nk = $d579544f31d629f8$var$ua.ReactCurrentDispatcher, $d579544f31d629f8$var$ok = $d579544f31d629f8$var$ua.ReactCurrentOwner, $d579544f31d629f8$var$pk = $d579544f31d629f8$var$ua.ReactCurrentBatchConfig, $d579544f31d629f8$var$K = 0, $d579544f31d629f8$var$R = null, $d579544f31d629f8$var$Y = null, $d579544f31d629f8$var$Z = 0, $d579544f31d629f8$var$gj = 0, $d579544f31d629f8$var$fj = $d579544f31d629f8$var$Uf(0), $d579544f31d629f8$var$T = 0, $d579544f31d629f8$var$qk = null, $d579544f31d629f8$var$hh = 0, $d579544f31d629f8$var$rk = 0, $d579544f31d629f8$var$sk = 0, $d579544f31d629f8$var$tk = null, $d579544f31d629f8$var$uk = null, $d579544f31d629f8$var$gk = 0, $d579544f31d629f8$var$Hj = Infinity, $d579544f31d629f8$var$vk = null, $d579544f31d629f8$var$Pi = !1, $d579544f31d629f8$var$Qi = null, $d579544f31d629f8$var$Si = null, $d579544f31d629f8$var$wk = !1, $d579544f31d629f8$var$xk = null, $d579544f31d629f8$var$yk = 0, $d579544f31d629f8$var$zk = 0, $d579544f31d629f8$var$Ak = null, $d579544f31d629f8$var$Bk = -1, $d579544f31d629f8$var$Ck = 0;
function $d579544f31d629f8$var$L() {
    return 0 !== ($d579544f31d629f8$var$K & 6) ? $d579544f31d629f8$var$B() : -1 !== $d579544f31d629f8$var$Bk ? $d579544f31d629f8$var$Bk : $d579544f31d629f8$var$Bk = $d579544f31d629f8$var$B();
}
function $d579544f31d629f8$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($d579544f31d629f8$var$K & 2) && 0 !== $d579544f31d629f8$var$Z) return $d579544f31d629f8$var$Z & -$d579544f31d629f8$var$Z;
    if (null !== $d579544f31d629f8$var$Kg.transition) return 0 === $d579544f31d629f8$var$Ck && ($d579544f31d629f8$var$Ck = $d579544f31d629f8$var$yc()), $d579544f31d629f8$var$Ck;
    a = $d579544f31d629f8$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $d579544f31d629f8$var$jd(a.type);
    return a;
}
function $d579544f31d629f8$var$mh(a, b, c, d) {
    if (50 < $d579544f31d629f8$var$zk) throw $d579544f31d629f8$var$zk = 0, $d579544f31d629f8$var$Ak = null, Error($d579544f31d629f8$var$p(185));
    $d579544f31d629f8$var$Ac(a, c, d);
    if (0 === ($d579544f31d629f8$var$K & 2) || a !== $d579544f31d629f8$var$R) a === $d579544f31d629f8$var$R && (0 === ($d579544f31d629f8$var$K & 2) && ($d579544f31d629f8$var$rk |= c), 4 === $d579544f31d629f8$var$T && $d579544f31d629f8$var$Dk(a, $d579544f31d629f8$var$Z)), $d579544f31d629f8$var$Ek(a, d), 1 === c && 0 === $d579544f31d629f8$var$K && 0 === (b.mode & 1) && ($d579544f31d629f8$var$Hj = $d579544f31d629f8$var$B() + 500, $d579544f31d629f8$var$fg && $d579544f31d629f8$var$jg());
}
function $d579544f31d629f8$var$Ek(a, b) {
    var c = a.callbackNode;
    $d579544f31d629f8$var$wc(a, b);
    var d = $d579544f31d629f8$var$uc(a, a === $d579544f31d629f8$var$R ? $d579544f31d629f8$var$Z : 0);
    if (0 === d) null !== c && $d579544f31d629f8$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $d579544f31d629f8$var$bc(c);
        if (1 === b) 0 === a.tag ? $d579544f31d629f8$var$ig($d579544f31d629f8$var$Fk.bind(null, a)) : $d579544f31d629f8$var$hg($d579544f31d629f8$var$Fk.bind(null, a)), $d579544f31d629f8$var$Jf(function() {
            0 === ($d579544f31d629f8$var$K & 6) && $d579544f31d629f8$var$jg();
        }), c = null;
        else {
            switch($d579544f31d629f8$var$Dc(d)){
                case 1:
                    c = $d579544f31d629f8$var$fc;
                    break;
                case 4:
                    c = $d579544f31d629f8$var$gc;
                    break;
                case 16:
                    c = $d579544f31d629f8$var$hc;
                    break;
                case 536870912:
                    c = $d579544f31d629f8$var$jc;
                    break;
                default:
                    c = $d579544f31d629f8$var$hc;
            }
            c = $d579544f31d629f8$var$Gk(c, $d579544f31d629f8$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $d579544f31d629f8$var$Hk(a, b) {
    $d579544f31d629f8$var$Bk = -1;
    $d579544f31d629f8$var$Ck = 0;
    if (0 !== ($d579544f31d629f8$var$K & 6)) throw Error($d579544f31d629f8$var$p(327));
    var c = a.callbackNode;
    if ($d579544f31d629f8$var$Ik() && a.callbackNode !== c) return null;
    var d = $d579544f31d629f8$var$uc(a, a === $d579544f31d629f8$var$R ? $d579544f31d629f8$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $d579544f31d629f8$var$Jk(a, d);
    else {
        b = d;
        var e = $d579544f31d629f8$var$K;
        $d579544f31d629f8$var$K |= 2;
        var f = $d579544f31d629f8$var$Kk();
        if ($d579544f31d629f8$var$R !== a || $d579544f31d629f8$var$Z !== b) $d579544f31d629f8$var$vk = null, $d579544f31d629f8$var$Hj = $d579544f31d629f8$var$B() + 500, $d579544f31d629f8$var$Lk(a, b);
        for(;;)try {
            $d579544f31d629f8$var$Mk();
            break;
        } catch (h) {
            $d579544f31d629f8$var$Nk(a, h);
        }
        $d579544f31d629f8$var$Qg();
        $d579544f31d629f8$var$nk.current = f;
        $d579544f31d629f8$var$K = e;
        null !== $d579544f31d629f8$var$Y ? b = 0 : ($d579544f31d629f8$var$R = null, $d579544f31d629f8$var$Z = 0, b = $d579544f31d629f8$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $d579544f31d629f8$var$xc(a), 0 !== e && (d = e, b = $d579544f31d629f8$var$Ok(a, e)));
        if (1 === b) throw c = $d579544f31d629f8$var$qk, $d579544f31d629f8$var$Lk(a, 0), $d579544f31d629f8$var$Dk(a, d), $d579544f31d629f8$var$Ek(a, $d579544f31d629f8$var$B()), c;
        if (6 === b) $d579544f31d629f8$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$d579544f31d629f8$var$Pk(e) && (b = $d579544f31d629f8$var$Jk(a, d), 2 === b && (f = $d579544f31d629f8$var$xc(a), 0 !== f && (d = f, b = $d579544f31d629f8$var$Ok(a, f))), 1 === b)) throw c = $d579544f31d629f8$var$qk, $d579544f31d629f8$var$Lk(a, 0), $d579544f31d629f8$var$Dk(a, d), $d579544f31d629f8$var$Ek(a, $d579544f31d629f8$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($d579544f31d629f8$var$p(345));
                case 2:
                    $d579544f31d629f8$var$Qk(a, $d579544f31d629f8$var$uk, $d579544f31d629f8$var$vk);
                    break;
                case 3:
                    $d579544f31d629f8$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $d579544f31d629f8$var$gk + 500 - $d579544f31d629f8$var$B(), 10 < b)) {
                        if (0 !== $d579544f31d629f8$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $d579544f31d629f8$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $d579544f31d629f8$var$Ff($d579544f31d629f8$var$Qk.bind(null, a, $d579544f31d629f8$var$uk, $d579544f31d629f8$var$vk), b);
                        break;
                    }
                    $d579544f31d629f8$var$Qk(a, $d579544f31d629f8$var$uk, $d579544f31d629f8$var$vk);
                    break;
                case 4:
                    $d579544f31d629f8$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $d579544f31d629f8$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $d579544f31d629f8$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $d579544f31d629f8$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $d579544f31d629f8$var$Ff($d579544f31d629f8$var$Qk.bind(null, a, $d579544f31d629f8$var$uk, $d579544f31d629f8$var$vk), d);
                        break;
                    }
                    $d579544f31d629f8$var$Qk(a, $d579544f31d629f8$var$uk, $d579544f31d629f8$var$vk);
                    break;
                case 5:
                    $d579544f31d629f8$var$Qk(a, $d579544f31d629f8$var$uk, $d579544f31d629f8$var$vk);
                    break;
                default:
                    throw Error($d579544f31d629f8$var$p(329));
            }
        }
    }
    $d579544f31d629f8$var$Ek(a, $d579544f31d629f8$var$B());
    return a.callbackNode === c ? $d579544f31d629f8$var$Hk.bind(null, a) : null;
}
function $d579544f31d629f8$var$Ok(a, b) {
    var c = $d579544f31d629f8$var$tk;
    a.current.memoizedState.isDehydrated && ($d579544f31d629f8$var$Lk(a, b).flags |= 256);
    a = $d579544f31d629f8$var$Jk(a, b);
    2 !== a && (b = $d579544f31d629f8$var$uk, $d579544f31d629f8$var$uk = c, null !== b && $d579544f31d629f8$var$Gj(b));
    return a;
}
function $d579544f31d629f8$var$Gj(a) {
    null === $d579544f31d629f8$var$uk ? $d579544f31d629f8$var$uk = a : $d579544f31d629f8$var$uk.push.apply($d579544f31d629f8$var$uk, a);
}
function $d579544f31d629f8$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$d579544f31d629f8$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $d579544f31d629f8$var$Dk(a, b) {
    b &= ~$d579544f31d629f8$var$sk;
    b &= ~$d579544f31d629f8$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $d579544f31d629f8$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $d579544f31d629f8$var$Fk(a) {
    if (0 !== ($d579544f31d629f8$var$K & 6)) throw Error($d579544f31d629f8$var$p(327));
    $d579544f31d629f8$var$Ik();
    var b = $d579544f31d629f8$var$uc(a, 0);
    if (0 === (b & 1)) return $d579544f31d629f8$var$Ek(a, $d579544f31d629f8$var$B()), null;
    var c = $d579544f31d629f8$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $d579544f31d629f8$var$xc(a);
        0 !== d && (b = d, c = $d579544f31d629f8$var$Ok(a, d));
    }
    if (1 === c) throw c = $d579544f31d629f8$var$qk, $d579544f31d629f8$var$Lk(a, 0), $d579544f31d629f8$var$Dk(a, b), $d579544f31d629f8$var$Ek(a, $d579544f31d629f8$var$B()), c;
    if (6 === c) throw Error($d579544f31d629f8$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $d579544f31d629f8$var$Qk(a, $d579544f31d629f8$var$uk, $d579544f31d629f8$var$vk);
    $d579544f31d629f8$var$Ek(a, $d579544f31d629f8$var$B());
    return null;
}
function $d579544f31d629f8$var$Rk(a, b) {
    var c = $d579544f31d629f8$var$K;
    $d579544f31d629f8$var$K |= 1;
    try {
        return a(b);
    } finally{
        $d579544f31d629f8$var$K = c, 0 === $d579544f31d629f8$var$K && ($d579544f31d629f8$var$Hj = $d579544f31d629f8$var$B() + 500, $d579544f31d629f8$var$fg && $d579544f31d629f8$var$jg());
    }
}
function $d579544f31d629f8$var$Sk(a) {
    null !== $d579544f31d629f8$var$xk && 0 === $d579544f31d629f8$var$xk.tag && 0 === ($d579544f31d629f8$var$K & 6) && $d579544f31d629f8$var$Ik();
    var b = $d579544f31d629f8$var$K;
    $d579544f31d629f8$var$K |= 1;
    var c = $d579544f31d629f8$var$pk.transition, d = $d579544f31d629f8$var$C;
    try {
        if ($d579544f31d629f8$var$pk.transition = null, $d579544f31d629f8$var$C = 1, a) return a();
    } finally{
        $d579544f31d629f8$var$C = d, $d579544f31d629f8$var$pk.transition = c, $d579544f31d629f8$var$K = b, 0 === ($d579544f31d629f8$var$K & 6) && $d579544f31d629f8$var$jg();
    }
}
function $d579544f31d629f8$var$Ij() {
    $d579544f31d629f8$var$gj = $d579544f31d629f8$var$fj.current;
    $d579544f31d629f8$var$E($d579544f31d629f8$var$fj);
}
function $d579544f31d629f8$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $d579544f31d629f8$var$Gf(c));
    if (null !== $d579544f31d629f8$var$Y) for(c = $d579544f31d629f8$var$Y.return; null !== c;){
        var d = c;
        $d579544f31d629f8$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $d579544f31d629f8$var$$f();
                break;
            case 3:
                $d579544f31d629f8$var$Jh();
                $d579544f31d629f8$var$E($d579544f31d629f8$var$Wf);
                $d579544f31d629f8$var$E($d579544f31d629f8$var$H);
                $d579544f31d629f8$var$Oh();
                break;
            case 5:
                $d579544f31d629f8$var$Lh(d);
                break;
            case 4:
                $d579544f31d629f8$var$Jh();
                break;
            case 13:
                $d579544f31d629f8$var$E($d579544f31d629f8$var$M);
                break;
            case 19:
                $d579544f31d629f8$var$E($d579544f31d629f8$var$M);
                break;
            case 10:
                $d579544f31d629f8$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $d579544f31d629f8$var$Ij();
        }
        c = c.return;
    }
    $d579544f31d629f8$var$R = a;
    $d579544f31d629f8$var$Y = a = $d579544f31d629f8$var$wh(a.current, null);
    $d579544f31d629f8$var$Z = $d579544f31d629f8$var$gj = b;
    $d579544f31d629f8$var$T = 0;
    $d579544f31d629f8$var$qk = null;
    $d579544f31d629f8$var$sk = $d579544f31d629f8$var$rk = $d579544f31d629f8$var$hh = 0;
    $d579544f31d629f8$var$uk = $d579544f31d629f8$var$tk = null;
    if (null !== $d579544f31d629f8$var$Wg) {
        for(b = 0; b < $d579544f31d629f8$var$Wg.length; b++)if (c = $d579544f31d629f8$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $d579544f31d629f8$var$Wg = null;
    }
    return a;
}
function $d579544f31d629f8$var$Nk(a, b) {
    do {
        var c = $d579544f31d629f8$var$Y;
        try {
            $d579544f31d629f8$var$Qg();
            $d579544f31d629f8$var$Ph.current = $d579544f31d629f8$var$ai;
            if ($d579544f31d629f8$var$Sh) {
                for(var d = $d579544f31d629f8$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $d579544f31d629f8$var$Sh = !1;
            }
            $d579544f31d629f8$var$Rh = 0;
            $d579544f31d629f8$var$P = $d579544f31d629f8$var$O = $d579544f31d629f8$var$N = null;
            $d579544f31d629f8$var$Th = !1;
            $d579544f31d629f8$var$Uh = 0;
            $d579544f31d629f8$var$ok.current = null;
            if (null === c || null === c.return) {
                $d579544f31d629f8$var$T = 1;
                $d579544f31d629f8$var$qk = b;
                $d579544f31d629f8$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $d579544f31d629f8$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $d579544f31d629f8$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $d579544f31d629f8$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $d579544f31d629f8$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $d579544f31d629f8$var$Ti(f, l, b);
                            $d579544f31d629f8$var$uj();
                            break a;
                        }
                        k = Error($d579544f31d629f8$var$p(426));
                    }
                } else if ($d579544f31d629f8$var$I && h.mode & 1) {
                    var J = $d579544f31d629f8$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $d579544f31d629f8$var$Wi(J, g, h, f, b);
                        $d579544f31d629f8$var$Jg($d579544f31d629f8$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $d579544f31d629f8$var$Ki(k, h);
                4 !== $d579544f31d629f8$var$T && ($d579544f31d629f8$var$T = 2);
                null === $d579544f31d629f8$var$tk ? $d579544f31d629f8$var$tk = [
                    f
                ] : $d579544f31d629f8$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $d579544f31d629f8$var$Oi(f, k, b);
                            $d579544f31d629f8$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $d579544f31d629f8$var$Si || !$d579544f31d629f8$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $d579544f31d629f8$var$Ri(f, h, b);
                                $d579544f31d629f8$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $d579544f31d629f8$var$Tk(c);
        } catch (na) {
            b = na;
            $d579544f31d629f8$var$Y === c && null !== c && ($d579544f31d629f8$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $d579544f31d629f8$var$Kk() {
    var a = $d579544f31d629f8$var$nk.current;
    $d579544f31d629f8$var$nk.current = $d579544f31d629f8$var$ai;
    return null === a ? $d579544f31d629f8$var$ai : a;
}
function $d579544f31d629f8$var$uj() {
    if (0 === $d579544f31d629f8$var$T || 3 === $d579544f31d629f8$var$T || 2 === $d579544f31d629f8$var$T) $d579544f31d629f8$var$T = 4;
    null === $d579544f31d629f8$var$R || 0 === ($d579544f31d629f8$var$hh & 268435455) && 0 === ($d579544f31d629f8$var$rk & 268435455) || $d579544f31d629f8$var$Dk($d579544f31d629f8$var$R, $d579544f31d629f8$var$Z);
}
function $d579544f31d629f8$var$Jk(a, b) {
    var c = $d579544f31d629f8$var$K;
    $d579544f31d629f8$var$K |= 2;
    var d = $d579544f31d629f8$var$Kk();
    if ($d579544f31d629f8$var$R !== a || $d579544f31d629f8$var$Z !== b) $d579544f31d629f8$var$vk = null, $d579544f31d629f8$var$Lk(a, b);
    for(;;)try {
        $d579544f31d629f8$var$Uk();
        break;
    } catch (e) {
        $d579544f31d629f8$var$Nk(a, e);
    }
    $d579544f31d629f8$var$Qg();
    $d579544f31d629f8$var$K = c;
    $d579544f31d629f8$var$nk.current = d;
    if (null !== $d579544f31d629f8$var$Y) throw Error($d579544f31d629f8$var$p(261));
    $d579544f31d629f8$var$R = null;
    $d579544f31d629f8$var$Z = 0;
    return $d579544f31d629f8$var$T;
}
function $d579544f31d629f8$var$Uk() {
    for(; null !== $d579544f31d629f8$var$Y;)$d579544f31d629f8$var$Vk($d579544f31d629f8$var$Y);
}
function $d579544f31d629f8$var$Mk() {
    for(; null !== $d579544f31d629f8$var$Y && !$d579544f31d629f8$var$cc();)$d579544f31d629f8$var$Vk($d579544f31d629f8$var$Y);
}
function $d579544f31d629f8$var$Vk(a) {
    var b = $d579544f31d629f8$var$Wk(a.alternate, a, $d579544f31d629f8$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $d579544f31d629f8$var$Tk(a) : $d579544f31d629f8$var$Y = b;
    $d579544f31d629f8$var$ok.current = null;
}
function $d579544f31d629f8$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $d579544f31d629f8$var$Fj(c, b, $d579544f31d629f8$var$gj), null !== c) {
                $d579544f31d629f8$var$Y = c;
                return;
            }
        } else {
            c = $d579544f31d629f8$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $d579544f31d629f8$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $d579544f31d629f8$var$T = 6;
                $d579544f31d629f8$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $d579544f31d629f8$var$Y = b;
            return;
        }
        $d579544f31d629f8$var$Y = b = a;
    }while (null !== b);
    0 === $d579544f31d629f8$var$T && ($d579544f31d629f8$var$T = 5);
}
function $d579544f31d629f8$var$Qk(a, b, c) {
    var d = $d579544f31d629f8$var$C, e = $d579544f31d629f8$var$pk.transition;
    try {
        $d579544f31d629f8$var$pk.transition = null, $d579544f31d629f8$var$C = 1, $d579544f31d629f8$var$Xk(a, b, c, d);
    } finally{
        $d579544f31d629f8$var$pk.transition = e, $d579544f31d629f8$var$C = d;
    }
    return null;
}
function $d579544f31d629f8$var$Xk(a, b, c, d) {
    do $d579544f31d629f8$var$Ik();
    while (null !== $d579544f31d629f8$var$xk);
    if (0 !== ($d579544f31d629f8$var$K & 6)) throw Error($d579544f31d629f8$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($d579544f31d629f8$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $d579544f31d629f8$var$Bc(a, f);
    a === $d579544f31d629f8$var$R && ($d579544f31d629f8$var$Y = $d579544f31d629f8$var$R = null, $d579544f31d629f8$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $d579544f31d629f8$var$wk || ($d579544f31d629f8$var$wk = !0, $d579544f31d629f8$var$Gk($d579544f31d629f8$var$hc, function() {
        $d579544f31d629f8$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $d579544f31d629f8$var$pk.transition;
        $d579544f31d629f8$var$pk.transition = null;
        var g = $d579544f31d629f8$var$C;
        $d579544f31d629f8$var$C = 1;
        var h = $d579544f31d629f8$var$K;
        $d579544f31d629f8$var$K |= 4;
        $d579544f31d629f8$var$ok.current = null;
        $d579544f31d629f8$var$Pj(a, c);
        $d579544f31d629f8$var$ek(c, a);
        $d579544f31d629f8$var$Oe($d579544f31d629f8$var$Df);
        $d579544f31d629f8$var$dd = !!$d579544f31d629f8$var$Cf;
        $d579544f31d629f8$var$Df = $d579544f31d629f8$var$Cf = null;
        a.current = c;
        $d579544f31d629f8$var$ik(c, a, e);
        $d579544f31d629f8$var$dc();
        $d579544f31d629f8$var$K = h;
        $d579544f31d629f8$var$C = g;
        $d579544f31d629f8$var$pk.transition = f;
    } else a.current = c;
    $d579544f31d629f8$var$wk && ($d579544f31d629f8$var$wk = !1, $d579544f31d629f8$var$xk = a, $d579544f31d629f8$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($d579544f31d629f8$var$Si = null);
    $d579544f31d629f8$var$mc(c.stateNode, d);
    $d579544f31d629f8$var$Ek(a, $d579544f31d629f8$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($d579544f31d629f8$var$Pi) throw $d579544f31d629f8$var$Pi = !1, a = $d579544f31d629f8$var$Qi, $d579544f31d629f8$var$Qi = null, a;
    0 !== ($d579544f31d629f8$var$yk & 1) && 0 !== a.tag && $d579544f31d629f8$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $d579544f31d629f8$var$Ak ? $d579544f31d629f8$var$zk++ : ($d579544f31d629f8$var$zk = 0, $d579544f31d629f8$var$Ak = a) : $d579544f31d629f8$var$zk = 0;
    $d579544f31d629f8$var$jg();
    return null;
}
function $d579544f31d629f8$var$Ik() {
    if (null !== $d579544f31d629f8$var$xk) {
        var a = $d579544f31d629f8$var$Dc($d579544f31d629f8$var$yk), b = $d579544f31d629f8$var$pk.transition, c = $d579544f31d629f8$var$C;
        try {
            $d579544f31d629f8$var$pk.transition = null;
            $d579544f31d629f8$var$C = 16 > a ? 16 : a;
            if (null === $d579544f31d629f8$var$xk) var d = !1;
            else {
                a = $d579544f31d629f8$var$xk;
                $d579544f31d629f8$var$xk = null;
                $d579544f31d629f8$var$yk = 0;
                if (0 !== ($d579544f31d629f8$var$K & 6)) throw Error($d579544f31d629f8$var$p(331));
                var e = $d579544f31d629f8$var$K;
                $d579544f31d629f8$var$K |= 4;
                for($d579544f31d629f8$var$V = a.current; null !== $d579544f31d629f8$var$V;){
                    var f = $d579544f31d629f8$var$V, g = f.child;
                    if (0 !== ($d579544f31d629f8$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($d579544f31d629f8$var$V = l; null !== $d579544f31d629f8$var$V;){
                                    var m = $d579544f31d629f8$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $d579544f31d629f8$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $d579544f31d629f8$var$V = q;
                                    else for(; null !== $d579544f31d629f8$var$V;){
                                        m = $d579544f31d629f8$var$V;
                                        var r = m.sibling, y = m.return;
                                        $d579544f31d629f8$var$Tj(m);
                                        if (m === l) {
                                            $d579544f31d629f8$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $d579544f31d629f8$var$V = r;
                                            break;
                                        }
                                        $d579544f31d629f8$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $d579544f31d629f8$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $d579544f31d629f8$var$V = g;
                    else b: for(; null !== $d579544f31d629f8$var$V;){
                        f = $d579544f31d629f8$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $d579544f31d629f8$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $d579544f31d629f8$var$V = x;
                            break b;
                        }
                        $d579544f31d629f8$var$V = f.return;
                    }
                }
                var w = a.current;
                for($d579544f31d629f8$var$V = w; null !== $d579544f31d629f8$var$V;){
                    g = $d579544f31d629f8$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $d579544f31d629f8$var$V = u;
                    else b: for(g = w; null !== $d579544f31d629f8$var$V;){
                        h = $d579544f31d629f8$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $d579544f31d629f8$var$Rj(9, h);
                            }
                        } catch (na) {
                            $d579544f31d629f8$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $d579544f31d629f8$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $d579544f31d629f8$var$V = F;
                            break b;
                        }
                        $d579544f31d629f8$var$V = h.return;
                    }
                }
                $d579544f31d629f8$var$K = e;
                $d579544f31d629f8$var$jg();
                if ($d579544f31d629f8$var$lc && "function" === typeof $d579544f31d629f8$var$lc.onPostCommitFiberRoot) try {
                    $d579544f31d629f8$var$lc.onPostCommitFiberRoot($d579544f31d629f8$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $d579544f31d629f8$var$C = c, $d579544f31d629f8$var$pk.transition = b;
        }
    }
    return !1;
}
function $d579544f31d629f8$var$Yk(a, b, c) {
    b = $d579544f31d629f8$var$Ki(c, b);
    b = $d579544f31d629f8$var$Oi(a, b, 1);
    a = $d579544f31d629f8$var$dh(a, b, 1);
    b = $d579544f31d629f8$var$L();
    null !== a && ($d579544f31d629f8$var$Ac(a, 1, b), $d579544f31d629f8$var$Ek(a, b));
}
function $d579544f31d629f8$var$W(a, b, c) {
    if (3 === a.tag) $d579544f31d629f8$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $d579544f31d629f8$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $d579544f31d629f8$var$Si || !$d579544f31d629f8$var$Si.has(d))) {
                a = $d579544f31d629f8$var$Ki(c, a);
                a = $d579544f31d629f8$var$Ri(b, a, 1);
                b = $d579544f31d629f8$var$dh(b, a, 1);
                a = $d579544f31d629f8$var$L();
                null !== b && ($d579544f31d629f8$var$Ac(b, 1, a), $d579544f31d629f8$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $d579544f31d629f8$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $d579544f31d629f8$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $d579544f31d629f8$var$R === a && ($d579544f31d629f8$var$Z & c) === c && (4 === $d579544f31d629f8$var$T || 3 === $d579544f31d629f8$var$T && ($d579544f31d629f8$var$Z & 130023424) === $d579544f31d629f8$var$Z && 500 > $d579544f31d629f8$var$B() - $d579544f31d629f8$var$gk ? $d579544f31d629f8$var$Lk(a, 0) : $d579544f31d629f8$var$sk |= c);
    $d579544f31d629f8$var$Ek(a, b);
}
function $d579544f31d629f8$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $d579544f31d629f8$var$sc, $d579544f31d629f8$var$sc <<= 1, 0 === ($d579544f31d629f8$var$sc & 130023424) && ($d579544f31d629f8$var$sc = 4194304)));
    var c = $d579544f31d629f8$var$L();
    a = $d579544f31d629f8$var$Zg(a, b);
    null !== a && ($d579544f31d629f8$var$Ac(a, b, c), $d579544f31d629f8$var$Ek(a, c));
}
function $d579544f31d629f8$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $d579544f31d629f8$var$Zk(a, c);
}
function $d579544f31d629f8$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($d579544f31d629f8$var$p(314));
    }
    null !== d && d.delete(b);
    $d579544f31d629f8$var$Zk(a, c);
}
var $d579544f31d629f8$var$Wk;
$d579544f31d629f8$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $d579544f31d629f8$var$Wf.current) $d579544f31d629f8$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $d579544f31d629f8$var$Ug = !1, $d579544f31d629f8$var$zj(a, b, c);
            $d579544f31d629f8$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $d579544f31d629f8$var$Ug = !1, $d579544f31d629f8$var$I && 0 !== (b.flags & 1048576) && $d579544f31d629f8$var$ug(b, $d579544f31d629f8$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $d579544f31d629f8$var$jj(a, b);
            a = b.pendingProps;
            var e = $d579544f31d629f8$var$Yf(b, $d579544f31d629f8$var$H.current);
            $d579544f31d629f8$var$Tg(b, c);
            e = $d579544f31d629f8$var$Xh(null, b, d, a, e, c);
            var f = $d579544f31d629f8$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $d579544f31d629f8$var$Zf(d) ? (f = !0, $d579544f31d629f8$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $d579544f31d629f8$var$ah(b), e.updater = $d579544f31d629f8$var$nh, b.stateNode = e, e._reactInternals = b, $d579544f31d629f8$var$rh(b, d, a, c), b = $d579544f31d629f8$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $d579544f31d629f8$var$I && f && $d579544f31d629f8$var$vg(b), $d579544f31d629f8$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $d579544f31d629f8$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $d579544f31d629f8$var$$k(d);
                a = $d579544f31d629f8$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $d579544f31d629f8$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $d579544f31d629f8$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $d579544f31d629f8$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $d579544f31d629f8$var$aj(null, b, d, $d579544f31d629f8$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($d579544f31d629f8$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d579544f31d629f8$var$Lg(d, e), $d579544f31d629f8$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d579544f31d629f8$var$Lg(d, e), $d579544f31d629f8$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $d579544f31d629f8$var$lj(b);
                if (null === a) throw Error($d579544f31d629f8$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $d579544f31d629f8$var$bh(a, b);
                $d579544f31d629f8$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $d579544f31d629f8$var$Ki(Error($d579544f31d629f8$var$p(423)), b);
                        b = $d579544f31d629f8$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $d579544f31d629f8$var$Ki(Error($d579544f31d629f8$var$p(424)), b);
                        b = $d579544f31d629f8$var$mj(a, b, d, c, e);
                        break a;
                    } else for($d579544f31d629f8$var$yg = $d579544f31d629f8$var$Lf(b.stateNode.containerInfo.firstChild), $d579544f31d629f8$var$xg = b, $d579544f31d629f8$var$I = !0, $d579544f31d629f8$var$zg = null, c = $d579544f31d629f8$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $d579544f31d629f8$var$Ig();
                    if (d === e) {
                        b = $d579544f31d629f8$var$$i(a, b, c);
                        break a;
                    }
                    $d579544f31d629f8$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $d579544f31d629f8$var$Kh(b), null === a && $d579544f31d629f8$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $d579544f31d629f8$var$Ef(d, e) ? g = null : null !== f && $d579544f31d629f8$var$Ef(d, f) && (b.flags |= 32), $d579544f31d629f8$var$hj(a, b), $d579544f31d629f8$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $d579544f31d629f8$var$Eg(b), null;
        case 13:
            return $d579544f31d629f8$var$pj(a, b, c);
        case 4:
            return $d579544f31d629f8$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $d579544f31d629f8$var$Bh(b, null, d, c) : $d579544f31d629f8$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d579544f31d629f8$var$Lg(d, e), $d579544f31d629f8$var$Zi(a, b, d, e, c);
        case 7:
            return $d579544f31d629f8$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $d579544f31d629f8$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $d579544f31d629f8$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $d579544f31d629f8$var$G($d579544f31d629f8$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($d579544f31d629f8$var$He(f.value, g)) {
                        if (f.children === e.children && !$d579544f31d629f8$var$Wf.current) {
                            b = $d579544f31d629f8$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $d579544f31d629f8$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $d579544f31d629f8$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($d579544f31d629f8$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $d579544f31d629f8$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $d579544f31d629f8$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $d579544f31d629f8$var$Tg(b, c), e = $d579544f31d629f8$var$Vg(e), d = d(e), b.flags |= 1, $d579544f31d629f8$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $d579544f31d629f8$var$Lg(d, b.pendingProps), e = $d579544f31d629f8$var$Lg(d.type, e), $d579544f31d629f8$var$aj(a, b, d, e, c);
        case 15:
            return $d579544f31d629f8$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d579544f31d629f8$var$Lg(d, e), $d579544f31d629f8$var$jj(a, b), b.tag = 1, $d579544f31d629f8$var$Zf(d) ? (a = !0, $d579544f31d629f8$var$cg(b)) : a = !1, $d579544f31d629f8$var$Tg(b, c), $d579544f31d629f8$var$ph(b, d, e), $d579544f31d629f8$var$rh(b, d, e, c), $d579544f31d629f8$var$kj(null, b, d, !0, a, c);
        case 19:
            return $d579544f31d629f8$var$yj(a, b, c);
        case 22:
            return $d579544f31d629f8$var$ej(a, b, c);
    }
    throw Error($d579544f31d629f8$var$p(156, b.tag));
};
function $d579544f31d629f8$var$Gk(a, b) {
    return $d579544f31d629f8$var$ac(a, b);
}
function $d579544f31d629f8$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $d579544f31d629f8$var$Bg(a, b, c, d) {
    return new $d579544f31d629f8$var$al(a, b, c, d);
}
function $d579544f31d629f8$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $d579544f31d629f8$var$$k(a) {
    if ("function" === typeof a) return $d579544f31d629f8$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $d579544f31d629f8$var$Da) return 11;
        if (a === $d579544f31d629f8$var$Ga) return 14;
    }
    return 2;
}
function $d579544f31d629f8$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $d579544f31d629f8$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $d579544f31d629f8$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $d579544f31d629f8$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $d579544f31d629f8$var$ya:
            return $d579544f31d629f8$var$Ah(c.children, e, f, b);
        case $d579544f31d629f8$var$za:
            g = 8;
            e |= 8;
            break;
        case $d579544f31d629f8$var$Aa:
            return a = $d579544f31d629f8$var$Bg(12, c, b, e | 2), a.elementType = $d579544f31d629f8$var$Aa, a.lanes = f, a;
        case $d579544f31d629f8$var$Ea:
            return a = $d579544f31d629f8$var$Bg(13, c, b, e), a.elementType = $d579544f31d629f8$var$Ea, a.lanes = f, a;
        case $d579544f31d629f8$var$Fa:
            return a = $d579544f31d629f8$var$Bg(19, c, b, e), a.elementType = $d579544f31d629f8$var$Fa, a.lanes = f, a;
        case $d579544f31d629f8$var$Ia:
            return $d579544f31d629f8$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $d579544f31d629f8$var$Ba:
                    g = 10;
                    break a;
                case $d579544f31d629f8$var$Ca:
                    g = 9;
                    break a;
                case $d579544f31d629f8$var$Da:
                    g = 11;
                    break a;
                case $d579544f31d629f8$var$Ga:
                    g = 14;
                    break a;
                case $d579544f31d629f8$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($d579544f31d629f8$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $7fjaO._)(a), ""));
    }
    b = $d579544f31d629f8$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $d579544f31d629f8$var$Ah(a, b, c, d) {
    a = $d579544f31d629f8$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $d579544f31d629f8$var$qj(a, b, c, d) {
    a = $d579544f31d629f8$var$Bg(22, a, d, b);
    a.elementType = $d579544f31d629f8$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $d579544f31d629f8$var$xh(a, b, c) {
    a = $d579544f31d629f8$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $d579544f31d629f8$var$zh(a, b, c) {
    b = $d579544f31d629f8$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $d579544f31d629f8$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $d579544f31d629f8$var$zc(0);
    this.expirationTimes = $d579544f31d629f8$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $d579544f31d629f8$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $d579544f31d629f8$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $d579544f31d629f8$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $d579544f31d629f8$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $d579544f31d629f8$var$ah(f);
    return a;
}
function $d579544f31d629f8$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $d579544f31d629f8$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $d579544f31d629f8$var$el(a) {
    if (!a) return $d579544f31d629f8$var$Vf;
    a = a._reactInternals;
    a: {
        if ($d579544f31d629f8$var$Vb(a) !== a || 1 !== a.tag) throw Error($d579544f31d629f8$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($d579544f31d629f8$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($d579544f31d629f8$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($d579544f31d629f8$var$Zf(c)) return $d579544f31d629f8$var$bg(a, c, b);
    }
    return b;
}
function $d579544f31d629f8$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $d579544f31d629f8$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $d579544f31d629f8$var$el(null);
    c = a.current;
    d = $d579544f31d629f8$var$L();
    e = $d579544f31d629f8$var$lh(c);
    f = $d579544f31d629f8$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $d579544f31d629f8$var$dh(c, f, e);
    a.current.lanes = e;
    $d579544f31d629f8$var$Ac(a, e, d);
    $d579544f31d629f8$var$Ek(a, d);
    return a;
}
function $d579544f31d629f8$var$gl(a, b, c, d) {
    var e = b.current, f = $d579544f31d629f8$var$L(), g = $d579544f31d629f8$var$lh(e);
    c = $d579544f31d629f8$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $d579544f31d629f8$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $d579544f31d629f8$var$dh(e, b, g);
    null !== a && ($d579544f31d629f8$var$mh(a, e, g, f), $d579544f31d629f8$var$eh(a, e, g));
    return g;
}
function $d579544f31d629f8$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $d579544f31d629f8$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $d579544f31d629f8$var$jl(a, b) {
    $d579544f31d629f8$var$il(a, b);
    (a = a.alternate) && $d579544f31d629f8$var$il(a, b);
}
function $d579544f31d629f8$var$kl() {
    return null;
}
var $d579544f31d629f8$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $d579544f31d629f8$var$ml(a) {
    this._internalRoot = a;
}
$d579544f31d629f8$var$nl.prototype.render = $d579544f31d629f8$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($d579544f31d629f8$var$p(409));
    $d579544f31d629f8$var$gl(a, b, null, null);
};
$d579544f31d629f8$var$nl.prototype.unmount = $d579544f31d629f8$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $d579544f31d629f8$var$Sk(function() {
            $d579544f31d629f8$var$gl(null, a, null, null);
        });
        b[$d579544f31d629f8$var$uf] = null;
    }
};
function $d579544f31d629f8$var$nl(a) {
    this._internalRoot = a;
}
$d579544f31d629f8$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $d579544f31d629f8$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $d579544f31d629f8$var$Qc.length && 0 !== b && b < $d579544f31d629f8$var$Qc[c].priority; c++);
        $d579544f31d629f8$var$Qc.splice(c, 0, a);
        0 === c && $d579544f31d629f8$var$Vc(a);
    }
};
function $d579544f31d629f8$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $d579544f31d629f8$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $d579544f31d629f8$var$ql() {}
function $d579544f31d629f8$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $d579544f31d629f8$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $d579544f31d629f8$var$fl(b, d, a, 0, null, !1, !1, "", $d579544f31d629f8$var$ql);
        a._reactRootContainer = g;
        a[$d579544f31d629f8$var$uf] = g.current;
        $d579544f31d629f8$var$sf(8 === a.nodeType ? a.parentNode : a);
        $d579544f31d629f8$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $d579544f31d629f8$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $d579544f31d629f8$var$cl(a, 0, !1, null, null, !1, !1, "", $d579544f31d629f8$var$ql);
    a._reactRootContainer = k;
    a[$d579544f31d629f8$var$uf] = k.current;
    $d579544f31d629f8$var$sf(8 === a.nodeType ? a.parentNode : a);
    $d579544f31d629f8$var$Sk(function() {
        $d579544f31d629f8$var$gl(b, k, c, d);
    });
    return k;
}
function $d579544f31d629f8$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $d579544f31d629f8$var$hl(g);
                h.call(_$a);
            };
        }
        $d579544f31d629f8$var$gl(b, g, a, e);
    } else g = $d579544f31d629f8$var$rl(c, b, a, e, d);
    return $d579544f31d629f8$var$hl(g);
}
$d579544f31d629f8$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $d579544f31d629f8$var$tc(b.pendingLanes);
                0 !== c && ($d579544f31d629f8$var$Cc(b, c | 1), $d579544f31d629f8$var$Ek(b, $d579544f31d629f8$var$B()), 0 === ($d579544f31d629f8$var$K & 6) && ($d579544f31d629f8$var$Hj = $d579544f31d629f8$var$B() + 500, $d579544f31d629f8$var$jg()));
            }
            break;
        case 13:
            $d579544f31d629f8$var$Sk(function() {
                var b = $d579544f31d629f8$var$Zg(a, 1);
                if (null !== b) {
                    var c = $d579544f31d629f8$var$L();
                    $d579544f31d629f8$var$mh(b, a, 1, c);
                }
            }), $d579544f31d629f8$var$jl(a, 1);
    }
};
$d579544f31d629f8$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $d579544f31d629f8$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $d579544f31d629f8$var$L();
            $d579544f31d629f8$var$mh(b, a, 134217728, c);
        }
        $d579544f31d629f8$var$jl(a, 134217728);
    }
};
$d579544f31d629f8$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $d579544f31d629f8$var$lh(a), c = $d579544f31d629f8$var$Zg(a, b);
        if (null !== c) {
            var d = $d579544f31d629f8$var$L();
            $d579544f31d629f8$var$mh(c, a, b, d);
        }
        $d579544f31d629f8$var$jl(a, b);
    }
};
$d579544f31d629f8$var$Hc = function Hc() {
    return $d579544f31d629f8$var$C;
};
$d579544f31d629f8$var$Ic = function Ic(a, b) {
    var c = $d579544f31d629f8$var$C;
    try {
        return $d579544f31d629f8$var$C = a, b();
    } finally{
        $d579544f31d629f8$var$C = c;
    }
};
$d579544f31d629f8$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $d579544f31d629f8$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $d579544f31d629f8$var$Db(d);
                        if (!e) throw Error($d579544f31d629f8$var$p(90));
                        $d579544f31d629f8$var$Wa(d);
                        $d579544f31d629f8$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $d579544f31d629f8$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $d579544f31d629f8$var$fb(a, !!c.multiple, b, !1);
    }
};
$d579544f31d629f8$var$Gb = $d579544f31d629f8$var$Rk;
$d579544f31d629f8$var$Hb = $d579544f31d629f8$var$Sk;
var $d579544f31d629f8$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $d579544f31d629f8$var$Cb,
        $d579544f31d629f8$var$ue,
        $d579544f31d629f8$var$Db,
        $d579544f31d629f8$var$Eb,
        $d579544f31d629f8$var$Fb,
        $d579544f31d629f8$var$Rk
    ]
}, $d579544f31d629f8$var$ul = {
    findFiberByHostInstance: $d579544f31d629f8$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $d579544f31d629f8$var$vl = {
    bundleType: $d579544f31d629f8$var$ul.bundleType,
    version: $d579544f31d629f8$var$ul.version,
    rendererPackageName: $d579544f31d629f8$var$ul.rendererPackageName,
    rendererConfig: $d579544f31d629f8$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $d579544f31d629f8$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $d579544f31d629f8$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $d579544f31d629f8$var$ul.findFiberByHostInstance || $d579544f31d629f8$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $d579544f31d629f8$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$d579544f31d629f8$var$wl.isDisabled && $d579544f31d629f8$var$wl.supportsFiber) try {
        $d579544f31d629f8$var$kc = $d579544f31d629f8$var$wl.inject($d579544f31d629f8$var$vl), $d579544f31d629f8$var$lc = $d579544f31d629f8$var$wl;
    } catch (a) {}
}
$d579544f31d629f8$export$ae55be85d98224ed = $d579544f31d629f8$var$tl;
$d579544f31d629f8$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$d579544f31d629f8$var$ol(b)) throw Error($d579544f31d629f8$var$p(200));
    return $d579544f31d629f8$var$dl(a, b, null, c);
};
$d579544f31d629f8$export$882461b6382ed46c = function(a, b) {
    if (!$d579544f31d629f8$var$ol(a)) throw Error($d579544f31d629f8$var$p(299));
    var c = !1, d = "", e = $d579544f31d629f8$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $d579544f31d629f8$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$d579544f31d629f8$var$uf] = b.current;
    $d579544f31d629f8$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $d579544f31d629f8$var$ml(b);
};
$d579544f31d629f8$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($d579544f31d629f8$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($d579544f31d629f8$var$p(268, a));
    }
    a = $d579544f31d629f8$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$d579544f31d629f8$export$cd75ccfd720a3cd4 = function(a) {
    return $d579544f31d629f8$var$Sk(a);
};
$d579544f31d629f8$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$d579544f31d629f8$var$pl(b)) throw Error($d579544f31d629f8$var$p(200));
    return $d579544f31d629f8$var$sl(null, a, b, !0, c);
};
$d579544f31d629f8$export$757ceba2d55c277e = function(a, b, c) {
    if (!$d579544f31d629f8$var$ol(a)) throw Error($d579544f31d629f8$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $d579544f31d629f8$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $d579544f31d629f8$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$d579544f31d629f8$var$uf] = b.current;
    $d579544f31d629f8$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $d579544f31d629f8$var$nl(b);
};
$d579544f31d629f8$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$d579544f31d629f8$var$pl(b)) throw Error($d579544f31d629f8$var$p(200));
    return $d579544f31d629f8$var$sl(null, a, b, !1, c);
};
$d579544f31d629f8$export$502457920280e6be = function(a) {
    if (!$d579544f31d629f8$var$pl(a)) throw Error($d579544f31d629f8$var$p(40));
    return a._reactRootContainer ? ($d579544f31d629f8$var$Sk(function() {
        $d579544f31d629f8$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$d579544f31d629f8$var$uf] = null;
        });
    }), !0) : !1;
};
$d579544f31d629f8$export$c78a37762a8d58e1 = $d579544f31d629f8$var$Rk;
$d579544f31d629f8$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$d579544f31d629f8$var$pl(c)) throw Error($d579544f31d629f8$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($d579544f31d629f8$var$p(38));
    return $d579544f31d629f8$var$sl(a, b, c, !1, d);
};
$d579544f31d629f8$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("8wlpD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8JhO5"));

});
parcelRegister("8JhO5", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $65b056c867d770c7$export$c4744153514ff05d; }, function (v) { return $65b056c867d770c7$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $65b056c867d770c7$export$3e506c1ccc9cc1a7; }, function (v) { return $65b056c867d770c7$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $65b056c867d770c7$export$e26fe2ed2fa76875; }, function (v) { return $65b056c867d770c7$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $65b056c867d770c7$export$502329bbf4b505b1; }, function (v) { return $65b056c867d770c7$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $65b056c867d770c7$export$6e3807111c4874c4; }, function (v) { return $65b056c867d770c7$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $65b056c867d770c7$export$c27134553091fb3a; }, function (v) { return $65b056c867d770c7$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $65b056c867d770c7$export$33ee1acdc04fd2a2; }, function (v) { return $65b056c867d770c7$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $65b056c867d770c7$export$b00a404bbd5edef2; }, function (v) { return $65b056c867d770c7$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $65b056c867d770c7$export$8352ce38b91d0c62; }, function (v) { return $65b056c867d770c7$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $65b056c867d770c7$export$d66a1c1c77bd778b; }, function (v) { return $65b056c867d770c7$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $65b056c867d770c7$export$d3dfb8e4810cb555; }, function (v) { return $65b056c867d770c7$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $65b056c867d770c7$export$839f9183b0465a69; }, function (v) { return $65b056c867d770c7$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $65b056c867d770c7$export$72fdf0e06517287b; }, function (v) { return $65b056c867d770c7$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $65b056c867d770c7$export$4b844e58a3e414b4; }, function (v) { return $65b056c867d770c7$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $65b056c867d770c7$export$816d2913ae6b83b1; }, function (v) { return $65b056c867d770c7$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $65b056c867d770c7$export$61bcfe829111a1d0; }, function (v) { return $65b056c867d770c7$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $65b056c867d770c7$export$7ee8c9beb337bc3f; }, function (v) { return $65b056c867d770c7$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $65b056c867d770c7$export$b5836b71941fa3ed; }, function (v) { return $65b056c867d770c7$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $65b056c867d770c7$export$cf845f2c119da08a; }, function (v) { return $65b056c867d770c7$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $65b056c867d770c7$export$c4744153514ff05d;
var $65b056c867d770c7$export$3e506c1ccc9cc1a7;
var $65b056c867d770c7$export$e26fe2ed2fa76875;
var $65b056c867d770c7$export$502329bbf4b505b1;
var $65b056c867d770c7$export$6e3807111c4874c4;
var $65b056c867d770c7$export$c27134553091fb3a;
var $65b056c867d770c7$export$33ee1acdc04fd2a2;
var $65b056c867d770c7$export$b00a404bbd5edef2;
var $65b056c867d770c7$export$8352ce38b91d0c62;
var $65b056c867d770c7$export$d66a1c1c77bd778b;
var $65b056c867d770c7$export$d3dfb8e4810cb555;
var $65b056c867d770c7$export$839f9183b0465a69;
var $65b056c867d770c7$export$72fdf0e06517287b;
var $65b056c867d770c7$export$4b844e58a3e414b4;
var $65b056c867d770c7$export$816d2913ae6b83b1;
var $65b056c867d770c7$export$61bcfe829111a1d0;
var $65b056c867d770c7$export$7ee8c9beb337bc3f;
var $65b056c867d770c7$export$b5836b71941fa3ed;
var $65b056c867d770c7$export$cf845f2c119da08a;
"use strict";
function $65b056c867d770c7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $65b056c867d770c7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $65b056c867d770c7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $65b056c867d770c7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $65b056c867d770c7$var$g(C, c)) n < e && 0 > $65b056c867d770c7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $65b056c867d770c7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $65b056c867d770c7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $65b056c867d770c7$var$l = performance;
    $65b056c867d770c7$export$c4744153514ff05d = function() {
        return $65b056c867d770c7$var$l.now();
    };
} else {
    var $65b056c867d770c7$var$p = Date, $65b056c867d770c7$var$q = $65b056c867d770c7$var$p.now();
    $65b056c867d770c7$export$c4744153514ff05d = function() {
        return $65b056c867d770c7$var$p.now() - $65b056c867d770c7$var$q;
    };
}
var $65b056c867d770c7$var$r = [], $65b056c867d770c7$var$t = [], $65b056c867d770c7$var$u = 1, $65b056c867d770c7$var$v = null, $65b056c867d770c7$var$y = 3, $65b056c867d770c7$var$z = !1, $65b056c867d770c7$var$A = !1, $65b056c867d770c7$var$B = !1, $65b056c867d770c7$var$D = "function" === typeof setTimeout ? setTimeout : null, $65b056c867d770c7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $65b056c867d770c7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $65b056c867d770c7$var$G(a) {
    for(var b = $65b056c867d770c7$var$h($65b056c867d770c7$var$t); null !== b;){
        if (null === b.callback) $65b056c867d770c7$var$k($65b056c867d770c7$var$t);
        else if (b.startTime <= a) $65b056c867d770c7$var$k($65b056c867d770c7$var$t), b.sortIndex = b.expirationTime, $65b056c867d770c7$var$f($65b056c867d770c7$var$r, b);
        else break;
        b = $65b056c867d770c7$var$h($65b056c867d770c7$var$t);
    }
}
function $65b056c867d770c7$var$H(a) {
    $65b056c867d770c7$var$B = !1;
    $65b056c867d770c7$var$G(a);
    if (!$65b056c867d770c7$var$A) {
        if (null !== $65b056c867d770c7$var$h($65b056c867d770c7$var$r)) $65b056c867d770c7$var$A = !0, $65b056c867d770c7$var$I($65b056c867d770c7$var$J);
        else {
            var b = $65b056c867d770c7$var$h($65b056c867d770c7$var$t);
            null !== b && $65b056c867d770c7$var$K($65b056c867d770c7$var$H, b.startTime - a);
        }
    }
}
function $65b056c867d770c7$var$J(a, b) {
    $65b056c867d770c7$var$A = !1;
    $65b056c867d770c7$var$B && ($65b056c867d770c7$var$B = !1, $65b056c867d770c7$var$E($65b056c867d770c7$var$L), $65b056c867d770c7$var$L = -1);
    $65b056c867d770c7$var$z = !0;
    var c = $65b056c867d770c7$var$y;
    try {
        $65b056c867d770c7$var$G(b);
        for($65b056c867d770c7$var$v = $65b056c867d770c7$var$h($65b056c867d770c7$var$r); null !== $65b056c867d770c7$var$v && (!($65b056c867d770c7$var$v.expirationTime > b) || a && !$65b056c867d770c7$var$M());){
            var d = $65b056c867d770c7$var$v.callback;
            if ("function" === typeof d) {
                $65b056c867d770c7$var$v.callback = null;
                $65b056c867d770c7$var$y = $65b056c867d770c7$var$v.priorityLevel;
                var e = d($65b056c867d770c7$var$v.expirationTime <= b);
                b = $65b056c867d770c7$export$c4744153514ff05d();
                "function" === typeof e ? $65b056c867d770c7$var$v.callback = e : $65b056c867d770c7$var$v === $65b056c867d770c7$var$h($65b056c867d770c7$var$r) && $65b056c867d770c7$var$k($65b056c867d770c7$var$r);
                $65b056c867d770c7$var$G(b);
            } else $65b056c867d770c7$var$k($65b056c867d770c7$var$r);
            $65b056c867d770c7$var$v = $65b056c867d770c7$var$h($65b056c867d770c7$var$r);
        }
        if (null !== $65b056c867d770c7$var$v) var w = !0;
        else {
            var m = $65b056c867d770c7$var$h($65b056c867d770c7$var$t);
            null !== m && $65b056c867d770c7$var$K($65b056c867d770c7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $65b056c867d770c7$var$v = null, $65b056c867d770c7$var$y = c, $65b056c867d770c7$var$z = !1;
    }
}
var $65b056c867d770c7$var$N = !1, $65b056c867d770c7$var$O = null, $65b056c867d770c7$var$L = -1, $65b056c867d770c7$var$P = 5, $65b056c867d770c7$var$Q = -1;
function $65b056c867d770c7$var$M() {
    return $65b056c867d770c7$export$c4744153514ff05d() - $65b056c867d770c7$var$Q < $65b056c867d770c7$var$P ? !1 : !0;
}
function $65b056c867d770c7$var$R() {
    if (null !== $65b056c867d770c7$var$O) {
        var a = $65b056c867d770c7$export$c4744153514ff05d();
        $65b056c867d770c7$var$Q = a;
        var b = !0;
        try {
            b = $65b056c867d770c7$var$O(!0, a);
        } finally{
            b ? $65b056c867d770c7$var$S() : ($65b056c867d770c7$var$N = !1, $65b056c867d770c7$var$O = null);
        }
    } else $65b056c867d770c7$var$N = !1;
}
var $65b056c867d770c7$var$S;
if ("function" === typeof $65b056c867d770c7$var$F) $65b056c867d770c7$var$S = function S() {
    $65b056c867d770c7$var$F($65b056c867d770c7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $65b056c867d770c7$var$T = new MessageChannel, $65b056c867d770c7$var$U = $65b056c867d770c7$var$T.port2;
    $65b056c867d770c7$var$T.port1.onmessage = $65b056c867d770c7$var$R;
    $65b056c867d770c7$var$S = function S() {
        $65b056c867d770c7$var$U.postMessage(null);
    };
} else $65b056c867d770c7$var$S = function S() {
    $65b056c867d770c7$var$D($65b056c867d770c7$var$R, 0);
};
function $65b056c867d770c7$var$I(a) {
    $65b056c867d770c7$var$O = a;
    $65b056c867d770c7$var$N || ($65b056c867d770c7$var$N = !0, $65b056c867d770c7$var$S());
}
function $65b056c867d770c7$var$K(a, b) {
    $65b056c867d770c7$var$L = $65b056c867d770c7$var$D(function() {
        a($65b056c867d770c7$export$c4744153514ff05d());
    }, b);
}
$65b056c867d770c7$export$3e506c1ccc9cc1a7 = 5;
$65b056c867d770c7$export$e26fe2ed2fa76875 = 1;
$65b056c867d770c7$export$502329bbf4b505b1 = 4;
$65b056c867d770c7$export$6e3807111c4874c4 = 3;
$65b056c867d770c7$export$c27134553091fb3a = null;
$65b056c867d770c7$export$33ee1acdc04fd2a2 = 2;
$65b056c867d770c7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$65b056c867d770c7$export$8352ce38b91d0c62 = function() {
    $65b056c867d770c7$var$A || $65b056c867d770c7$var$z || ($65b056c867d770c7$var$A = !0, $65b056c867d770c7$var$I($65b056c867d770c7$var$J));
};
$65b056c867d770c7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $65b056c867d770c7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$65b056c867d770c7$export$d3dfb8e4810cb555 = function() {
    return $65b056c867d770c7$var$y;
};
$65b056c867d770c7$export$839f9183b0465a69 = function() {
    return $65b056c867d770c7$var$h($65b056c867d770c7$var$r);
};
$65b056c867d770c7$export$72fdf0e06517287b = function(a) {
    switch($65b056c867d770c7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $65b056c867d770c7$var$y;
    }
    var c = $65b056c867d770c7$var$y;
    $65b056c867d770c7$var$y = b;
    try {
        return a();
    } finally{
        $65b056c867d770c7$var$y = c;
    }
};
$65b056c867d770c7$export$4b844e58a3e414b4 = function() {};
$65b056c867d770c7$export$816d2913ae6b83b1 = function() {};
$65b056c867d770c7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $65b056c867d770c7$var$y;
    $65b056c867d770c7$var$y = a;
    try {
        return b();
    } finally{
        $65b056c867d770c7$var$y = c;
    }
};
$65b056c867d770c7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $65b056c867d770c7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $65b056c867d770c7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $65b056c867d770c7$var$f($65b056c867d770c7$var$t, a), null === $65b056c867d770c7$var$h($65b056c867d770c7$var$r) && a === $65b056c867d770c7$var$h($65b056c867d770c7$var$t) && ($65b056c867d770c7$var$B ? ($65b056c867d770c7$var$E($65b056c867d770c7$var$L), $65b056c867d770c7$var$L = -1) : $65b056c867d770c7$var$B = !0, $65b056c867d770c7$var$K($65b056c867d770c7$var$H, c - d))) : (a.sortIndex = e, $65b056c867d770c7$var$f($65b056c867d770c7$var$r, a), $65b056c867d770c7$var$A || $65b056c867d770c7$var$z || ($65b056c867d770c7$var$A = !0, $65b056c867d770c7$var$I($65b056c867d770c7$var$J)));
    return a;
};
$65b056c867d770c7$export$b5836b71941fa3ed = $65b056c867d770c7$var$M;
$65b056c867d770c7$export$cf845f2c119da08a = function(a) {
    var b = $65b056c867d770c7$var$y;
    return function() {
        var c = $65b056c867d770c7$var$y;
        $65b056c867d770c7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $65b056c867d770c7$var$y = c;
        }
    };
};

});



parcelRegister("b48eP", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $80e6755a16316f75$export$bf730a2d8bf68b42; }, function (v) { return $80e6755a16316f75$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $80e6755a16316f75$export$bf730a2d8bf68b42;
"use strict";

var $f6C7p = parcelRequire("f6C7p");
function $80e6755a16316f75$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $80e6755a16316f75$var$p = "function" === typeof Object.is ? Object.is : $80e6755a16316f75$var$n, $80e6755a16316f75$var$q = $f6C7p.useSyncExternalStore, $80e6755a16316f75$var$r = $f6C7p.useRef, $80e6755a16316f75$var$t = $f6C7p.useEffect, $80e6755a16316f75$var$u = $f6C7p.useMemo, $80e6755a16316f75$var$v = $f6C7p.useDebugValue;
$80e6755a16316f75$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $80e6755a16316f75$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $80e6755a16316f75$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var _$b = f.value;
                    if (h(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if ($80e6755a16316f75$var$p(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== h && h(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $80e6755a16316f75$var$q(a, c[0], c[1]);
    $80e6755a16316f75$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $80e6755a16316f75$var$v(d);
    return d;
};

});

parcelRegister("2aK6P", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $dhgu3 = parcelRequire("dhgu3");

var $8cfPm = parcelRequire("8cfPm");

var $953s6 = parcelRequire("953s6");

var $fkQxX = parcelRequire("fkQxX");

var $feZkv = parcelRequire("feZkv");

var $g9pLc = parcelRequire("g9pLc");

var $3wcuq = parcelRequire("3wcuq");

var $3O8MO = parcelRequire("3O8MO");

var $6ZKiV = parcelRequire("6ZKiV");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(function(param) {
        var _param = (0, $g9pLc._)(param, 2), key = _param[0], value = _param[1];
        iter(key, value, obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && isPlainObject(base)) {
        if (!getPrototypeOf(base)) {
            var obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return __spreadValues({}, base);
    }
    var descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    var keys = Reflect.ownKeys(descriptors);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) each(obj, function(_key, value) {
        return freeze(value, true);
    }, true);
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        }, true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $8cfPm._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _this = this;
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $3wcuq._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $3wcuq._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $953s6._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $g9pLc._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $feZkv._)(DraftMap, Map1);
        var _super = (0, $6ZKiV._)(DraftMap);
        function DraftMap(target, parent) {
            (0, $8cfPm._)(this, DraftMap);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: (0, $dhgu3._)(_this),
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $953s6._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $fkQxX._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $fkQxX._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $fkQxX._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $fkQxX._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $3O8MO._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $feZkv._)(DraftSet, Set1);
        var _super = (0, $6ZKiV._)(DraftSet);
        function DraftSet(target, parent) {
            (0, $8cfPm._)(this, DraftSet);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: (0, $dhgu3._)(_this),
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $953s6._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $3O8MO._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});
parcelRegister("dhgu3", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $9aa9a632b9fe8fc3$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $9aa9a632b9fe8fc3$export$f3b8ed2e4a5d10b8; });
function $9aa9a632b9fe8fc3$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("8cfPm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5f7bb8b4a0f586d1$export$2996f80ef42b8419; });
function $5f7bb8b4a0f586d1$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("953s6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $69c74239b7971844$export$d60067ff2358eee8; });
function $69c74239b7971844$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $69c74239b7971844$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $69c74239b7971844$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $69c74239b7971844$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("fkQxX", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $b2a17bf4b2c346ce$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $b2a17bf4b2c346ce$export$1e71eb4bef00f6b0; });
function $b2a17bf4b2c346ce$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("feZkv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b187bca028a394bc$export$7e4530ad35d3bb8; });

var $5CovP = parcelRequire("5CovP");
function $b187bca028a394bc$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $5CovP._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("5CovP", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $417384028f45291d$export$c2c98ac76e997b63; });
function $417384028f45291d$export$c2c98ac76e997b63(o, p) {
    $417384028f45291d$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $417384028f45291d$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("g9pLc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bc2178121696f7f4$export$fdf2a89c76341bbf; });

var $5fLHB = parcelRequire("5fLHB");

var $i1rj9 = parcelRequire("i1rj9");

var $cqgdm = parcelRequire("cqgdm");

var $cvdrm = parcelRequire("cvdrm");
function $bc2178121696f7f4$export$fdf2a89c76341bbf(arr, i) {
    return (0, $5fLHB._array_with_holes)(arr) || (0, $i1rj9._iterable_to_array_limit)(arr, i) || (0, $cvdrm._unsupported_iterable_to_array)(arr, i) || (0, $cqgdm._non_iterable_rest)();
}

});
parcelRegister("5fLHB", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $3d335b2255857f77$export$e6256bf45c68d561; });
function $3d335b2255857f77$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("i1rj9", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $d1ed80bff6babf6c$export$2fd15edff6687200; });
function $d1ed80bff6babf6c$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("cqgdm", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $90b47d97005bf91e$export$60dbc22abd7da546; });
function $90b47d97005bf91e$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("cvdrm", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $91a2ce42d686c897$export$a5be06335b3a083c; });

var $cEZbj = parcelRequire("cEZbj");
function $91a2ce42d686c897$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $cEZbj._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $cEZbj._array_like_to_array)(o, minLen);
}

});
parcelRegister("cEZbj", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $9378add33926ec9b$export$79e617b1955a2616; });
function $9378add33926ec9b$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("3wcuq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $28fe0c7091185670$export$1b5e630bc3aea29f; });

var $3FHhy = parcelRequire("3FHhy");

var $l5ZDi = parcelRequire("l5ZDi");

var $8Pbpy = parcelRequire("8Pbpy");

var $cvdrm = parcelRequire("cvdrm");
function $28fe0c7091185670$export$1b5e630bc3aea29f(arr) {
    return (0, $3FHhy._array_without_holes)(arr) || (0, $l5ZDi._iterable_to_array)(arr) || (0, $cvdrm._unsupported_iterable_to_array)(arr) || (0, $8Pbpy._non_iterable_spread)();
}

});
parcelRegister("3FHhy", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $2ac6c65d8c624e42$export$7e0947b5ad3404e2; });

var $cEZbj = parcelRequire("cEZbj");
function $2ac6c65d8c624e42$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $cEZbj._array_like_to_array)(arr);
}

});

parcelRegister("l5ZDi", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $f5b9df976a9be9a0$export$1eb58a6e75231000; });
function $f5b9df976a9be9a0$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("8Pbpy", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $66cbf02ff46324db$export$e6f3c4780d19eb2b; });
function $66cbf02ff46324db$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3O8MO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2c5cdb5d954b747d$export$2466d533fda16e33; });

var $7Z16o = parcelRequire("7Z16o");

var $4R95R = parcelRequire("4R95R");

var $1TV0B = parcelRequire("1TV0B");

var $5CovP = parcelRequire("5CovP");
function $2c5cdb5d954b747d$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $2c5cdb5d954b747d$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $1TV0B._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $7Z16o._construct)(Class, arguments, (0, $4R95R._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $5CovP._set_prototype_of)(Wrapper, Class);
    };
    return $2c5cdb5d954b747d$export$2466d533fda16e33(Class);
}

});
parcelRegister("7Z16o", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $5cff15c21874fac7$export$2d841144c5f8c4ab; });
$parcel$export(module.exports, "_", function () { return $5cff15c21874fac7$export$2d841144c5f8c4ab; });

var $lhqyP = parcelRequire("lhqyP");

var $5CovP = parcelRequire("5CovP");
function $5cff15c21874fac7$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $lhqyP._is_native_reflect_construct)()) $5cff15c21874fac7$export$2d841144c5f8c4ab = Reflect.construct;
    else $5cff15c21874fac7$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $5CovP._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $5cff15c21874fac7$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRegister("lhqyP", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $f7dfc9ebda02e7c5$export$685354647fba1516; });
function $f7dfc9ebda02e7c5$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("4R95R", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $38932a72944f631b$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $38932a72944f631b$export$f09211a7d3c496a1; });
function $38932a72944f631b$export$f09211a7d3c496a1(o) {
    $38932a72944f631b$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $38932a72944f631b$export$f09211a7d3c496a1(o);
}

});

parcelRegister("1TV0B", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $1627263a1a65df52$export$514eda94019f4334; });
function $1627263a1a65df52$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("6ZKiV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $517c5ba808051a51$export$8dd05c13f5255580; });

var $4R95R = parcelRequire("4R95R");

var $lhqyP = parcelRequire("lhqyP");

var $hok2M = parcelRequire("hok2M");
function $517c5ba808051a51$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $lhqyP._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $4R95R._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $4R95R._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $hok2M._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("hok2M", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $ca9439da9057d5eb$export$ef97c660ca164e52; });

var $dhgu3 = parcelRequire("dhgu3");

var $7fjaO = parcelRequire("7fjaO");
function $ca9439da9057d5eb$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $7fjaO._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $dhgu3._assert_this_initialized)(self);
}

});



parcelRegister("fBF8i", function(module, exports) {


module.exports = (parcelRequire("bzgBT"))((parcelRequire("gUptJ")).resolve("4EkDN")).then(function() {
    return parcelRequire("a7DFG");
});

});
parcelRegister("bzgBT", function(module, exports) {
"use strict";

var $laOJM = parcelRequire("laOJM");
module.exports = $laOJM(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("laOJM", function(module, exports) {
"use strict";
var $f6a1e38d7161dfcb$var$cachedBundles = {};
var $f6a1e38d7161dfcb$var$cachedPreloads = {};
var $f6a1e38d7161dfcb$var$cachedPrefetches = {};
function $f6a1e38d7161dfcb$var$getCache(type) {
    switch(type){
        case "preload":
            return $f6a1e38d7161dfcb$var$cachedPreloads;
        case "prefetch":
            return $f6a1e38d7161dfcb$var$cachedPrefetches;
        default:
            return $f6a1e38d7161dfcb$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f6a1e38d7161dfcb$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




var $g9pLc = parcelRequire("g9pLc");

var $ht8Wd = parcelRequire("ht8Wd");

var $f6C7p = parcelRequire("f6C7p");
var $dbc53e6cc89d3c52$exports = {};

$parcel$export($dbc53e6cc89d3c52$exports, "createRoot", function () { return $dbc53e6cc89d3c52$export$882461b6382ed46c; }, function (v) { return $dbc53e6cc89d3c52$export$882461b6382ed46c = v; });
$parcel$export($dbc53e6cc89d3c52$exports, "hydrateRoot", function () { return $dbc53e6cc89d3c52$export$757ceba2d55c277e; }, function (v) { return $dbc53e6cc89d3c52$export$757ceba2d55c277e = v; });
var $dbc53e6cc89d3c52$export$882461b6382ed46c;
var $dbc53e6cc89d3c52$export$757ceba2d55c277e;
"use strict";
var $d1c59b6c8407de62$exports = {};
"use strict";
function $d1c59b6c8407de62$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d1c59b6c8407de62$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d1c59b6c8407de62$var$checkDCE();

$d1c59b6c8407de62$exports = (parcelRequire("ikjDJ"));


var $dbc53e6cc89d3c52$var$i;
$dbc53e6cc89d3c52$export$882461b6382ed46c = $d1c59b6c8407de62$exports.createRoot;
$dbc53e6cc89d3c52$export$757ceba2d55c277e = $d1c59b6c8407de62$exports.hydrateRoot;



var $g9pLc = parcelRequire("g9pLc");

var $ht8Wd = parcelRequire("ht8Wd");
var $f1a1b29ad18234d0$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_264,h_288,c_fill/";
var $f1a1b29ad18234d0$export$cd85698b2b1026a5 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";
var $f1a1b29ad18234d0$export$8878ead86ed0da0b = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQdaMYtVi9_tfNcpsbGGseU6ehYgV9UeU3h7A&usqp=CAU ";
var $f1a1b29ad18234d0$export$b77c1aa4fb57bd1c = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=" //  multifile used named exports
;



var $f6C7p = parcelRequire("f6C7p");
/**
 * React Router DOM v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $39e0c52944643fcc$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $39e0c52944643fcc$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $39e0c52944643fcc$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $39e0c52944643fcc$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $8cfPm = parcelRequire("8cfPm");

var $g9pLc = parcelRequire("g9pLc");

var $3wcuq = parcelRequire("3wcuq");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $7fjaO = parcelRequire("7fjaO");
var $3529a7406e1ba74f$var$extendStatics = function extendStatics1(d, b) {
    $3529a7406e1ba74f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3529a7406e1ba74f$var$extendStatics(d, b);
};
function $3529a7406e1ba74f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3529a7406e1ba74f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3529a7406e1ba74f$export$18ce0697a983be9b = function __assign1() {
    $3529a7406e1ba74f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3529a7406e1ba74f$export$18ce0697a983be9b.apply(this, arguments);
};
function $3529a7406e1ba74f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3529a7406e1ba74f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3529a7406e1ba74f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3529a7406e1ba74f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3529a7406e1ba74f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3529a7406e1ba74f$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $7fjaO._)(x)) === "symbol" ? x : "".concat(x);
}
function $3529a7406e1ba74f$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $7fjaO._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3529a7406e1ba74f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3529a7406e1ba74f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3529a7406e1ba74f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3529a7406e1ba74f$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3529a7406e1ba74f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3529a7406e1ba74f$export$45d3717a4c69092e(o, m, p);
}
function $3529a7406e1ba74f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3529a7406e1ba74f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3529a7406e1ba74f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3529a7406e1ba74f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3529a7406e1ba74f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3529a7406e1ba74f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3529a7406e1ba74f$export$10c90e4f7922046c(v) {
    return this instanceof $3529a7406e1ba74f$export$10c90e4f7922046c ? (this.v = v, this) : new $3529a7406e1ba74f$export$10c90e4f7922046c(v);
}
function $3529a7406e1ba74f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3529a7406e1ba74f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3529a7406e1ba74f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3529a7406e1ba74f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3529a7406e1ba74f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3529a7406e1ba74f$export$19a8beecd37a4c45 === "function" ? $3529a7406e1ba74f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3529a7406e1ba74f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3529a7406e1ba74f$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3529a7406e1ba74f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3529a7406e1ba74f$export$45d3717a4c69092e(result, mod, k);
    }
    $3529a7406e1ba74f$var$__setModuleDefault(result, mod);
    return result;
}
function $3529a7406e1ba74f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3529a7406e1ba74f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3529a7406e1ba74f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3529a7406e1ba74f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3529a7406e1ba74f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3529a7406e1ba74f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3529a7406e1ba74f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3529a7406e1ba74f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3529a7406e1ba74f$export$2e2bcd8739ae039 = {
    __extends: $3529a7406e1ba74f$export$a8ba968b8961cb8a,
    __assign: $3529a7406e1ba74f$export$18ce0697a983be9b,
    __rest: $3529a7406e1ba74f$export$3c9a16f847548506,
    __decorate: $3529a7406e1ba74f$export$29e00dfd3077644b,
    __param: $3529a7406e1ba74f$export$d5ad3fd78186038f,
    __metadata: $3529a7406e1ba74f$export$f1db080c865becb9,
    __awaiter: $3529a7406e1ba74f$export$1050f835b63b671e,
    __generator: $3529a7406e1ba74f$export$67ebef60e6f28a6,
    __createBinding: $3529a7406e1ba74f$export$45d3717a4c69092e,
    __exportStar: $3529a7406e1ba74f$export$f33643c0debef087,
    __values: $3529a7406e1ba74f$export$19a8beecd37a4c45,
    __read: $3529a7406e1ba74f$export$8d051b38c9118094,
    __spread: $3529a7406e1ba74f$export$afc72e2116322959,
    __spreadArrays: $3529a7406e1ba74f$export$6388937ca91ccae8,
    __spreadArray: $3529a7406e1ba74f$export$1216008129fb82ed,
    __await: $3529a7406e1ba74f$export$10c90e4f7922046c,
    __asyncGenerator: $3529a7406e1ba74f$export$e427f37a30a4de9b,
    __asyncDelegator: $3529a7406e1ba74f$export$bbd80228419bb833,
    __asyncValues: $3529a7406e1ba74f$export$e3b29a3d6162315f,
    __makeTemplateObject: $3529a7406e1ba74f$export$4fb47efe1390b86f,
    __importStar: $3529a7406e1ba74f$export$c21735bcef00d192,
    __importDefault: $3529a7406e1ba74f$export$da59b14a69baef04,
    __classPrivateFieldGet: $3529a7406e1ba74f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3529a7406e1ba74f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3529a7406e1ba74f$export$81fdc39f203e4e04,
    __addDisposableResource: $3529a7406e1ba74f$export$88ac25d8e944e405,
    __disposeResources: $3529a7406e1ba74f$export$8f076105dc360e92
};



var $f6C7p = parcelRequire("f6C7p");
/**
 * @remix-run/router v1.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $8cfPm = parcelRequire("8cfPm");

var $953s6 = parcelRequire("953s6");

var $fkQxX = parcelRequire("fkQxX");

var $feZkv = parcelRequire("feZkv");

var $g9pLc = parcelRequire("g9pLc");

var $5fLHB = parcelRequire("5fLHB");

var $l5ZDi = parcelRequire("l5ZDi");

var $cqgdm = parcelRequire("cqgdm");

var $cvdrm = parcelRequire("cvdrm");
function $865d5a7c3934d6d3$export$e62c166da838fa3(arr) {
    return (0, $5fLHB._array_with_holes)(arr) || (0, $l5ZDi._iterable_to_array)(arr) || (0, $cvdrm._unsupported_iterable_to_array)(arr) || (0, $cqgdm._non_iterable_rest)();
}



var $3wcuq = parcelRequire("3wcuq");

var $3O8MO = parcelRequire("3O8MO");

var $6ZKiV = parcelRequire("6ZKiV");


function $42943e3e55c7cf39$var$_extends() {
    $42943e3e55c7cf39$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $42943e3e55c7cf39$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $42943e3e55c7cf39$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($42943e3e55c7cf39$export$e19cd5f9376f8cee || ($42943e3e55c7cf39$export$e19cd5f9376f8cee = {}));
var $42943e3e55c7cf39$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $42943e3e55c7cf39$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $42943e3e55c7cf39$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $42943e3e55c7cf39$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $42943e3e55c7cf39$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $42943e3e55c7cf39$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $42943e3e55c7cf39$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $42943e3e55c7cf39$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $42943e3e55c7cf39$export$fe53371bee54353d(to);
    }
    return $42943e3e55c7cf39$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $42943e3e55c7cf39$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $42943e3e55c7cf39$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $42943e3e55c7cf39$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $42943e3e55c7cf39$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $42943e3e55c7cf39$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $42943e3e55c7cf39$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $42943e3e55c7cf39$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $42943e3e55c7cf39$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $42943e3e55c7cf39$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $42943e3e55c7cf39$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $42943e3e55c7cf39$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $42943e3e55c7cf39$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $42943e3e55c7cf39$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $42943e3e55c7cf39$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $42943e3e55c7cf39$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $42943e3e55c7cf39$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $42943e3e55c7cf39$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($42943e3e55c7cf39$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Push;
        var location = $42943e3e55c7cf39$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $42943e3e55c7cf39$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Replace;
        var location = $42943e3e55c7cf39$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $42943e3e55c7cf39$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $42943e3e55c7cf39$export$fe53371bee54353d(to);
        $42943e3e55c7cf39$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($42943e3e55c7cf39$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($42943e3e55c7cf39$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $42943e3e55c7cf39$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($42943e3e55c7cf39$var$ResultType || ($42943e3e55c7cf39$var$ResultType = {}));
var $42943e3e55c7cf39$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $42943e3e55c7cf39$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $42943e3e55c7cf39$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $3wcuq._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $42943e3e55c7cf39$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $42943e3e55c7cf39$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($42943e3e55c7cf39$var$isIndexRoute(route)) {
            var indexRoute = $42943e3e55c7cf39$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $42943e3e55c7cf39$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $42943e3e55c7cf39$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $42943e3e55c7cf39$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $42943e3e55c7cf39$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $42943e3e55c7cf39$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $42943e3e55c7cf39$var$flattenRoutes(routes);
    $42943e3e55c7cf39$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $42943e3e55c7cf39$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $42943e3e55c7cf39$var$safelyDecodeURI(pathname));
    return matches;
}
function $42943e3e55c7cf39$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $42943e3e55c7cf39$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $42943e3e55c7cf39$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $42943e3e55c7cf39$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $42943e3e55c7cf39$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $42943e3e55c7cf39$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $42943e3e55c7cf39$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $42943e3e55c7cf39$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $42943e3e55c7cf39$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $865d5a7c3934d6d3$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $42943e3e55c7cf39$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $3wcuq._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $3wcuq._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $42943e3e55c7cf39$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $42943e3e55c7cf39$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $42943e3e55c7cf39$var$paramRe = /^:\w+$/;
var $42943e3e55c7cf39$var$dynamicSegmentValue = 3;
var $42943e3e55c7cf39$var$indexRouteValue = 2;
var $42943e3e55c7cf39$var$emptySegmentValue = 1;
var $42943e3e55c7cf39$var$staticSegmentValue = 10;
var $42943e3e55c7cf39$var$splatPenalty = -2;
var $42943e3e55c7cf39$var$isSplat = function(s) {
    return s === "*";
};
function $42943e3e55c7cf39$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($42943e3e55c7cf39$var$isSplat)) initialScore += $42943e3e55c7cf39$var$splatPenalty;
    if (index) initialScore += $42943e3e55c7cf39$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$42943e3e55c7cf39$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($42943e3e55c7cf39$var$paramRe.test(segment) ? $42943e3e55c7cf39$var$dynamicSegmentValue : segment === "" ? $42943e3e55c7cf39$var$emptySegmentValue : $42943e3e55c7cf39$var$staticSegmentValue);
    }, initialScore);
}
function $42943e3e55c7cf39$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $42943e3e55c7cf39$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $42943e3e55c7cf39$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $42943e3e55c7cf39$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $42943e3e55c7cf39$export$a5c6d149b50c1d86($42943e3e55c7cf39$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $42943e3e55c7cf39$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $42943e3e55c7cf39$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $42943e3e55c7cf39$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $g9pLc._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $42943e3e55c7cf39$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $42943e3e55c7cf39$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $g9pLc._)($42943e3e55c7cf39$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], paramNames = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = paramNames.reduce(function(memo, paramName, index) {
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $42943e3e55c7cf39$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $42943e3e55c7cf39$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $42943e3e55c7cf39$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var paramNames = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, function(_, paramName) {
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $42943e3e55c7cf39$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $42943e3e55c7cf39$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $42943e3e55c7cf39$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $42943e3e55c7cf39$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $42943e3e55c7cf39$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $42943e3e55c7cf39$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $42943e3e55c7cf39$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $42943e3e55c7cf39$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $42943e3e55c7cf39$var$normalizeSearch(search),
        hash: $42943e3e55c7cf39$var$normalizeHash(hash)
    };
}
function $42943e3e55c7cf39$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $42943e3e55c7cf39$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $42943e3e55c7cf39$export$90ba53ce1c7fdff2(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
/**
 * @private
 */ function $42943e3e55c7cf39$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $42943e3e55c7cf39$export$8ccf933b0513f8d0(toArg);
    else {
        to = $42943e3e55c7cf39$var$_extends({}, toArg);
        $42943e3e55c7cf39$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $42943e3e55c7cf39$var$getInvalidPathError("?", "pathname", "search", to));
        $42943e3e55c7cf39$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $42943e3e55c7cf39$var$getInvalidPathError("#", "pathname", "hash", to));
        $42943e3e55c7cf39$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $42943e3e55c7cf39$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $42943e3e55c7cf39$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $42943e3e55c7cf39$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $42943e3e55c7cf39$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $42943e3e55c7cf39$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $42943e3e55c7cf39$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $42943e3e55c7cf39$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $42943e3e55c7cf39$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $42943e3e55c7cf39$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $42943e3e55c7cf39$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $42943e3e55c7cf39$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $feZkv._)(AbortedDeferredError, Error1);
    var _super = (0, $6ZKiV._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $8cfPm._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $3O8MO._)(Error));
var $42943e3e55c7cf39$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $8cfPm._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $42943e3e55c7cf39$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $42943e3e55c7cf39$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref) {
            var _$_ref = (0, $g9pLc._)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            return Object.assign(acc, (0, $fkQxX._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $953s6._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $42943e3e55c7cf39$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $39e0c52944643fcc$export$7c398597f8905a1)(function() {
                    var aborted, onAbort;
                    return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $42943e3e55c7cf39$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref2) {
                    var _$_ref2 = (0, $g9pLc._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
                    return Object.assign(acc, (0, $fkQxX._)({}, key, $42943e3e55c7cf39$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $42943e3e55c7cf39$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $42943e3e55c7cf39$var$unwrapTrackedPromise(value) {
    if (!$42943e3e55c7cf39$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $42943e3e55c7cf39$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $42943e3e55c7cf39$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $42943e3e55c7cf39$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $42943e3e55c7cf39$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $42943e3e55c7cf39$export$a6cd19cd1951a23c = function(url, init) {
    var response = $42943e3e55c7cf39$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $42943e3e55c7cf39$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $8cfPm._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $42943e3e55c7cf39$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $42943e3e55c7cf39$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $42943e3e55c7cf39$var$validMutationMethods = new Set($42943e3e55c7cf39$var$validMutationMethodsArr);
var $42943e3e55c7cf39$var$validRequestMethodsArr = [
    "get"
].concat((0, $3wcuq._)($42943e3e55c7cf39$var$validMutationMethodsArr));
var $42943e3e55c7cf39$var$validRequestMethods = new Set($42943e3e55c7cf39$var$validRequestMethodsArr);
var $42943e3e55c7cf39$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $42943e3e55c7cf39$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $42943e3e55c7cf39$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $42943e3e55c7cf39$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $42943e3e55c7cf39$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $42943e3e55c7cf39$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $42943e3e55c7cf39$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $42943e3e55c7cf39$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $42943e3e55c7cf39$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $42943e3e55c7cf39$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $42943e3e55c7cf39$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $42943e3e55c7cf39$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $42943e3e55c7cf39$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $42943e3e55c7cf39$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $42943e3e55c7cf39$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $42943e3e55c7cf39$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $fkQxX._)({}, route.id, error);
    }
    var initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some(function(m) {
        return m.route.lazy;
    }) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some(function(m) {
        return m.route.loader;
    }) || init.hydrationData != null);
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $42943e3e55c7cf39$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $42943e3e55c7cf39$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $42943e3e55c7cf39$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $42943e3e55c7cf39$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $42943e3e55c7cf39$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($42943e3e55c7cf39$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, viewTransitionOpts) {
        state = $42943e3e55c7cf39$var$_extends({}, state, newState);
        subscribers.forEach(function(subscriber) {
            return subscriber(state, {
                unstable_viewTransitionOpts: viewTransitionOpts
            });
        });
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $42943e3e55c7cf39$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $42943e3e55c7cf39$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $42943e3e55c7cf39$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $42943e3e55c7cf39$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $42943e3e55c7cf39$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $42943e3e55c7cf39$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $42943e3e55c7cf39$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $42943e3e55c7cf39$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($42943e3e55c7cf39$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $42943e3e55c7cf39$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), viewTransitionOpts);
        // Reset stateful navigation vars
        pendingAction = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, blockerKey;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $42943e3e55c7cf39$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $42943e3e55c7cf39$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $42943e3e55c7cf39$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $42943e3e55c7cf39$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $42943e3e55c7cf39$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $42943e3e55c7cf39$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $42943e3e55c7cf39$export$2708184779ceb39d(routesToUse, location, basename);
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $42943e3e55c7cf39$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $42943e3e55c7cf39$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $fkQxX._)({}, route.id, error)
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $42943e3e55c7cf39$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $42943e3e55c7cf39$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $42943e3e55c7cf39$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $fkQxX._)({}, $42943e3e55c7cf39$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $42943e3e55c7cf39$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $42943e3e55c7cf39$var$getLoadingNavigation(location, opts.submission);
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $42943e3e55c7cf39$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $42943e3e55c7cf39$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        });
                        actionMatch = $42943e3e55c7cf39$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $42943e3e55c7cf39$var$ResultType.error,
                            error: $42943e3e55c7cf39$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $42943e3e55c7cf39$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$42943e3e55c7cf39$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($42943e3e55c7cf39$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $42943e3e55c7cf39$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $42943e3e55c7cf39$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $fkQxX._)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($42943e3e55c7cf39$var$isDeferredResult(result)) throw $42943e3e55c7cf39$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $fkQxX._)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $42943e3e55c7cf39$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $42943e3e55c7cf39$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $g9pLc._)($42943e3e55c7cf39$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $42943e3e55c7cf39$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        if (!isUninterruptedRevalidation) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $42943e3e55c7cf39$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($42943e3e55c7cf39$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $42943e3e55c7cf39$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(state, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        // Process and commit output from loaders
                        _processLoaderData = $42943e3e55c7cf39$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $42943e3e55c7cf39$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $42943e3e55c7cf39$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $42943e3e55c7cf39$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        var matches = $42943e3e55c7cf39$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $42943e3e55c7cf39$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        var _normalizeNavigateOptions = $42943e3e55c7cf39$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        var match = $42943e3e55c7cf39$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $42943e3e55c7cf39$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(key, routeId, path, match, requestMatches, submission) {
            var error, existingFetcher, fetcher, abortController, fetchRequest, originatingLoadId, actionResult, doneFetcher, loadingFetcher, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher1, didAbortFetchLoads;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $42943e3e55c7cf39$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error);
                            return [
                                2
                            ];
                        }
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        fetcher = $42943e3e55c7cf39$var$getSubmittingFetcher(submission, existingFetcher);
                        state.fetchers.set(key, fetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = $42943e3e55c7cf39$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $42943e3e55c7cf39$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by ou our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if ($42943e3e55c7cf39$var$isRedirectResult(actionResult)) {
                            fetchControllers.delete(key);
                            if (pendingNavigationLoadId > originatingLoadId) {
                                // A new navigation was kicked off after our action started, so that
                                // should take precedence over this redirect navigation.  We already
                                // set isRevalidationRequired so all loaders for the new route should
                                // fire unless opted out via shouldRevalidate
                                doneFetcher = $42943e3e55c7cf39$var$getDoneFetcher(undefined);
                                state.fetchers.set(key, doneFetcher);
                                updateState({
                                    fetchers: new Map(state.fetchers)
                                });
                                return [
                                    2
                                ];
                            } else {
                                fetchRedirectIds.add(key);
                                loadingFetcher = $42943e3e55c7cf39$var$getLoadingFetcher(submission);
                                state.fetchers.set(key, loadingFetcher);
                                updateState({
                                    fetchers: new Map(state.fetchers)
                                });
                                return [
                                    2,
                                    startRedirectNavigation(state, actionResult, {
                                        fetcherSubmission: submission
                                    })
                                ];
                            }
                        }
                        // Process any non-redirect errors thrown
                        if ($42943e3e55c7cf39$var$isErrorResult(actionResult)) {
                            setFetcherError(key, routeId, actionResult.error);
                            return [
                                2
                            ];
                        }
                        if ($42943e3e55c7cf39$var$isDeferredResult(actionResult)) throw $42943e3e55c7cf39$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $42943e3e55c7cf39$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $42943e3e55c7cf39$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $42943e3e55c7cf39$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $42943e3e55c7cf39$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $g9pLc._)($42943e3e55c7cf39$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $fkQxX._)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $42943e3e55c7cf39$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $42943e3e55c7cf39$var$findRedirect(results);
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(state, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $42943e3e55c7cf39$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher1 = $42943e3e55c7cf39$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher1);
                        }
                        didAbortFetchLoads = abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $42943e3e55c7cf39$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState($42943e3e55c7cf39$var$_extends({
                                errors: errors,
                                loaderData: $42943e3e55c7cf39$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
                            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(key, routeId, path, match, matches, submission) {
            var existingFetcher, loadingFetcher, abortController, fetchRequest, originatingLoadId, result, doneFetcher, boundaryMatch, doneFetcher1;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        // Put this fetcher into it's loading state
                        loadingFetcher = $42943e3e55c7cf39$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
                        state.fetchers.set(key, loadingFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = $42943e3e55c7cf39$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $42943e3e55c7cf39$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$42943e3e55c7cf39$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $42943e3e55c7cf39$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (!$42943e3e55c7cf39$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        doneFetcher = $42943e3e55c7cf39$var$getDoneFetcher(undefined);
                        state.fetchers.set(key, doneFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($42943e3e55c7cf39$var$isErrorResult(result)) {
                            boundaryMatch = $42943e3e55c7cf39$var$findNearestBoundary(state.matches, routeId);
                            state.fetchers.delete(key);
                            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
                            // do we need to behave any differently with our non-redirect errors?
                            // What if it was a non-redirect Response?
                            updateState({
                                fetchers: new Map(state.fetchers),
                                errors: (0, $fkQxX._)({}, boundaryMatch.route.id, result.error)
                            });
                            return [
                                2
                            ];
                        }
                        $42943e3e55c7cf39$export$3e9cee6b33872309(!$42943e3e55c7cf39$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        doneFetcher1 = $42943e3e55c7cf39$var$getDoneFetcher(result.data);
                        state.fetchers.set(key, doneFetcher1);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(state, redirect, _temp) {
            var _ref, submission, fetcherSubmission, replace, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp === void 0 ? {} : _temp, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $42943e3e55c7cf39$var$createLocation(state.location, redirect.location, {
                            _isRedirect: true
                        });
                        $42943e3e55c7cf39$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($42943e3e55c7cf39$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                                url = init.history.createURL(redirect.location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $42943e3e55c7cf39$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $42943e3e55c7cf39$export$e19cd5f9376f8cee.Replace : $42943e3e55c7cf39$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $42943e3e55c7cf39$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($42943e3e55c7cf39$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $42943e3e55c7cf39$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $42943e3e55c7cf39$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $42943e3e55c7cf39$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $3wcuq._)(matchesToLoad.map(function(match) {
                                return $42943e3e55c7cf39$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename);
                            })).concat((0, $3wcuq._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $42943e3e55c7cf39$var$callLoaderOrAction("loader", $42943e3e55c7cf39$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                                else {
                                    var error = {
                                        type: $42943e3e55c7cf39$var$ResultType.error,
                                        error: $42943e3e55c7cf39$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $42943e3e55c7cf39$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $42943e3e55c7cf39$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $3wcuq._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        var boundaryMatch = $42943e3e55c7cf39$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $fkQxX._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $42943e3e55c7cf39$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $42943e3e55c7cf39$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $42943e3e55c7cf39$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $g9pLc._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $42943e3e55c7cf39$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $42943e3e55c7cf39$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $42943e3e55c7cf39$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $42943e3e55c7cf39$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $42943e3e55c7cf39$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $g9pLc._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $42943e3e55c7cf39$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $42943e3e55c7cf39$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $42943e3e55c7cf39$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $42943e3e55c7cf39$export$4d0306f8f6a4585b = Symbol("deferred");
function $42943e3e55c7cf39$export$3336b097a6fbc59a(routes, opts) {
    $42943e3e55c7cf39$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $42943e3e55c7cf39$var$defaultMapRouteProperties;
    var dataRoutes = $42943e3e55c7cf39$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp2) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(request, _temp2) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp2 === void 0 ? {} : _temp2).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $42943e3e55c7cf39$var$createLocation("", $42943e3e55c7cf39$export$fe53371bee54353d(url), null, "default");
                        matches = $42943e3e55c7cf39$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$42943e3e55c7cf39$var$isValidMethod(method) && method !== "HEAD") {
                            error = $42943e3e55c7cf39$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $42943e3e55c7cf39$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $fkQxX._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $42943e3e55c7cf39$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $42943e3e55c7cf39$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $fkQxX._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($42943e3e55c7cf39$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $42943e3e55c7cf39$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp3) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(request, _temp3) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $42943e3e55c7cf39$var$createLocation("", $42943e3e55c7cf39$export$fe53371bee54353d(url), null, "default");
                        matches = $42943e3e55c7cf39$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$42943e3e55c7cf39$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $42943e3e55c7cf39$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $42943e3e55c7cf39$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $42943e3e55c7cf39$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $42943e3e55c7cf39$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $42943e3e55c7cf39$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($42943e3e55c7cf39$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$42943e3e55c7cf39$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $42943e3e55c7cf39$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$42943e3e55c7cf39$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $42943e3e55c7cf39$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $42943e3e55c7cf39$var$isResponse(result1) ? result1 : $42943e3e55c7cf39$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($42943e3e55c7cf39$var$isQueryRouteResponse(e)) {
                            if (e.type === $42943e3e55c7cf39$var$ResultType.error) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($42943e3e55c7cf39$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $42943e3e55c7cf39$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $42943e3e55c7cf39$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $42943e3e55c7cf39$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
                        }
                        _state.label = 3;
                    case 3:
                        if ($42943e3e55c7cf39$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($42943e3e55c7cf39$var$isDeferredResult(result)) {
                            error1 = $42943e3e55c7cf39$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $42943e3e55c7cf39$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($42943e3e55c7cf39$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $fkQxX._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$42943e3e55c7cf39$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = $42943e3e55c7cf39$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $fkQxX._)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $42943e3e55c7cf39$var$_extends({}, context, {
                                statusCode: $42943e3e55c7cf39$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $42943e3e55c7cf39$var$_extends({}, result.headers ? (0, $fkQxX._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $42943e3e55c7cf39$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $fkQxX._)({}, actionMatch.route.id, result.data),
                                actionHeaders: $42943e3e55c7cf39$var$_extends({}, result.headers ? (0, $fkQxX._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $42943e3e55c7cf39$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $42943e3e55c7cf39$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $fkQxX._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $3wcuq._)(matchesToLoad.map(function(match) {
                                return $42943e3e55c7cf39$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
                        }
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $42943e3e55c7cf39$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $42943e3e55c7cf39$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $42943e3e55c7cf39$export$fec11da027c70692(routes, context, error) {
    var newContext = $42943e3e55c7cf39$var$_extends({}, context, {
        statusCode: 500,
        errors: (0, $fkQxX._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $42943e3e55c7cf39$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $42943e3e55c7cf39$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $42943e3e55c7cf39$export$cae722b0cc860f13(to ? to : ".", $42943e3e55c7cf39$export$90ba53ce1c7fdff2(contextualMatches).map(function(m) {
        return m.pathnameBase;
    }), $42943e3e55c7cf39$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$42943e3e55c7cf39$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $42943e3e55c7cf39$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $42943e3e55c7cf39$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $42943e3e55c7cf39$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$42943e3e55c7cf39$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$42943e3e55c7cf39$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $42943e3e55c7cf39$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $42943e3e55c7cf39$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $42943e3e55c7cf39$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$42943e3e55c7cf39$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $g9pLc._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$42943e3e55c7cf39$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $42943e3e55c7cf39$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $42943e3e55c7cf39$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $42943e3e55c7cf39$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $42943e3e55c7cf39$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $42943e3e55c7cf39$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($42943e3e55c7cf39$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $42943e3e55c7cf39$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $42943e3e55c7cf39$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $42943e3e55c7cf39$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $42943e3e55c7cf39$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $42943e3e55c7cf39$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $42943e3e55c7cf39$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($42943e3e55c7cf39$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $42943e3e55c7cf39$var$shouldRevalidateLoader(match, $42943e3e55c7cf39$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $42943e3e55c7cf39$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some(function(m) {
            return m.route.id === f.routeId;
        })) return;
        var fetcherMatches = $42943e3e55c7cf39$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $42943e3e55c7cf39$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $42943e3e55c7cf39$var$shouldRevalidateLoader(fetcherMatch, $42943e3e55c7cf39$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $42943e3e55c7cf39$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $42943e3e55c7cf39$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $42943e3e55c7cf39$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $42943e3e55c7cf39$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $42943e3e55c7cf39$var$_loadLazyRouteModule.apply(this, arguments);
}
function $42943e3e55c7cf39$var$_loadLazyRouteModule() {
    $42943e3e55c7cf39$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $42943e3e55c7cf39$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $42943e3e55c7cf39$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$42943e3e55c7cf39$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $42943e3e55c7cf39$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $42943e3e55c7cf39$var$_loadLazyRouteModule.apply(this, arguments);
}
function $42943e3e55c7cf39$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    return $42943e3e55c7cf39$var$_callLoaderOrAction.apply(this, arguments);
}
function $42943e3e55c7cf39$var$_callLoaderOrAction() {
    $42943e3e55c7cf39$var$_callLoaderOrAction = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
        var resultType, result, onReject, runHandler, handler, handlerError, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, queryRouteResponse, data, contentType, _result$init, _result$init2;
        return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            $42943e3e55c7cf39$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    if (handlerError) throw handlerError;
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $42943e3e55c7cf39$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $42943e3e55c7cf39$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $42943e3e55c7cf39$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $42943e3e55c7cf39$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $42943e3e55c7cf39$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $42943e3e55c7cf39$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$42943e3e55c7cf39$var$isResponse(result)) return [
                        3,
                        19
                    ];
                    status = result.status;
                    // Process redirects
                    if ($42943e3e55c7cf39$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $42943e3e55c7cf39$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$42943e3e55c7cf39$var$ABSOLUTE_URL_REGEX.test(location)) location = $42943e3e55c7cf39$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
                        else if (!opts.isStaticRequest) {
                            // Strip off the protocol+origin for same-origin + same-basename absolute
                            // redirects. If this is a static request, we can let it go back to the
                            // browser as-is
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $42943e3e55c7cf39$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $42943e3e55c7cf39$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) {
                        queryRouteResponse = {
                            type: resultType === $42943e3e55c7cf39$var$ResultType.error ? $42943e3e55c7cf39$var$ResultType.error : $42943e3e55c7cf39$var$ResultType.data,
                            response: result
                        };
                        throw queryRouteResponse;
                    }
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        result.json()
                    ];
                case 15:
                    data = _state.sent();
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.text()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    if (resultType === $42943e3e55c7cf39$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $42943e3e55c7cf39$export$6c6580e81da25755(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $42943e3e55c7cf39$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 19:
                    if (resultType === $42943e3e55c7cf39$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($42943e3e55c7cf39$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $42943e3e55c7cf39$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $42943e3e55c7cf39$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $42943e3e55c7cf39$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $42943e3e55c7cf39$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($42943e3e55c7cf39$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $42943e3e55c7cf39$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $42943e3e55c7cf39$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $42943e3e55c7cf39$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $g9pLc._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $42943e3e55c7cf39$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $g9pLc._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $42943e3e55c7cf39$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $42943e3e55c7cf39$export$3e9cee6b33872309(!$42943e3e55c7cf39$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($42943e3e55c7cf39$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $42943e3e55c7cf39$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $42943e3e55c7cf39$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($42943e3e55c7cf39$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $42943e3e55c7cf39$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $42943e3e55c7cf39$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $42943e3e55c7cf39$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($42943e3e55c7cf39$var$isErrorResult(result)) {
            var boundaryMatch = $42943e3e55c7cf39$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $42943e3e55c7cf39$var$_extends({}, errors, (0, $fkQxX._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($42943e3e55c7cf39$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $42943e3e55c7cf39$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($42943e3e55c7cf39$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $42943e3e55c7cf39$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $42943e3e55c7cf39$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $42943e3e55c7cf39$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $42943e3e55c7cf39$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $42943e3e55c7cf39$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $3wcuq._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $42943e3e55c7cf39$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $42943e3e55c7cf39$var$getInternalRouterError(status, _temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $42943e3e55c7cf39$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $42943e3e55c7cf39$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($42943e3e55c7cf39$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $42943e3e55c7cf39$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $42943e3e55c7cf39$export$8ccf933b0513f8d0(path) : path;
    return $42943e3e55c7cf39$export$fe53371bee54353d($42943e3e55c7cf39$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $42943e3e55c7cf39$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $42943e3e55c7cf39$var$isDeferredResult(result) {
    return result.type === $42943e3e55c7cf39$var$ResultType.deferred;
}
function $42943e3e55c7cf39$var$isErrorResult(result) {
    return result.type === $42943e3e55c7cf39$var$ResultType.error;
}
function $42943e3e55c7cf39$var$isRedirectResult(result) {
    return (result && result.type) === $42943e3e55c7cf39$var$ResultType.redirect;
}
function $42943e3e55c7cf39$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $42943e3e55c7cf39$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $42943e3e55c7cf39$var$isRedirectResponse(result) {
    if (!$42943e3e55c7cf39$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $42943e3e55c7cf39$var$isQueryRouteResponse(obj) {
    return obj && $42943e3e55c7cf39$var$isResponse(obj.response) && (obj.type === $42943e3e55c7cf39$var$ResultType.data || obj.type === $42943e3e55c7cf39$var$ResultType.error);
}
function $42943e3e55c7cf39$var$isValidMethod(method) {
    return $42943e3e55c7cf39$var$validRequestMethods.has(method.toLowerCase());
}
function $42943e3e55c7cf39$var$isMutationMethod(method) {
    return $42943e3e55c7cf39$var$validMutationMethods.has(method.toLowerCase());
}
function $42943e3e55c7cf39$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $42943e3e55c7cf39$var$_resolveDeferredResults.apply(this, arguments);
}
function $42943e3e55c7cf39$var$_resolveDeferredResults() {
    $42943e3e55c7cf39$var$_resolveDeferredResults = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$42943e3e55c7cf39$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($42943e3e55c7cf39$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $42943e3e55c7cf39$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $42943e3e55c7cf39$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $3529a7406e1ba74f$export$19a8beecd37a4c45)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $42943e3e55c7cf39$var$_resolveDeferredResults.apply(this, arguments);
}
function $42943e3e55c7cf39$var$resolveDeferredData(result, signal, unwrap) {
    return $42943e3e55c7cf39$var$_resolveDeferredData.apply(this, arguments);
}
function $42943e3e55c7cf39$var$_resolveDeferredData() {
    $42943e3e55c7cf39$var$_resolveDeferredData = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(result, signal, unwrap) {
        var aborted;
        return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $42943e3e55c7cf39$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $42943e3e55c7cf39$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $42943e3e55c7cf39$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $42943e3e55c7cf39$var$_resolveDeferredData.apply(this, arguments);
}
function $42943e3e55c7cf39$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $42943e3e55c7cf39$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $42943e3e55c7cf39$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $42943e3e55c7cf39$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $42943e3e55c7cf39$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $42943e3e55c7cf39$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $42943e3e55c7cf39$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $42943e3e55c7cf39$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $42943e3e55c7cf39$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $42943e3e55c7cf39$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $42943e3e55c7cf39$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $42943e3e55c7cf39$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($42943e3e55c7cf39$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $g9pLc._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $42943e3e55c7cf39$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $g9pLc._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $3wcuq._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($42943e3e55c7cf39$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $42943e3e55c7cf39$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8cfPm = parcelRequire("8cfPm");

var $953s6 = parcelRequire("953s6");

var $feZkv = parcelRequire("feZkv");

var $g9pLc = parcelRequire("g9pLc");

var $3wcuq = parcelRequire("3wcuq");

var $6ZKiV = parcelRequire("6ZKiV");

var $f6C7p = parcelRequire("f6C7p");

function $b50ff877aba8fe4d$var$_extends() {
    $b50ff877aba8fe4d$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b50ff877aba8fe4d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $b50ff877aba8fe4d$export$3add0d5dce533e2e = /*#__PURE__*/ $f6C7p.createContext(null);
var $b50ff877aba8fe4d$export$145dfa71566a64dc = /*#__PURE__*/ $f6C7p.createContext(null);
var $b50ff877aba8fe4d$var$AwaitContext = /*#__PURE__*/ $f6C7p.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $b50ff877aba8fe4d$export$26749e8557646306 = /*#__PURE__*/ $f6C7p.createContext(null);
var $b50ff877aba8fe4d$export$c7914228fb69b0f5 = /*#__PURE__*/ $f6C7p.createContext(null);
var $b50ff877aba8fe4d$export$9072aa6dd1f93057 = /*#__PURE__*/ $f6C7p.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $b50ff877aba8fe4d$var$RouteErrorContext = /*#__PURE__*/ $f6C7p.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $b50ff877aba8fe4d$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$b50ff877aba8fe4d$export$9c954a9d03d32f4a() && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    var _React_useContext = $f6C7p.useContext($b50ff877aba8fe4d$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $b50ff877aba8fe4d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $42943e3e55c7cf39$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $b50ff877aba8fe4d$export$9c954a9d03d32f4a() {
    return $f6C7p.useContext($b50ff877aba8fe4d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $b50ff877aba8fe4d$export$45d76561a5302f2b() {
    !$b50ff877aba8fe4d$export$9c954a9d03d32f4a() && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    return $f6C7p.useContext($b50ff877aba8fe4d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $b50ff877aba8fe4d$export$1b3f31771c5d07c() {
    return $f6C7p.useContext($b50ff877aba8fe4d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $b50ff877aba8fe4d$export$6c330e8992e8a295(pattern) {
    !$b50ff877aba8fe4d$export$9c954a9d03d32f4a() && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    var pathname = $b50ff877aba8fe4d$export$45d76561a5302f2b().pathname;
    return $f6C7p.useMemo(function() {
        return (0, $42943e3e55c7cf39$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $b50ff877aba8fe4d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $b50ff877aba8fe4d$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $f6C7p.useContext($b50ff877aba8fe4d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $f6C7p.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $b50ff877aba8fe4d$export$9770f232ac06a008() {
    var isDataRoute = $f6C7p.useContext($b50ff877aba8fe4d$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $b50ff877aba8fe4d$var$useNavigateStable() : $b50ff877aba8fe4d$var$useNavigateUnstable();
}
function $b50ff877aba8fe4d$var$useNavigateUnstable() {
    !$b50ff877aba8fe4d$export$9c954a9d03d32f4a() && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    var dataRouterContext = $f6C7p.useContext($b50ff877aba8fe4d$export$3add0d5dce533e2e);
    var _React_useContext = $f6C7p.useContext($b50ff877aba8fe4d$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var matches = $f6C7p.useContext($b50ff877aba8fe4d$export$9072aa6dd1f93057).matches;
    var _useLocation = $b50ff877aba8fe4d$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $42943e3e55c7cf39$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    var activeRef = $f6C7p.useRef(false);
    $b50ff877aba8fe4d$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $f6C7p.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $42943e3e55c7cf39$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $42943e3e55c7cf39$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $b50ff877aba8fe4d$var$OutletContext = /*#__PURE__*/ $f6C7p.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $b50ff877aba8fe4d$export$4138103a3ae699cc() {
    return $f6C7p.useContext($b50ff877aba8fe4d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $b50ff877aba8fe4d$export$a3be3530d8e40d0b(context) {
    var outlet = $f6C7p.useContext($b50ff877aba8fe4d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $b50ff877aba8fe4d$export$99eaa27ddbbb95ef() {
    var matches = $f6C7p.useContext($b50ff877aba8fe4d$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $b50ff877aba8fe4d$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var matches = $f6C7p.useContext($b50ff877aba8fe4d$export$9072aa6dd1f93057).matches;
    var _useLocation = $b50ff877aba8fe4d$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $42943e3e55c7cf39$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    return $f6C7p.useMemo(function() {
        return (0, $42943e3e55c7cf39$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $b50ff877aba8fe4d$export$5d3fca4a98652595(routes, locationArg) {
    return $b50ff877aba8fe4d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $b50ff877aba8fe4d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$b50ff877aba8fe4d$export$9c954a9d03d32f4a() && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    var navigator = $f6C7p.useContext($b50ff877aba8fe4d$export$26749e8557646306).navigator;
    var _React_useContext = $f6C7p.useContext($b50ff877aba8fe4d$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $b50ff877aba8fe4d$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $42943e3e55c7cf39$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $42943e3e55c7cf39$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $b50ff877aba8fe4d$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $42943e3e55c7cf39$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $42943e3e55c7cf39$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $b50ff877aba8fe4d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $42943e3e55c7cf39$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b50ff877aba8fe4d$var$DefaultErrorComponent() {
    var error = $b50ff877aba8fe4d$export$ed527bf60f6e05f2();
    var message = (0, $42943e3e55c7cf39$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $f6C7p.createElement($f6C7p.Fragment, null, /*#__PURE__*/ $f6C7p.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $f6C7p.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $f6C7p.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $b50ff877aba8fe4d$var$defaultErrorElement = /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$var$DefaultErrorComponent, null);
var $b50ff877aba8fe4d$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $feZkv._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $6ZKiV._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $8cfPm._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $953s6._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error || state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($f6C7p.Component);
function $b50ff877aba8fe4d$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $f6C7p.useContext($b50ff877aba8fe4d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $b50ff877aba8fe4d$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        var errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $b50ff877aba8fe4d$var$defaultErrorElement;
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $f6C7p.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $b50ff877aba8fe4d$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($b50ff877aba8fe4d$var$DataRouterHook || {});
var $b50ff877aba8fe4d$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($b50ff877aba8fe4d$var$DataRouterStateHook || {});
function $b50ff877aba8fe4d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b50ff877aba8fe4d$var$useDataRouterContext(hookName) {
    var ctx = $f6C7p.useContext($b50ff877aba8fe4d$export$3add0d5dce533e2e);
    !ctx && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b50ff877aba8fe4d$var$useDataRouterState(hookName) {
    var state = $f6C7p.useContext($b50ff877aba8fe4d$export$145dfa71566a64dc);
    !state && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    return state;
}
function $b50ff877aba8fe4d$var$useRouteContext(hookName) {
    var route = $f6C7p.useContext($b50ff877aba8fe4d$export$9072aa6dd1f93057);
    !route && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $b50ff877aba8fe4d$var$useCurrentRouteId(hookName) {
    var route = $b50ff877aba8fe4d$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $b50ff877aba8fe4d$export$5fc8298006ad9e58() {
    return $b50ff877aba8fe4d$var$useCurrentRouteId($b50ff877aba8fe4d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $b50ff877aba8fe4d$export$d0fd4b7106de2769() {
    var state = $b50ff877aba8fe4d$var$useDataRouterState($b50ff877aba8fe4d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $b50ff877aba8fe4d$export$600dc272ed516c15() {
    var dataRouterContext = $b50ff877aba8fe4d$var$useDataRouterContext($b50ff877aba8fe4d$var$DataRouterHook.UseRevalidator);
    var state = $b50ff877aba8fe4d$var$useDataRouterState($b50ff877aba8fe4d$var$DataRouterStateHook.UseRevalidator);
    return $f6C7p.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $b50ff877aba8fe4d$export$2378eb7f5ff86053() {
    var _useDataRouterState = $b50ff877aba8fe4d$var$useDataRouterState($b50ff877aba8fe4d$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $f6C7p.useMemo(function() {
        return matches.map(function(m) {
            return (0, $42943e3e55c7cf39$export$b3fac024fad9e8ff)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $b50ff877aba8fe4d$export$1448a5050d252c4d() {
    var state = $b50ff877aba8fe4d$var$useDataRouterState($b50ff877aba8fe4d$var$DataRouterStateHook.UseLoaderData);
    var routeId = $b50ff877aba8fe4d$var$useCurrentRouteId($b50ff877aba8fe4d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $b50ff877aba8fe4d$export$fd5d37484eab868d(routeId) {
    var state = $b50ff877aba8fe4d$var$useDataRouterState($b50ff877aba8fe4d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $b50ff877aba8fe4d$export$fdc00f3f26066d5e() {
    var state = $b50ff877aba8fe4d$var$useDataRouterState($b50ff877aba8fe4d$var$DataRouterStateHook.UseActionData);
    var route = $f6C7p.useContext($b50ff877aba8fe4d$export$9072aa6dd1f93057);
    !route && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $b50ff877aba8fe4d$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $f6C7p.useContext($b50ff877aba8fe4d$var$RouteErrorContext);
    var state = $b50ff877aba8fe4d$var$useDataRouterState($b50ff877aba8fe4d$var$DataRouterStateHook.UseRouteError);
    var routeId = $b50ff877aba8fe4d$var$useCurrentRouteId($b50ff877aba8fe4d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $b50ff877aba8fe4d$export$78a72ddb39bdd145() {
    var value = $f6C7p.useContext($b50ff877aba8fe4d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $b50ff877aba8fe4d$export$17f53340677d5831() {
    var value = $f6C7p.useContext($b50ff877aba8fe4d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $b50ff877aba8fe4d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $b50ff877aba8fe4d$export$2af03a1de5c0910(shouldBlock) {
    var _useDataRouterContext = $b50ff877aba8fe4d$var$useDataRouterContext($b50ff877aba8fe4d$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $b50ff877aba8fe4d$var$useDataRouterState($b50ff877aba8fe4d$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $g9pLc._)($f6C7p.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $f6C7p.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $b50ff877aba8fe4d$var$_extends({}, currentLocation, {
                pathname: (0, $42943e3e55c7cf39$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $b50ff877aba8fe4d$var$_extends({}, nextLocation, {
                pathname: (0, $42943e3e55c7cf39$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $f6C7p.useEffect(function() {
        var key = String(++$b50ff877aba8fe4d$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $f6C7p.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $42943e3e55c7cf39$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $b50ff877aba8fe4d$var$useNavigateStable() {
    var router = $b50ff877aba8fe4d$var$useDataRouterContext($b50ff877aba8fe4d$var$DataRouterHook.UseNavigateStable).router;
    var id = $b50ff877aba8fe4d$var$useCurrentRouteId($b50ff877aba8fe4d$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $f6C7p.useRef(false);
    $b50ff877aba8fe4d$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $f6C7p.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $b50ff877aba8fe4d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $b50ff877aba8fe4d$var$alreadyWarned = {};
function $b50ff877aba8fe4d$var$warningOnce(key, cond, message) {
    if (!cond && !$b50ff877aba8fe4d$var$alreadyWarned[key]) $b50ff877aba8fe4d$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $b50ff877aba8fe4d$var$START_TRANSITION = "startTransition";
var $b50ff877aba8fe4d$var$startTransitionImpl = $f6C7p[$b50ff877aba8fe4d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b50ff877aba8fe4d$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $g9pLc._)($f6C7p.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $f6C7p.useCallback(function(newState) {
        if (v7_startTransition && $b50ff877aba8fe4d$var$startTransitionImpl) $b50ff877aba8fe4d$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $f6C7p.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    var navigator = $f6C7p.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $f6C7p.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $f6C7p.createElement($f6C7p.Fragment, null, /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $b50ff877aba8fe4d$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, state = _ref2.state;
    return $b50ff877aba8fe4d$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $b50ff877aba8fe4d$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $f6C7p.useRef();
    if (historyRef.current == null) historyRef.current = (0, $42943e3e55c7cf39$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $g9pLc._)($f6C7p.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $f6C7p.useCallback(function(newState) {
        v7_startTransition && $b50ff877aba8fe4d$var$startTransitionImpl ? $b50ff877aba8fe4d$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $f6C7p.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $b50ff877aba8fe4d$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$b50ff877aba8fe4d$export$9c954a9d03d32f4a() && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    var matches = $f6C7p.useContext($b50ff877aba8fe4d$export$9072aa6dd1f93057).matches;
    var _useLocation = $b50ff877aba8fe4d$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $b50ff877aba8fe4d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $42943e3e55c7cf39$export$cae722b0cc860f13)(to, (0, $42943e3e55c7cf39$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $f6C7p.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $b50ff877aba8fe4d$export$910ae8079b2c2852(props) {
    return $b50ff877aba8fe4d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $b50ff877aba8fe4d$export$e7b0ac011bb776c6(_props) {
    (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $b50ff877aba8fe4d$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $42943e3e55c7cf39$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1;
    !!$b50ff877aba8fe4d$export$9c954a9d03d32f4a() && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $f6C7p.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $42943e3e55c7cf39$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $f6C7p.useMemo(function() {
        var trailingPathname = (0, $42943e3e55c7cf39$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $b50ff877aba8fe4d$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $b50ff877aba8fe4d$export$5d3fca4a98652595($b50ff877aba8fe4d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $b50ff877aba8fe4d$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$var$ResolveAwait, null, children));
}
var $b50ff877aba8fe4d$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($b50ff877aba8fe4d$var$AwaitRenderStatus || {});
var $b50ff877aba8fe4d$var$neverSettledPromise = new Promise(function() {});
var $b50ff877aba8fe4d$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $feZkv._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $6ZKiV._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $8cfPm._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $953s6._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $b50ff877aba8fe4d$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $b50ff877aba8fe4d$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $b50ff877aba8fe4d$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $b50ff877aba8fe4d$var$AwaitRenderStatus.error : promise._data !== undefined ? $b50ff877aba8fe4d$var$AwaitRenderStatus.success : $b50ff877aba8fe4d$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $b50ff877aba8fe4d$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $b50ff877aba8fe4d$var$AwaitRenderStatus.error && promise._error instanceof (0, $42943e3e55c7cf39$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $b50ff877aba8fe4d$var$neverSettledPromise;
                if (status === $b50ff877aba8fe4d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $b50ff877aba8fe4d$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $b50ff877aba8fe4d$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $f6C7p.createElement($b50ff877aba8fe4d$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($f6C7p.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $b50ff877aba8fe4d$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $b50ff877aba8fe4d$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $f6C7p.createElement($f6C7p.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $b50ff877aba8fe4d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $f6C7p.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $f6C7p.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $3wcuq._)(parentPath).concat([
            index
        ]);
        if (element.type === $f6C7p.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $b50ff877aba8fe4d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $b50ff877aba8fe4d$export$e7b0ac011bb776c6) && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $b50ff877aba8fe4d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $b50ff877aba8fe4d$export$daf73786167a7f72(matches) {
    return $b50ff877aba8fe4d$var$_renderMatches(matches);
}
function $b50ff877aba8fe4d$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $f6C7p.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $f6C7p.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $b50ff877aba8fe4d$export$f30f7e456d254e83(routes, opts) {
    return (0, $42943e3e55c7cf39$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b50ff877aba8fe4d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $42943e3e55c7cf39$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $b50ff877aba8fe4d$export$52b333d321859367
    }).initialize();
}



function $58d3e9a89be9b556$var$_extends() {
    $58d3e9a89be9b556$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $58d3e9a89be9b556$var$_extends.apply(this, arguments);
}
function $58d3e9a89be9b556$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $58d3e9a89be9b556$var$defaultMethod = "get";
var $58d3e9a89be9b556$var$defaultEncType = "application/x-www-form-urlencoded";
function $58d3e9a89be9b556$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $58d3e9a89be9b556$var$isButtonElement(object) {
    return $58d3e9a89be9b556$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $58d3e9a89be9b556$var$isFormElement(object) {
    return $58d3e9a89be9b556$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $58d3e9a89be9b556$var$isInputElement(object) {
    return $58d3e9a89be9b556$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $58d3e9a89be9b556$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $58d3e9a89be9b556$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$58d3e9a89be9b556$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $58d3e9a89be9b556$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $58d3e9a89be9b556$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $58d3e9a89be9b556$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $58d3e9a89be9b556$var$_formDataSupportsSubmitter = null;
function $58d3e9a89be9b556$var$isFormDataSubmitterSupported() {
    if ($58d3e9a89be9b556$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $58d3e9a89be9b556$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $58d3e9a89be9b556$var$_formDataSupportsSubmitter = true;
    }
    return $58d3e9a89be9b556$var$_formDataSupportsSubmitter;
}
var $58d3e9a89be9b556$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $58d3e9a89be9b556$var$getFormEncType(encType) {
    if (encType != null && !$58d3e9a89be9b556$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $58d3e9a89be9b556$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($58d3e9a89be9b556$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $42943e3e55c7cf39$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $58d3e9a89be9b556$var$defaultMethod;
        encType = $58d3e9a89be9b556$var$getFormEncType(target.getAttribute("enctype")) || $58d3e9a89be9b556$var$defaultEncType;
        formData = new FormData(target);
    } else if ($58d3e9a89be9b556$var$isButtonElement(target) || $58d3e9a89be9b556$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $42943e3e55c7cf39$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $58d3e9a89be9b556$var$defaultMethod;
        encType = $58d3e9a89be9b556$var$getFormEncType(target.getAttribute("formenctype")) || $58d3e9a89be9b556$var$getFormEncType(form.getAttribute("enctype")) || $58d3e9a89be9b556$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$58d3e9a89be9b556$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($58d3e9a89be9b556$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $58d3e9a89be9b556$var$defaultMethod;
        action = null;
        encType = $58d3e9a89be9b556$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $58d3e9a89be9b556$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $58d3e9a89be9b556$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $58d3e9a89be9b556$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $58d3e9a89be9b556$export$1f3f55432a00e06d(routes, opts) {
    return (0, $42943e3e55c7cf39$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $58d3e9a89be9b556$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $42943e3e55c7cf39$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $58d3e9a89be9b556$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b50ff877aba8fe4d$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $58d3e9a89be9b556$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $42943e3e55c7cf39$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $58d3e9a89be9b556$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $42943e3e55c7cf39$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $58d3e9a89be9b556$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b50ff877aba8fe4d$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $58d3e9a89be9b556$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $58d3e9a89be9b556$var$_extends({}, state, {
        errors: $58d3e9a89be9b556$var$deserializeErrors(state.errors)
    });
    return state;
}
function $58d3e9a89be9b556$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $g9pLc._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $42943e3e55c7cf39$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $58d3e9a89be9b556$export$7ad602f0e94e62d1 = /*#__PURE__*/ $f6C7p.createContext({
    isTransitioning: false
});
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $58d3e9a89be9b556$var$START_TRANSITION = "startTransition";
var $58d3e9a89be9b556$var$startTransitionImpl = $f6C7p[$58d3e9a89be9b556$var$START_TRANSITION];
function $58d3e9a89be9b556$var$startTransitionSafe(cb) {
    if ($58d3e9a89be9b556$var$startTransitionImpl) $58d3e9a89be9b556$var$startTransitionImpl(cb);
    else cb();
}
var $58d3e9a89be9b556$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $8cfPm._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $58d3e9a89be9b556$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $g9pLc._)($f6C7p.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $g9pLc._)($f6C7p.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $g9pLc._)($f6C7p.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $g9pLc._)($f6C7p.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $g9pLc._)($f6C7p.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $g9pLc._)($f6C7p.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $f6C7p.useCallback(function(cb) {
        if (v7_startTransition) $58d3e9a89be9b556$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $f6C7p.useCallback(function(newState, _ref2) {
        var viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        if (!viewTransitionOpts || router.window == null || typeof router.window.document.startViewTransition !== "function") // Mid-navigation state update, or startViewTransition isn't available
        optInStartTransition(function() {
            return setStateImpl(newState);
        });
        else if (transition && renderDfd) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        optInStartTransition,
        transition,
        renderDfd,
        router.window
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $f6C7p.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $f6C7p.useEffect(function() {
        if (vtContext.isTransitioning) setRenderDfd(new $58d3e9a89be9b556$var$Deferred());
    }, [
        vtContext.isTransitioning
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $f6C7p.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $39e0c52944643fcc$export$7c398597f8905a1)(function() {
                return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $f6C7p.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $f6C7p.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    var navigator = $f6C7p.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $f6C7p.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $f6C7p.createElement($f6C7p.Fragment, null, /*#__PURE__*/ $f6C7p.createElement((0, $b50ff877aba8fe4d$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $f6C7p.createElement((0, $b50ff877aba8fe4d$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $f6C7p.createElement($58d3e9a89be9b556$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $f6C7p.createElement((0, $b50ff877aba8fe4d$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $f6C7p.createElement($58d3e9a89be9b556$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement)))), null);
}
function $58d3e9a89be9b556$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, state = _ref3.state;
    return (0, $b50ff877aba8fe4d$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $58d3e9a89be9b556$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $f6C7p.useRef();
    if (historyRef.current == null) historyRef.current = (0, $42943e3e55c7cf39$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $g9pLc._)($f6C7p.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $f6C7p.useCallback(function(newState) {
        v7_startTransition && $58d3e9a89be9b556$var$startTransitionImpl ? $58d3e9a89be9b556$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $f6C7p.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $f6C7p.createElement((0, $b50ff877aba8fe4d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $58d3e9a89be9b556$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $f6C7p.useRef();
    if (historyRef.current == null) historyRef.current = (0, $42943e3e55c7cf39$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $g9pLc._)($f6C7p.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $f6C7p.useCallback(function(newState) {
        v7_startTransition && $58d3e9a89be9b556$var$startTransitionImpl ? $58d3e9a89be9b556$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $f6C7p.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $f6C7p.createElement((0, $b50ff877aba8fe4d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $58d3e9a89be9b556$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $g9pLc._)($f6C7p.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $f6C7p.useCallback(function(newState) {
        v7_startTransition && $58d3e9a89be9b556$var$startTransitionImpl ? $58d3e9a89be9b556$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $f6C7p.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $f6C7p.createElement((0, $b50ff877aba8fe4d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
var $58d3e9a89be9b556$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $58d3e9a89be9b556$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $58d3e9a89be9b556$export$a6c7ac8248d6e38a = /*#__PURE__*/ $f6C7p.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $58d3e9a89be9b556$var$_objectWithoutPropertiesLoose(_ref7, $58d3e9a89be9b556$var$_excluded);
    var basename = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $58d3e9a89be9b556$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($58d3e9a89be9b556$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $42943e3e55c7cf39$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $b50ff877aba8fe4d$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $58d3e9a89be9b556$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $f6C7p.createElement("a", $58d3e9a89be9b556$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $58d3e9a89be9b556$export$b0d92dbee9b5b60d = /*#__PURE__*/ $f6C7p.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $58d3e9a89be9b556$var$_objectWithoutPropertiesLoose(_ref8, $58d3e9a89be9b556$var$_excluded2);
    var path = (0, $b50ff877aba8fe4d$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $b50ff877aba8fe4d$export$45d76561a5302f2b)();
    var routerState = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$145dfa71566a64dc));
    var navigator = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$26749e8557646306)).navigator;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $58d3e9a89be9b556$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $f6C7p.createElement($58d3e9a89be9b556$export$a6c7ac8248d6e38a, $58d3e9a89be9b556$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $58d3e9a89be9b556$export$a7fed597f4b8afd8 = /*#__PURE__*/ $f6C7p.forwardRef(function(props, ref) {
    var submit = $58d3e9a89be9b556$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $f6C7p.createElement($58d3e9a89be9b556$var$FormImpl, $58d3e9a89be9b556$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
var $58d3e9a89be9b556$var$FormImpl = /*#__PURE__*/ $f6C7p.forwardRef(function(_ref9, forwardedRef) {
    var reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $58d3e9a89be9b556$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, submit = _ref9.submit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $58d3e9a89be9b556$var$_objectWithoutPropertiesLoose(_ref9, $58d3e9a89be9b556$var$_excluded3);
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var formAction = $58d3e9a89be9b556$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $f6C7p.createElement("form", $58d3e9a89be9b556$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $58d3e9a89be9b556$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $58d3e9a89be9b556$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $58d3e9a89be9b556$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($58d3e9a89be9b556$var$DataRouterHook || ($58d3e9a89be9b556$var$DataRouterHook = {}));
var $58d3e9a89be9b556$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($58d3e9a89be9b556$var$DataRouterStateHook || ($58d3e9a89be9b556$var$DataRouterStateHook = {}));
function $58d3e9a89be9b556$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $58d3e9a89be9b556$var$useDataRouterContext(hookName) {
    var ctx = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$3add0d5dce533e2e));
    !ctx && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    return ctx;
}
function $58d3e9a89be9b556$var$useDataRouterState(hookName) {
    var state = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$145dfa71566a64dc));
    !state && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $58d3e9a89be9b556$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $b50ff877aba8fe4d$export$9770f232ac06a008)();
    var location = (0, $b50ff877aba8fe4d$export$45d76561a5302f2b)();
    var path = (0, $b50ff877aba8fe4d$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $f6C7p.useCallback(function(event) {
        if ($58d3e9a89be9b556$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $42943e3e55c7cf39$export$fe53371bee54353d)(location) === (0, $42943e3e55c7cf39$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $58d3e9a89be9b556$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $f6C7p.useRef($58d3e9a89be9b556$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $f6C7p.useRef(false);
    var location = (0, $b50ff877aba8fe4d$export$45d76561a5302f2b)();
    var searchParams = $f6C7p.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $58d3e9a89be9b556$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $b50ff877aba8fe4d$export$9770f232ac06a008)();
    var setSearchParams = $f6C7p.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $58d3e9a89be9b556$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $58d3e9a89be9b556$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $58d3e9a89be9b556$export$47c85c6e3a081d3() {
    var router = $58d3e9a89be9b556$var$useDataRouterContext($58d3e9a89be9b556$var$DataRouterHook.UseSubmit).router;
    var basename = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$26749e8557646306)).basename;
    var currentRouteId = (0, $b50ff877aba8fe4d$export$5fc8298006ad9e58)();
    return $f6C7p.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $58d3e9a89be9b556$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $58d3e9a89be9b556$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $58d3e9a89be9b556$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    var router = $58d3e9a89be9b556$var$useDataRouterContext($58d3e9a89be9b556$var$DataRouterHook.UseSubmitFetcher).router;
    var basename = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$26749e8557646306)).basename;
    return $f6C7p.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $58d3e9a89be9b556$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $58d3e9a89be9b556$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        !(fetcherRouteId != null) && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $58d3e9a89be9b556$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$26749e8557646306)).basename;
    var routeContext = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$9072aa6dd1f93057));
    !routeContext && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $g9pLc._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $58d3e9a89be9b556$var$_extends({}, (0, $b50ff877aba8fe4d$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $b50ff877aba8fe4d$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            var params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $42943e3e55c7cf39$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $42943e3e55c7cf39$export$fe53371bee54353d)(path);
}
function $58d3e9a89be9b556$var$createFetcherForm(fetcherKey, routeId) {
    var FetcherForm = /*#__PURE__*/ $f6C7p.forwardRef(function(props, ref) {
        var submit = $58d3e9a89be9b556$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $f6C7p.createElement($58d3e9a89be9b556$var$FormImpl, $58d3e9a89be9b556$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
var $58d3e9a89be9b556$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $58d3e9a89be9b556$export$5b0d2d9a9921565a() {
    var _route$matches;
    var router = $58d3e9a89be9b556$var$useDataRouterContext($58d3e9a89be9b556$var$DataRouterHook.UseFetcher).router;
    var route = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$9072aa6dd1f93057));
    !route && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    var _React_useState = (0, $g9pLc._)($f6C7p.useState(function() {
        return String(++$58d3e9a89be9b556$var$fetcherId);
    }), 1), fetcherKey = _React_useState[0];
    var _React_useState1 = (0, $g9pLc._)($f6C7p.useState(function() {
        !routeId && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
        return $58d3e9a89be9b556$var$createFetcherForm(fetcherKey, routeId);
    }), 1), Form = _React_useState1[0];
    var _React_useState2 = (0, $g9pLc._)($f6C7p.useState(function() {
        return function(href) {
            !router && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
            !routeId && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        };
    }), 1), load = _React_useState2[0];
    var submit = $58d3e9a89be9b556$var$useSubmitFetcher(fetcherKey, routeId);
    var fetcher = router.getFetcher(fetcherKey);
    var fetcherWithComponents = $f6C7p.useMemo(function() {
        return $58d3e9a89be9b556$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher);
    }, [
        fetcher,
        Form,
        submit,
        load
    ]);
    $f6C7p.useEffect(function() {
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return function() {
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $58d3e9a89be9b556$export$fa996778a3a31087() {
    var state = $58d3e9a89be9b556$var$useDataRouterState($58d3e9a89be9b556$var$DataRouterStateHook.UseFetchers);
    return (0, $3wcuq._)(state.fetchers.values());
}
var $58d3e9a89be9b556$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $58d3e9a89be9b556$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $58d3e9a89be9b556$export$25057cfe5591e3e9(_temp3) {
    var _ref = _temp3 === void 0 ? {} : _temp3, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $58d3e9a89be9b556$var$useDataRouterContext($58d3e9a89be9b556$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $58d3e9a89be9b556$var$useDataRouterState($58d3e9a89be9b556$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $f6C7p.useContext((0, $b50ff877aba8fe4d$export$26749e8557646306)).basename;
    var location = (0, $b50ff877aba8fe4d$export$45d76561a5302f2b)();
    var matches = (0, $b50ff877aba8fe4d$export$2378eb7f5ff86053)();
    var navigation = (0, $b50ff877aba8fe4d$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $f6C7p.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $58d3e9a89be9b556$var$usePageHide($f6C7p.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $58d3e9a89be9b556$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $58d3e9a89be9b556$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($58d3e9a89be9b556$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $f6C7p.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $58d3e9a89be9b556$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $58d3e9a89be9b556$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $f6C7p.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($58d3e9a89be9b556$var$_extends({}, location, {
                    pathname: (0, $42943e3e55c7cf39$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($58d3e9a89be9b556$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $f6C7p.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $58d3e9a89be9b556$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $f6C7p.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $58d3e9a89be9b556$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $f6C7p.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $58d3e9a89be9b556$export$39f4eb3dbd812741(_ref11) {
    var when = _ref11.when, message = _ref11.message;
    var blocker = (0, $b50ff877aba8fe4d$export$2af03a1de5c0910)(when);
    $f6C7p.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $f6C7p.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $58d3e9a89be9b556$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $f6C7p.useContext($58d3e9a89be9b556$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $42943e3e55c7cf39$export$3e9cee6b33872309)(false);
    var basename = $58d3e9a89be9b556$var$useDataRouterContext($58d3e9a89be9b556$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $b50ff877aba8fe4d$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $42943e3e55c7cf39$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $42943e3e55c7cf39$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $42943e3e55c7cf39$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $42943e3e55c7cf39$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $g9pLc = parcelRequire("g9pLc");

var $f6C7p = parcelRequire("f6C7p");
var $f36ca4ab89a742dc$var$useOnlineStatus = function() {
    var _useState = (0, $g9pLc._)((0, $f6C7p.useState)(true), 2), onlineStatus = _useState[0], setOnlineStatus = _useState[1];
    // check online status
    (0, $f6C7p.useEffect)(function() {
        window.addEventListener("offline", function() {
            setOnlineStatus(false);
        });
        window.addEventListener("online", function() {
            setOnlineStatus(true);
        });
    }, []);
    return onlineStatus;
};
var $f36ca4ab89a742dc$export$2e2bcd8739ae039 = $f36ca4ab89a742dc$var$useOnlineStatus;



var $f6C7p = parcelRequire("f6C7p");
var $cb9202d36b904eb0$var$UserContext = /*#__PURE__*/ (0, $f6C7p.createContext)({
    loggedInUser: "Default User"
});
var $cb9202d36b904eb0$export$2e2bcd8739ae039 = $cb9202d36b904eb0$var$UserContext;



var $fkQxX = parcelRequire("fkQxX");

var $g9pLc = parcelRequire("g9pLc");

var $3wcuq = parcelRequire("3wcuq");

var $7fjaO = parcelRequire("7fjaO");

var $f6C7p = parcelRequire("f6C7p");
var $9f3c8ce1dab1a2ba$exports = {};
"use strict";

$9f3c8ce1dab1a2ba$exports = (parcelRequire("b48eP"));



var $19813643f60dbb4e$var$__defProp = Object.defineProperty;
var $19813643f60dbb4e$var$__defProps = Object.defineProperties;
var $19813643f60dbb4e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $19813643f60dbb4e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $19813643f60dbb4e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $19813643f60dbb4e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $19813643f60dbb4e$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $19813643f60dbb4e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $19813643f60dbb4e$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($19813643f60dbb4e$var$__hasOwnProp.call(b, prop)) $19813643f60dbb4e$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($19813643f60dbb4e$var$__getOwnPropSymbols) try {
        for(var _iterator = $19813643f60dbb4e$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($19813643f60dbb4e$var$__propIsEnum.call(b, prop)) $19813643f60dbb4e$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $19813643f60dbb4e$var$__spreadProps = function(a, b) {
    return $19813643f60dbb4e$var$__defProps(a, $19813643f60dbb4e$var$__getOwnPropDescs(b));
};
var $19813643f60dbb4e$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($19813643f60dbb4e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $19813643f60dbb4e$var$__getOwnPropSymbols) try {
        for(var _iterator = $19813643f60dbb4e$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $19813643f60dbb4e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
// src/utils/batch.ts
function $19813643f60dbb4e$var$defaultNoopBatch(callback) {
    callback();
}
var $19813643f60dbb4e$var$batch = $19813643f60dbb4e$var$defaultNoopBatch;
var $19813643f60dbb4e$var$setBatch = function(newBatch) {
    return $19813643f60dbb4e$var$batch = newBatch;
};
var $19813643f60dbb4e$var$getBatch = function() {
    return $19813643f60dbb4e$var$batch;
};
var $19813643f60dbb4e$var$React = // prettier-ignore
// @ts-ignore
"default" in $f6C7p ? $f6C7p["default"] : $f6C7p;
// src/components/Context.ts
var $19813643f60dbb4e$var$ContextKey = Symbol.for("react-redux-context");
var $19813643f60dbb4e$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $19813643f60dbb4e$var$getContext() {
    var _a;
    if (!$19813643f60dbb4e$var$React.createContext) return {};
    var contextMap = (_a = $19813643f60dbb4e$var$gT[$19813643f60dbb4e$var$ContextKey]) != null ? _a : $19813643f60dbb4e$var$gT[$19813643f60dbb4e$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($19813643f60dbb4e$var$React.createContext);
    if (!realContext) {
        realContext = $19813643f60dbb4e$var$React.createContext(null);
        contextMap.set($19813643f60dbb4e$var$React.createContext, realContext);
    }
    return realContext;
}
var $19813643f60dbb4e$export$cc80c08dc91f1c00 = /* @__PURE__ */ $19813643f60dbb4e$var$getContext();
// src/utils/useSyncExternalStore.ts
var $19813643f60dbb4e$var$notInitialized = function() {
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $19813643f60dbb4e$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $19813643f60dbb4e$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $19813643f60dbb4e$var$React.useContext(context);
        return contextValue;
    };
}
var $19813643f60dbb4e$var$useReduxContext = /* @__PURE__ */ $19813643f60dbb4e$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $19813643f60dbb4e$var$useSyncExternalStoreWithSelector = $19813643f60dbb4e$var$notInitialized;
var $19813643f60dbb4e$var$initializeUseSelector = function(fn) {
    $19813643f60dbb4e$var$useSyncExternalStoreWithSelector = fn;
};
var $19813643f60dbb4e$var$refEquality = function(a, b) {
    return a === b;
};
function $19813643f60dbb4e$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $19813643f60dbb4e$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $19813643f60dbb4e$export$cc80c08dc91f1c00 ? $19813643f60dbb4e$var$useReduxContext : $19813643f60dbb4e$var$createReduxContextHook(context);
    return function useSelector2(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $19813643f60dbb4e$var$refEquality : _ref_equalityFn, _ref_devModeChecks = _ref.devModeChecks, devModeChecks = _ref_devModeChecks === void 0 ? {} : _ref_devModeChecks;
        var _useReduxContext2 = useReduxContext2(), store = _useReduxContext2.store, subscription = _useReduxContext2.subscription, getServerState = _useReduxContext2.getServerState, stabilityCheck = _useReduxContext2.stabilityCheck, identityFunctionCheck = _useReduxContext2.identityFunctionCheck;
        var firstRun = $19813643f60dbb4e$var$React.useRef(true);
        var wrappedSelector = $19813643f60dbb4e$var$React.useCallback((0, $fkQxX._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        var selectedState = $19813643f60dbb4e$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $19813643f60dbb4e$var$React.useDebugValue(selectedState);
        return selectedState;
    };
}
var $19813643f60dbb4e$export$2105062e25df4afe = /* @__PURE__ */ $19813643f60dbb4e$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $19813643f60dbb4e$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $19813643f60dbb4e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $19813643f60dbb4e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $19813643f60dbb4e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $19813643f60dbb4e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $19813643f60dbb4e$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $19813643f60dbb4e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $19813643f60dbb4e$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $19813643f60dbb4e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $19813643f60dbb4e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $19813643f60dbb4e$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $19813643f60dbb4e$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $19813643f60dbb4e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $19813643f60dbb4e$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $19813643f60dbb4e$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $19813643f60dbb4e$var$ForwardRef = $19813643f60dbb4e$var$REACT_FORWARD_REF_TYPE;
var $19813643f60dbb4e$var$Memo = $19813643f60dbb4e$var$REACT_MEMO_TYPE;
function $19813643f60dbb4e$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $19813643f60dbb4e$var$REACT_FRAGMENT_TYPE || type === $19813643f60dbb4e$var$REACT_PROFILER_TYPE || type === $19813643f60dbb4e$var$REACT_STRICT_MODE_TYPE || type === $19813643f60dbb4e$var$REACT_SUSPENSE_TYPE || type === $19813643f60dbb4e$var$REACT_SUSPENSE_LIST_TYPE || type === $19813643f60dbb4e$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $19813643f60dbb4e$var$REACT_LAZY_TYPE || type.$$typeof === $19813643f60dbb4e$var$REACT_MEMO_TYPE || type.$$typeof === $19813643f60dbb4e$var$REACT_PROVIDER_TYPE || type.$$typeof === $19813643f60dbb4e$var$REACT_CONTEXT_TYPE || type.$$typeof === $19813643f60dbb4e$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $19813643f60dbb4e$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $19813643f60dbb4e$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $19813643f60dbb4e$var$REACT_ELEMENT_TYPE:
                {
                    var type = object.type;
                    switch(type){
                        case $19813643f60dbb4e$var$REACT_FRAGMENT_TYPE:
                        case $19813643f60dbb4e$var$REACT_PROFILER_TYPE:
                        case $19813643f60dbb4e$var$REACT_STRICT_MODE_TYPE:
                        case $19813643f60dbb4e$var$REACT_SUSPENSE_TYPE:
                        case $19813643f60dbb4e$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                var $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $19813643f60dbb4e$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $19813643f60dbb4e$var$REACT_CONTEXT_TYPE:
                                    case $19813643f60dbb4e$var$REACT_FORWARD_REF_TYPE:
                                    case $19813643f60dbb4e$var$REACT_LAZY_TYPE:
                                    case $19813643f60dbb4e$var$REACT_MEMO_TYPE:
                                    case $19813643f60dbb4e$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $19813643f60dbb4e$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $19813643f60dbb4e$var$isContextConsumer(object) {
    return $19813643f60dbb4e$var$typeOf(object) === $19813643f60dbb4e$var$REACT_CONTEXT_TYPE;
}
function $19813643f60dbb4e$var$isMemo(object) {
    return $19813643f60dbb4e$var$typeOf(object) === $19813643f60dbb4e$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $19813643f60dbb4e$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $19813643f60dbb4e$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $19813643f60dbb4e$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $19813643f60dbb4e$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $19813643f60dbb4e$var$verify(mapStateToProps, "mapStateToProps");
    $19813643f60dbb4e$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $19813643f60dbb4e$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $19813643f60dbb4e$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $19813643f60dbb4e$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $19813643f60dbb4e$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $19813643f60dbb4e$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $19813643f60dbb4e$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $3wcuq._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $19813643f60dbb4e$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $19813643f60dbb4e$var$verifyPlainObject(value, displayName, methodName) {
    if (!$19813643f60dbb4e$var$isPlainObject(value)) $19813643f60dbb4e$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $19813643f60dbb4e$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $19813643f60dbb4e$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $19813643f60dbb4e$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $19813643f60dbb4e$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $19813643f60dbb4e$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $19813643f60dbb4e$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $7fjaO._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $19813643f60dbb4e$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $19813643f60dbb4e$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $19813643f60dbb4e$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $19813643f60dbb4e$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $19813643f60dbb4e$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $19813643f60dbb4e$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $19813643f60dbb4e$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $19813643f60dbb4e$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $19813643f60dbb4e$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $19813643f60dbb4e$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $19813643f60dbb4e$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $19813643f60dbb4e$var$__spreadValues($19813643f60dbb4e$var$__spreadValues($19813643f60dbb4e$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $19813643f60dbb4e$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $19813643f60dbb4e$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $19813643f60dbb4e$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $19813643f60dbb4e$var$wrapMergePropsFunc(mergeProps) : $19813643f60dbb4e$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/Subscription.ts
function $19813643f60dbb4e$var$createListenerCollection() {
    var batch3 = $19813643f60dbb4e$var$getBatch();
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            batch3(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $19813643f60dbb4e$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $19813643f60dbb4e$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $19813643f60dbb4e$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $19813643f60dbb4e$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $19813643f60dbb4e$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $19813643f60dbb4e$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $19813643f60dbb4e$var$useIsomorphicLayoutEffect = $19813643f60dbb4e$var$canUseDOM ? $19813643f60dbb4e$var$React.useLayoutEffect : $19813643f60dbb4e$var$React.useEffect;
// src/utils/shallowEqual.ts
function $19813643f60dbb4e$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $19813643f60dbb4e$export$d36bdfa510afb180(objA, objB) {
    if ($19813643f60dbb4e$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$19813643f60dbb4e$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $19813643f60dbb4e$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $19813643f60dbb4e$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $19813643f60dbb4e$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $19813643f60dbb4e$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $19813643f60dbb4e$var$_obj;
var $19813643f60dbb4e$var$TYPE_STATICS = ($19813643f60dbb4e$var$_obj = {}, (0, $fkQxX._)($19813643f60dbb4e$var$_obj, $19813643f60dbb4e$var$ForwardRef, $19813643f60dbb4e$var$FORWARD_REF_STATICS), (0, $fkQxX._)($19813643f60dbb4e$var$_obj, $19813643f60dbb4e$var$Memo, $19813643f60dbb4e$var$MEMO_STATICS), $19813643f60dbb4e$var$_obj);
function $19813643f60dbb4e$var$getStatics(component) {
    if ($19813643f60dbb4e$var$isMemo(component)) return $19813643f60dbb4e$var$MEMO_STATICS;
    return $19813643f60dbb4e$var$TYPE_STATICS[component["$$typeof"]] || $19813643f60dbb4e$var$REACT_STATICS;
}
var $19813643f60dbb4e$var$defineProperty = Object.defineProperty;
var $19813643f60dbb4e$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $19813643f60dbb4e$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $19813643f60dbb4e$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $19813643f60dbb4e$var$getPrototypeOf = Object.getPrototypeOf;
var $19813643f60dbb4e$var$objectPrototype = Object.prototype;
function $19813643f60dbb4e$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($19813643f60dbb4e$var$objectPrototype) {
            var inheritedComponent = $19813643f60dbb4e$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $19813643f60dbb4e$var$objectPrototype) $19813643f60dbb4e$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $19813643f60dbb4e$var$getOwnPropertyNames(sourceComponent);
        if ($19813643f60dbb4e$var$getOwnPropertySymbols) keys = keys.concat($19813643f60dbb4e$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $19813643f60dbb4e$var$getStatics(targetComponent);
        var sourceStatics = $19813643f60dbb4e$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$19813643f60dbb4e$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $19813643f60dbb4e$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $19813643f60dbb4e$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $19813643f60dbb4e$var$useSyncExternalStore = $19813643f60dbb4e$var$notInitialized;
var $19813643f60dbb4e$var$initializeConnect = function(fn) {
    $19813643f60dbb4e$var$useSyncExternalStore = fn;
};
var $19813643f60dbb4e$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $19813643f60dbb4e$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $19813643f60dbb4e$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $19813643f60dbb4e$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $3wcuq._)(effectArgs));
    }, dependencies);
}
function $19813643f60dbb4e$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $19813643f60dbb4e$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $19813643f60dbb4e$var$strictEqual(a, b) {
    return a === b;
}
var $19813643f60dbb4e$var$hasWarnedAboutDeprecatedPureOption = false;
function $19813643f60dbb4e$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $19813643f60dbb4e$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $19813643f60dbb4e$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $19813643f60dbb4e$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $19813643f60dbb4e$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $19813643f60dbb4e$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $19813643f60dbb4e$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $19813643f60dbb4e$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $19813643f60dbb4e$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $g9pLc._)($19813643f60dbb4e$var$React.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $19813643f60dbb4e$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $19813643f60dbb4e$var$React.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $19813643f60dbb4e$var$React.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $19813643f60dbb4e$var$React.useMemo(function() {
                return $19813643f60dbb4e$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $g9pLc._)($19813643f60dbb4e$var$React.useMemo(function() {
                if (!shouldHandleStateChanges) return $19813643f60dbb4e$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $19813643f60dbb4e$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $19813643f60dbb4e$var$React.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $19813643f60dbb4e$var$__spreadProps($19813643f60dbb4e$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $19813643f60dbb4e$var$React.useRef();
            var lastWrapperProps = $19813643f60dbb4e$var$React.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $19813643f60dbb4e$var$React.useRef();
            var renderIsScheduled = $19813643f60dbb4e$var$React.useRef(false);
            var isProcessingDispatch = $19813643f60dbb4e$var$React.useRef(false);
            var isMounted = $19813643f60dbb4e$var$React.useRef(false);
            var latestSubscriptionCallbackError = $19813643f60dbb4e$var$React.useRef();
            $19813643f60dbb4e$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $19813643f60dbb4e$var$React.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $19813643f60dbb4e$var$React.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $19813643f60dbb4e$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $19813643f60dbb4e$var$useIsomorphicLayoutEffectWithArgs($19813643f60dbb4e$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $19813643f60dbb4e$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $19813643f60dbb4e$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $19813643f60dbb4e$var$React.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $19813643f60dbb4e$var$React.createElement(WrappedComponent, $19813643f60dbb4e$var$__spreadProps($19813643f60dbb4e$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $19813643f60dbb4e$var$React.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $19813643f60dbb4e$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $19813643f60dbb4e$var$React.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $19813643f60dbb4e$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $19813643f60dbb4e$var$React.createElement(Connect, $19813643f60dbb4e$var$__spreadProps($19813643f60dbb4e$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $19813643f60dbb4e$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $19813643f60dbb4e$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $19813643f60dbb4e$export$64605811ab45167f = $19813643f60dbb4e$var$connect;
// src/components/Provider.tsx
function $19813643f60dbb4e$var$Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? "once" : _param_stabilityCheck, _param_identityFunctionCheck = param.identityFunctionCheck, identityFunctionCheck = _param_identityFunctionCheck === void 0 ? "once" : _param_identityFunctionCheck;
    var contextValue = $19813643f60dbb4e$var$React.useMemo(function() {
        var subscription = $19813643f60dbb4e$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    var previousState = $19813643f60dbb4e$var$React.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $19813643f60dbb4e$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $19813643f60dbb4e$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $19813643f60dbb4e$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $19813643f60dbb4e$export$2881499e37b75b9a = $19813643f60dbb4e$var$Provider;
// src/hooks/useStore.ts
function $19813643f60dbb4e$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $19813643f60dbb4e$export$cc80c08dc91f1c00;
    var useReduxContext2 = // @ts-ignore
    context === $19813643f60dbb4e$export$cc80c08dc91f1c00 ? $19813643f60dbb4e$var$useReduxContext : // @ts-ignore
    $19813643f60dbb4e$var$createReduxContextHook(context);
    return function useStore2() {
        var store = useReduxContext2().store;
        return store;
    };
}
var $19813643f60dbb4e$export$6ccbb43953eebf8 = /* @__PURE__ */ $19813643f60dbb4e$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $19813643f60dbb4e$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $19813643f60dbb4e$export$cc80c08dc91f1c00;
    var useStore2 = // @ts-ignore
    context === $19813643f60dbb4e$export$cc80c08dc91f1c00 ? $19813643f60dbb4e$export$6ccbb43953eebf8 : $19813643f60dbb4e$export$671dba69185d0304(context);
    return function useDispatch2() {
        var store = useStore2();
        return store.dispatch;
    };
}
var $19813643f60dbb4e$export$8ad76b76a4c905f8 = /* @__PURE__ */ $19813643f60dbb4e$export$bc9b55530897c558();
// src/index.ts
$19813643f60dbb4e$var$initializeUseSelector((0, $9f3c8ce1dab1a2ba$exports.useSyncExternalStoreWithSelector));
$19813643f60dbb4e$var$initializeConnect($f6C7p.useSyncExternalStore);
$19813643f60dbb4e$var$setBatch((0, $d1c59b6c8407de62$exports.unstable_batchedUpdates));
var $19813643f60dbb4e$export$712ea50be43a7858 = (0, $d1c59b6c8407de62$exports.unstable_batchedUpdates);


var $8ab1f8f0fdfee72f$var$Header = function() {
    var onlineStatus = (0, $f36ca4ab89a742dc$export$2e2bcd8739ae039)();
    var loggedInUser = (0, $f6C7p.useContext)((0, $cb9202d36b904eb0$export$2e2bcd8739ae039)).loggedInUser;
    //  subcribing to the
    var cartItems = (0, $19813643f60dbb4e$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    console.log(cartItems);
    // let btnName = "Login";
    var _useState = (0, $g9pLc._)((0, $f6C7p.useState)("Login"), 2), btnNameReact = _useState[0], setBtnNameReact = _useState[1];
    (0, $f6C7p.useEffect)(function() {
    // console.log("useEffect")
    });
    return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
        className: "flex justify-between bg-pink-100 shadow-lg mb-2 sm:bg-yellow-100 lg:bg-green-100 md:to-blue-100",
        children: [
            /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $ht8Wd.jsx)("img", {
                    className: "w-28",
                    src: (0, $f1a1b29ad18234d0$export$8878ead86ed0da0b)
                })
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $ht8Wd.jsxs)("ul", {
                    className: "flex  m-0 p-2",
                    children: [
                        /*#__PURE__*/ (0, $ht8Wd.jsxs)("li", {
                            className: "px-2",
                            children: [
                                "Status:",
                                onlineStatus ? "\u2705" : "\u274C"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $58d3e9a89be9b556$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: " Home "
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsxs)("li", {
                            className: "px-2",
                            children: [
                                /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $58d3e9a89be9b556$export$a6c7ac8248d6e38a), {
                                    to: "/about",
                                    children: "About us "
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsxs)("li", {
                            className: "px-2",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $58d3e9a89be9b556$export$a6c7ac8248d6e38a), {
                                    to: "/contact",
                                    children: "Contact Us"
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsxs)("li", {
                            className: "px-2",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $58d3e9a89be9b556$export$a6c7ac8248d6e38a), {
                                    to: "/grocery",
                                    children: "Grocery"
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsxs)("li", {
                            className: "px-2 font-bold",
                            children: [
                                /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $58d3e9a89be9b556$export$a6c7ac8248d6e38a), {
                                    to: "/cart",
                                    children: "Cart"
                                }),
                                "(",
                                cartItems.length,
                                " Item) "
                            ]
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsx)("button", {
                            className: "login ",
                            onClick: function() {
                                btnNameReact === "login" ? setBtnNameReact("logout") : setBtnNameReact("login");
                                console.log(btnNameReact);
                            },
                            children: btnNameReact
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsxs)("li", {
                            className: "px-2 font-bold",
                            children: [
                                " ",
                                loggedInUser,
                                " "
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $8ab1f8f0fdfee72f$export$2e2bcd8739ae039 = $8ab1f8f0fdfee72f$var$Header;




var $g9pLc = parcelRequire("g9pLc");


var $ht8Wd = parcelRequire("ht8Wd");

var $fkQxX = parcelRequire("fkQxX");
function $4fea265c9a477b36$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $fkQxX._define_property)(target, key, source[key]);
        });
    }
    return target;
}



var $ht8Wd = parcelRequire("ht8Wd");

var $f6C7p = parcelRequire("f6C7p");


// const styleCard ={
//     backgroundColor: "#f0f0f0",
// };
var $fcdb9e18d07e986c$var$RestaurantCard = function(props) {
    var resData = props.resData;
    var loggedInUser = (0, $f6C7p.useContext)((0, $cb9202d36b904eb0$export$2e2bcd8739ae039)).loggedInUser;
    var _ref = resData === null || resData === void 0 ? void 0 : resData.info, cloudinaryImageId = _ref.cloudinaryImageId, name = _ref.name, cuisines = _ref.cuisines, costForTwo = _ref.costForTwo, avgRating = _ref.avgRating, deliveryTime = _ref.deliveryTime;
    return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
        className: "res-card m-4 p-4 w-[300px] rounded-lg bg-gray-200 hover:bg-green-200  ",
        children: [
            /*#__PURE__*/ (0, $ht8Wd.jsx)("img", {
                className: "res-logo rounded-lg ",
                src: (0, $f1a1b29ad18234d0$export$31adfacaf07ffe63) + cloudinaryImageId,
                alt: "Biryani"
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h3", {
                className: " font-bold py-4 text-lg",
                children: name
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h4", {
                children: cuisines.join(", ")
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("h4", {
                children: [
                    avgRating,
                    " stars"
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h4", {
                children: costForTwo
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("h4", {
                children: [
                    deliveryTime,
                    "minutes "
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("h4", {
                children: [
                    "User:",
                    loggedInUser,
                    " "
                ]
            })
        ]
    });
};
var $fcdb9e18d07e986c$export$bdc3d774adf316c = function(RestaurantCard) {
    return function(props) {
        return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ht8Wd.jsx)("label", {
                    children: "Promoted"
                }),
                /*#__PURE__*/ (0, $ht8Wd.jsx)(RestaurantCard, (0, $4fea265c9a477b36$export$581ff339ea0ba762)({}, props))
            ]
        });
    };
};
var $fcdb9e18d07e986c$export$2e2bcd8739ae039 // style={{ backgroundColor: "#f0f0f0", }}
 = $fcdb9e18d07e986c$var$RestaurantCard;



var $f6C7p = parcelRequire("f6C7p");

var $ht8Wd = parcelRequire("ht8Wd");
var $0cd640e6f31826d2$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
        className: "flex flex-wrap m-4 p-4 mx-[60px] my-[60px] justify-between ",
        children: [
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            })
        ]
    });
};
var $0cd640e6f31826d2$export$2e2bcd8739ae039 //  <div className="shimmer-container  rounded-lg border w-60 h-60 mx-16 m-8 p-4 animate-pulse">
 //  <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
 // <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
 // <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
 // <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
 // </div>
 = $0cd640e6f31826d2$var$Shimmer;





//  import UserContext from "../utils/UserContext";
//  import UserContext from "../utils/UserContext";
//  State Variables - super powerful variables
var $48ffb8e4618bf807$var$Body = function() {
    var _useState = (0, $g9pLc._)((0, $f6C7p.useState)([]), 2), listOfRestaurants = _useState[0], setListOfRestaurant = _useState[1];
    var _useState1 = (0, $g9pLc._)((0, $f6C7p.useState)([]), 2), filteredRestaurant = _useState1[0], setFilteredRestaurant = _useState1[1];
    var _useState2 = (0, $g9pLc._)((0, $f6C7p.useState)(""), 2), searchText = _useState2[0], setSearchText = _useState2[1];
    var RestaurantCardPromoted = (0, $fcdb9e18d07e986c$export$bdc3d774adf316c)((0, $fcdb9e18d07e986c$export$2e2bcd8739ae039));
    //    whenever state variable , react triggers a reconciliation cycle (re -render the component)
    console.log("rakesh");
    (0, $f6C7p.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = function() {
        var _ref = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function() {
            var _json_data_cards__card_card_gridElements_infoWithStyle, _json_data_cards__card_card_gridElements, _json_data_cards__card_card, _json_data_cards__card, _json_data_cards_, _json_data, _json_data_cards__card_card_gridElements_infoWithStyle1, _json_data_cards__card_card_gridElements1, _json_data_cards__card_card1, _json_data_cards__card1, _json_data_cards_1, _json_data1, _json_data_cards__card_card_gridElements_infoWithStyle2, _json_data_cards__card_card_gridElements2, _json_data_cards__card_card2, _json_data_cards__card2, _json_data_cards_2, _json_data2, data, json;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9715987&lng=77.5945627&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING")
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        // console.log(data.cards[2]);
                        console.log(json);
                        console.log(json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : (_json_data_cards_ = _json_data.cards[1]) === null || _json_data_cards_ === void 0 ? void 0 : (_json_data_cards__card = _json_data_cards_.card) === null || _json_data_cards__card === void 0 ? void 0 : (_json_data_cards__card_card = _json_data_cards__card.card) === null || _json_data_cards__card_card === void 0 ? void 0 : (_json_data_cards__card_card_gridElements = _json_data_cards__card_card.gridElements) === null || _json_data_cards__card_card_gridElements === void 0 ? void 0 : (_json_data_cards__card_card_gridElements_infoWithStyle = _json_data_cards__card_card_gridElements.infoWithStyle) === null || _json_data_cards__card_card_gridElements_infoWithStyle === void 0 ? void 0 : _json_data_cards__card_card_gridElements_infoWithStyle.restaurants);
                        //  Optional Chaining                                                                
                        setListOfRestaurant(json === null || json === void 0 ? void 0 : (_json_data1 = json.data) === null || _json_data1 === void 0 ? void 0 : (_json_data_cards_1 = _json_data1.cards[1]) === null || _json_data_cards_1 === void 0 ? void 0 : (_json_data_cards__card1 = _json_data_cards_1.card) === null || _json_data_cards__card1 === void 0 ? void 0 : (_json_data_cards__card_card1 = _json_data_cards__card1.card) === null || _json_data_cards__card_card1 === void 0 ? void 0 : (_json_data_cards__card_card_gridElements1 = _json_data_cards__card_card1.gridElements) === null || _json_data_cards__card_card_gridElements1 === void 0 ? void 0 : (_json_data_cards__card_card_gridElements_infoWithStyle1 = _json_data_cards__card_card_gridElements1.infoWithStyle) === null || _json_data_cards__card_card_gridElements_infoWithStyle1 === void 0 ? void 0 : _json_data_cards__card_card_gridElements_infoWithStyle1.restaurants);
                        setFilteredRestaurant(json === null || json === void 0 ? void 0 : (_json_data2 = json.data) === null || _json_data2 === void 0 ? void 0 : (_json_data_cards_2 = _json_data2.cards[1]) === null || _json_data_cards_2 === void 0 ? void 0 : (_json_data_cards__card2 = _json_data_cards_2.card) === null || _json_data_cards__card2 === void 0 ? void 0 : (_json_data_cards__card_card2 = _json_data_cards__card2.card) === null || _json_data_cards__card_card2 === void 0 ? void 0 : (_json_data_cards__card_card_gridElements2 = _json_data_cards__card_card2.gridElements) === null || _json_data_cards__card_card_gridElements2 === void 0 ? void 0 : (_json_data_cards__card_card_gridElements_infoWithStyle2 = _json_data_cards__card_card_gridElements2.infoWithStyle) === null || _json_data_cards__card_card_gridElements_infoWithStyle2 === void 0 ? void 0 : _json_data_cards__card_card_gridElements_infoWithStyle2.restaurants);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var onlineStatus = (0, $f36ca4ab89a742dc$export$2e2bcd8739ae039)();
    if (onlineStatus === false) return /*#__PURE__*/ (0, $ht8Wd.jsx)("h1", {
        children: "Look like you are offline"
    });
    //  if(listOfRestaurants.length===0){
    //    return <Shimmer/>;
    var _useContext = (0, $f6C7p.useContext)((0, $cb9202d36b904eb0$export$2e2bcd8739ae039)), loggedInUser = _useContext.loggedInUser, setUserName = _useContext.setUserName;
    return listOfRestaurants.length === 0 ? /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $0cd640e6f31826d2$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
        className: "body",
        children: [
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "filter flex",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                        className: "search p-4 m-4",
                        children: [
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("input", {
                                type: "text",
                                className: "border border-solid border-black",
                                value: searchText,
                                onChange: function(e) {
                                    setSearchText(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("button", {
                                className: "px-4 py-1 bg-green-100 m-4 rounded-lg",
                                onClick: function() {
                                    //  filter
                                    var filteredRestaurant = listOfRestaurants.filter(function(res) {
                                        return res.info.name.toLowerCase().includes(searchText);
                                    });
                                    setFilteredRestaurant(filteredRestaurant);
                                },
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                        className: "p-4 m-4 flex items-center",
                        children: /*#__PURE__*/ (0, $ht8Wd.jsx)("button", {
                            className: "filter-btn px-4 py-2 bg-gray-200 rounded-lg",
                            onClick: function() {
                                //     filter logic here
                                var filteredList = listOfRestaurants.filter(function(res) {
                                    return res.info.avgRating > 4;
                                });
                                setListOfRestaurant(filteredList);
                            // console.log(listOfRestaurants);
                            },
                            children: "Top Rated Restaurants"
                        })
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                        className: "p-4 m-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("label", {
                                children: "User Name:"
                            }),
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("input", {
                                className: "border border-black p-2",
                                value: loggedInUser,
                                onChange: function(e) {
                                    return setUserName(e.target.value);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                className: "res-conatiner flex flex-wrap rounded-lg",
                children: filteredRestaurant.map(function(restaurants, index) {
                    return /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $58d3e9a89be9b556$export$a6c7ac8248d6e38a), {
                        to: "/restaurants/" + restaurants.info.id,
                        children: /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $fcdb9e18d07e986c$export$2e2bcd8739ae039), {
                            resData: restaurants
                        })
                    }, restaurants.info.id);
                })
            })
        ]
    });
};
var $48ffb8e4618bf807$export$2e2bcd8739ae039 = $48ffb8e4618bf807$var$Body;



var $8cfPm = parcelRequire("8cfPm");

var $953s6 = parcelRequire("953s6");

var $feZkv = parcelRequire("feZkv");

var $6ZKiV = parcelRequire("6ZKiV");

var $ht8Wd = parcelRequire("ht8Wd");

var $f6C7p = parcelRequire("f6C7p");


var $g9pLc = parcelRequire("g9pLc");


var $ht8Wd = parcelRequire("ht8Wd");

var $f6C7p = parcelRequire("f6C7p");
var $32b85c4235f7f008$var$User = function(param) {
    var name = param.name;
    var getUserInfo = function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
    };
    var _useState = (0, $g9pLc._)((0, $f6C7p.useState)(0), 2), count = _useState[0], setCount = _useState[1];
    var _useState1 = (0, $g9pLc._)((0, $f6C7p.useState)(1), 1), count2 = _useState1[0];
    // function handleClick() {
    //     setCount(count + 1);
    //   }
    (0, $f6C7p.useEffect)(function() {}, []);
    function _getUserInfo() {
        _getUserInfo = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function() {
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                return [
                    2
                ];
            });
        });
        return _getUserInfo.apply(this, arguments);
    }
    return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
        className: "user-card",
        children: [
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h2", {
                children: " Name :Rakesh kushwaha "
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("h2", {
                children: [
                    "  ",
                    name
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h3", {
                children: " location : Akabar shahpur Meja Prayagraj"
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h4", {
                children: "Contact : rk7518329420@gmail.com"
            })
        ]
    });
};
var $32b85c4235f7f008$export$2e2bcd8739ae039 = $32b85c4235f7f008$var$User;




var $8cfPm = parcelRequire("8cfPm");

var $953s6 = parcelRequire("953s6");

var $feZkv = parcelRequire("feZkv");

var $6ZKiV = parcelRequire("6ZKiV");


var $ht8Wd = parcelRequire("ht8Wd");

var $f6C7p = parcelRequire("f6C7p");
var $95b1ae9f6dc6cb13$var$UserClass = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $feZkv._)(UserClass, _React_Component);
    var _super = (0, $6ZKiV._)(UserClass);
    function UserClass(props) {
        (0, $8cfPm._)(this, UserClass);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            userInfo: {
                name: "Rakesh kushwaha  ",
                location: "Prayagraj"
            }
        };
        return _this;
    }
    (0, $953s6._)(UserClass, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return (0, $39e0c52944643fcc$export$7c398597f8905a1)(function() {
                    var data, json;
                    return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("https://api.github.com/users/RAKESHKUSHWAHA7518")
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    4,
                                    data.json()
                                ];
                            case 2:
                                json = _state.sent();
                                _this.setState({
                                    userInfo: json
                                });
                                console.log(json);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                console.log("componentDidUpdate");
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                console.log("componentWillUnmount");
            }
        },
        {
            key: "render",
            value: function render() {
                //  const {name} = this.props;
                //  console.log (this.props.name+" child render")
                var _this_state_userInfo = this.state.userInfo, name = _this_state_userInfo.name, location = _this_state_userInfo.location, id = _this_state_userInfo.id, avatar_url = _this_state_userInfo.avatar_url;
                return /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                    className: "  place-content-center  ",
                    children: /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                        className: "user-card m-4 p-4 border  rounded-lg bg-blue-200  justify-center",
                        children: [
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("img", {
                                className: "bg-gray-200 place-content-center  hover:bg-green-200",
                                src: avatar_url
                            }),
                            /*#__PURE__*/ (0, $ht8Wd.jsxs)("h2", {
                                className: "font-bold",
                                children: [
                                    " Name : ",
                                    name
                                ]
                            }),
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("h3", {
                                className: "font-light",
                                children: " location : Akabar shahpur Meja Prayagraj"
                            }),
                            /*#__PURE__*/ (0, $ht8Wd.jsxs)("h3", {
                                className: "font-light",
                                children: [
                                    " location : ",
                                    location
                                ]
                            }),
                            /*#__PURE__*/ (0, $ht8Wd.jsxs)("h3", {
                                className: "font-light",
                                children: [
                                    " Id: ",
                                    id
                                ]
                            }),
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("h4", {
                                children: "Contact : rk7518329420@gmail.com"
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return UserClass;
}((0, (/*@__PURE__*/$parcel$interopDefault($f6C7p))).Component);
var $95b1ae9f6dc6cb13$export$2e2bcd8739ae039 = $95b1ae9f6dc6cb13$var$UserClass;



var $a96f393f1ad99ab0$var$About = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $feZkv._)(About, _React_Component);
    var _super = (0, $6ZKiV._)(About);
    function About(props) {
        (0, $8cfPm._)(this, About);
        return _super.call(this, props);
    }
    (0, $953s6._)(About, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
            // console.log(" parent Component is mounted");
            }
        },
        {
            key: "render",
            value: function render() {
                // console.log(" Parent Rendering...");
                return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ht8Wd.jsx)("h1", {
                            className: "m-4 px-4  font-bold",
                            children: "About class "
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                            children: [
                                "loggedIn User",
                                /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $cb9202d36b904eb0$export$2e2bcd8739ae039).Consumer, {
                                    children: function(param) {
                                        var loggedInUser = param.loggedInUser;
                                        return /*#__PURE__*/ (0, $ht8Wd.jsx)("h1", {
                                            className: "font-bold p-6",
                                            children: loggedInUser
                                        });
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsx)("h2", {
                            className: "m-4 px-4 font-bold",
                            children: " Namaste React Student"
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $95b1ae9f6dc6cb13$export$2e2bcd8739ae039), {
                            name: "Rakesh Kushwaha (class base component) "
                        })
                    ]
                });
            }
        }
    ]);
    return About;
}((0, (/*@__PURE__*/$parcel$interopDefault($f6C7p))).Component);
var // const About =() =>{
//     return(
//         <div>
//             <h1>About</h1>
//             <h2> Namaste React Student</h2>
//             <User name = {"Rakesh Kushwaha(fuctional)"}/>
//             <UserClass name = {"Rakesh Kushwaha (class base component) "} />
//         </div>
//     );
// }
$a96f393f1ad99ab0$export$2e2bcd8739ae039 = $a96f393f1ad99ab0$var$About;



var $ht8Wd = parcelRequire("ht8Wd");


var $8689f7d3a93be4f8$var$Error = function() {
    var err = (0, $b50ff877aba8fe4d$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $8ab1f8f0fdfee72f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h1", {
                children: " Error 404 found"
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h2", {
                children: "This page is not present"
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("h3", {
                children: [
                    err.status,
                    ":",
                    err.statusText,
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("br", {})
                ]
            })
        ]
    });
};
var $8689f7d3a93be4f8$export$2e2bcd8739ae039 = $8689f7d3a93be4f8$var$Error;



var $ht8Wd = parcelRequire("ht8Wd");
var $95f752b07db7681f$var$Contact = function() {
    return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
        className: "border m-4 p-4 justify-center bg-gray-200 border-r-blue-200",
        children: [
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h1", {
                className: "font-bold",
                children: " Contact us Page"
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h2", {
                children: "I am Rakesh Kushwaha"
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h2", {
                children: "My Email is rk7518329420@gmail.com"
            })
        ]
    });
};
var $95f752b07db7681f$export$2e2bcd8739ae039 = $95f752b07db7681f$var$Contact;




var $g9pLc = parcelRequire("g9pLc");

var $ht8Wd = parcelRequire("ht8Wd");

var $f6C7p = parcelRequire("f6C7p");




var $g9pLc = parcelRequire("g9pLc");


var $f6C7p = parcelRequire("f6C7p");

var $6f2912c4ad8142db$var$useRestaurantMenu = function(resId) {
    var _useState = (0, $g9pLc._)((0, $f6C7p.useState)(null), 2), resInfo = _useState[0], setResInfo = _useState[1];
    //  fetch data
    (0, $f6C7p.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = function() {
        var _ref = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function() {
            var data, json;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=" + resId + "&catalog_qa=undefined&submitAction=ENTER")
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        setResInfo(json.data);
                        return [
                            2
                        ];
                }
            });
        //  console.log(json.data);
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    return resInfo;
};
var $6f2912c4ad8142db$export$2e2bcd8739ae039 = $6f2912c4ad8142db$var$useRestaurantMenu;




var $ht8Wd = parcelRequire("ht8Wd");
parcelRequire("f6C7p");
// import { useDispatch } from "react-redux";

var $ht8Wd = parcelRequire("ht8Wd");

// src/index.ts

var $dhgu3 = parcelRequire("dhgu3");


var $8cfPm = parcelRequire("8cfPm");

var $7Z16o = parcelRequire("7Z16o");

var $953s6 = parcelRequire("953s6");

var $fkQxX = parcelRequire("fkQxX");

var $4R95R = parcelRequire("4R95R");
function $50fa5f1c8a3efb92$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $4R95R._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}


function $6262699f5a2bb86e$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $6262699f5a2bb86e$export$afb3516d9d608401 = Reflect.get;
    else $6262699f5a2bb86e$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $50fa5f1c8a3efb92$export$e4187255aefbc259)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $6262699f5a2bb86e$export$afb3516d9d608401(target, property, receiver || target);
}



var $4R95R = parcelRequire("4R95R");

var $feZkv = parcelRequire("feZkv");

function $7305121fbb913b12$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7305121fbb913b12$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $7305121fbb913b12$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $67517a11df0fdadc$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $6076f0b8fabffc21$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $67517a11df0fdadc$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $g9pLc = parcelRequire("g9pLc");

var $3wcuq = parcelRequire("3wcuq");

var $7fjaO = parcelRequire("7fjaO");

var $3O8MO = parcelRequire("3O8MO");

var $6ZKiV = parcelRequire("6ZKiV");

// src/utils/formatProdErrorMessage.ts

var $fkQxX = parcelRequire("fkQxX");



var $3wcuq = parcelRequire("3wcuq");

var $7fjaO = parcelRequire("7fjaO");
function $3dfb2b38496d9965$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $3dfb2b38496d9965$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $3dfb2b38496d9965$var$symbol_observable_default = $3dfb2b38496d9965$var$$$observable;
// src/utils/actionTypes.ts
var $3dfb2b38496d9965$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $3dfb2b38496d9965$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($3dfb2b38496d9965$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($3dfb2b38496d9965$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($3dfb2b38496d9965$var$randomString());
    }
};
var $3dfb2b38496d9965$export$4219e499db7ca678 = $3dfb2b38496d9965$var$ActionTypes;
// src/utils/isPlainObject.ts
function $3dfb2b38496d9965$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// src/utils/kindOf.ts
function $3dfb2b38496d9965$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $7fjaO._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($3dfb2b38496d9965$var$isDate(val)) return "date";
    if ($3dfb2b38496d9965$var$isError(val)) return "error";
    var constructorName = $3dfb2b38496d9965$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $3dfb2b38496d9965$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $3dfb2b38496d9965$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $3dfb2b38496d9965$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $3dfb2b38496d9965$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $7fjaO._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $3dfb2b38496d9965$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(1));
        return enhancer($3dfb2b38496d9965$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$3dfb2b38496d9965$export$53b83ca8eaab0383(action)) throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $3dfb2b38496d9965$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $fkQxX._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $3dfb2b38496d9965$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $3dfb2b38496d9965$export$4219e499db7ca678.INIT
    });
    var store = (0, $fkQxX._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $3dfb2b38496d9965$var$symbol_observable_default, observable);
    return store;
}
function $3dfb2b38496d9965$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $3dfb2b38496d9965$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $3dfb2b38496d9965$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $3dfb2b38496d9965$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $3dfb2b38496d9965$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$3dfb2b38496d9965$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($3dfb2b38496d9965$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $3dfb2b38496d9965$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $3dfb2b38496d9965$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $3dfb2b38496d9965$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $3dfb2b38496d9965$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(13));
    });
}
function $3dfb2b38496d9965$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $3dfb2b38496d9965$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $3dfb2b38496d9965$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $3dfb2b38496d9965$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $3dfb2b38496d9965$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $3dfb2b38496d9965$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $3dfb2b38496d9965$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $3wcuq._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $3dfb2b38496d9965$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($3dfb2b38496d9965$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $3wcuq._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $3dfb2b38496d9965$export$f672e0b6f7222cd7.apply(void 0, (0, $3wcuq._)(chain))(store.dispatch);
            return (0, $7305121fbb913b12$export$4fa2f4023c9cbda5)((0, $4fea265c9a477b36$export$581ff339ea0ba762)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $3dfb2b38496d9965$export$b956e38827fca970(action) {
    return $3dfb2b38496d9965$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $2aK6P = parcelRequire("2aK6P");

var $8cfPm = parcelRequire("8cfPm");

var $953s6 = parcelRequire("953s6");

var $g9pLc = parcelRequire("g9pLc");

var $3wcuq = parcelRequire("3wcuq");

var $7fjaO = parcelRequire("7fjaO");
var $b17e0fb4b9e1d0b8$var$__defProp = Object.defineProperty;
var $b17e0fb4b9e1d0b8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b17e0fb4b9e1d0b8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b17e0fb4b9e1d0b8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b17e0fb4b9e1d0b8$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $b17e0fb4b9e1d0b8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $b17e0fb4b9e1d0b8$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($b17e0fb4b9e1d0b8$var$__hasOwnProp.call(b, prop)) $b17e0fb4b9e1d0b8$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($b17e0fb4b9e1d0b8$var$__getOwnPropSymbols) try {
        for(var _iterator = $b17e0fb4b9e1d0b8$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($b17e0fb4b9e1d0b8$var$__propIsEnum.call(b, prop)) $b17e0fb4b9e1d0b8$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $b17e0fb4b9e1d0b8$var$__publicField = function(obj, key, value) {
    $b17e0fb4b9e1d0b8$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $7fjaO._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $b17e0fb4b9e1d0b8$var$runIdentityFunctionCheck = function(resultFunc) {
    var isInputSameAsOutput = false;
    try {
        var emptyObject = {};
        if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
    } catch (e) {}
    if (isInputSameAsOutput) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
            stack: stack
        });
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $b17e0fb4b9e1d0b8$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $3wcuq._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $b17e0fb4b9e1d0b8$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $b17e0fb4b9e1d0b8$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($b17e0fb4b9e1d0b8$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $b17e0fb4b9e1d0b8$var$NOT_FOUND = "NOT_FOUND";
function $b17e0fb4b9e1d0b8$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $7fjaO._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $b17e0fb4b9e1d0b8$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $7fjaO._)(object));
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $b17e0fb4b9e1d0b8$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $7fjaO._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $b17e0fb4b9e1d0b8$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $b17e0fb4b9e1d0b8$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $b17e0fb4b9e1d0b8$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $b17e0fb4b9e1d0b8$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $b17e0fb4b9e1d0b8$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $b17e0fb4b9e1d0b8$var$__spreadValues($b17e0fb4b9e1d0b8$var$__spreadValues({}, $b17e0fb4b9e1d0b8$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $b17e0fb4b9e1d0b8$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $b17e0fb4b9e1d0b8$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $b17e0fb4b9e1d0b8$var$$REVISION = 0;
var $b17e0fb4b9e1d0b8$var$CURRENT_TRACKER = null;
var $b17e0fb4b9e1d0b8$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b17e0fb4b9e1d0b8$var$tripleEq;
        (0, $8cfPm._)(this, Cell);
        $b17e0fb4b9e1d0b8$var$__publicField(this, "revision", $b17e0fb4b9e1d0b8$var$$REVISION);
        $b17e0fb4b9e1d0b8$var$__publicField(this, "_value");
        $b17e0fb4b9e1d0b8$var$__publicField(this, "_lastValue");
        $b17e0fb4b9e1d0b8$var$__publicField(this, "_isEqual", $b17e0fb4b9e1d0b8$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $953s6._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $b17e0fb4b9e1d0b8$var$CURRENT_TRACKER == null || $b17e0fb4b9e1d0b8$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$b17e0fb4b9e1d0b8$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $b17e0fb4b9e1d0b8$var$tripleEq(a, b) {
    return a === b;
}
var $b17e0fb4b9e1d0b8$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $8cfPm._)(this, TrackingCache);
        $b17e0fb4b9e1d0b8$var$__publicField(this, "_cachedValue");
        $b17e0fb4b9e1d0b8$var$__publicField(this, "_cachedRevision", -1);
        $b17e0fb4b9e1d0b8$var$__publicField(this, "_deps", []);
        $b17e0fb4b9e1d0b8$var$__publicField(this, "hits", 0);
        $b17e0fb4b9e1d0b8$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $953s6._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $b17e0fb4b9e1d0b8$var$CURRENT_TRACKER;
                    $b17e0fb4b9e1d0b8$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $b17e0fb4b9e1d0b8$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $b17e0fb4b9e1d0b8$var$CURRENT_TRACKER == null || $b17e0fb4b9e1d0b8$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $3wcuq._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $b17e0fb4b9e1d0b8$var$getValue(cell) {
    if (!(cell instanceof $b17e0fb4b9e1d0b8$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $b17e0fb4b9e1d0b8$var$setValue(storage, value) {
    if (!(storage instanceof $b17e0fb4b9e1d0b8$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $b17e0fb4b9e1d0b8$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b17e0fb4b9e1d0b8$var$tripleEq;
    return new $b17e0fb4b9e1d0b8$var$Cell(initialValue, isEqual);
}
function $b17e0fb4b9e1d0b8$var$createCache(fn) {
    $b17e0fb4b9e1d0b8$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $b17e0fb4b9e1d0b8$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $b17e0fb4b9e1d0b8$var$neverEq = function(a, b) {
    return false;
};
function $b17e0fb4b9e1d0b8$var$createTag() {
    return $b17e0fb4b9e1d0b8$var$createCell(null, $b17e0fb4b9e1d0b8$var$neverEq);
}
function $b17e0fb4b9e1d0b8$var$dirtyTag(tag, value) {
    $b17e0fb4b9e1d0b8$var$setValue(tag, value);
}
var $b17e0fb4b9e1d0b8$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $b17e0fb4b9e1d0b8$var$createTag();
    $b17e0fb4b9e1d0b8$var$getValue(tag);
};
var $b17e0fb4b9e1d0b8$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $b17e0fb4b9e1d0b8$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $b17e0fb4b9e1d0b8$var$REDUX_PROXY_LABEL = Symbol();
var $b17e0fb4b9e1d0b8$var$nextId = 0;
var $b17e0fb4b9e1d0b8$var$proto = Object.getPrototypeOf({});
var $b17e0fb4b9e1d0b8$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $8cfPm._)(this, ObjectTreeNode);
    this.value = value;
    $b17e0fb4b9e1d0b8$var$__publicField(this, "proxy", new Proxy(this, $b17e0fb4b9e1d0b8$var$objectProxyHandler));
    $b17e0fb4b9e1d0b8$var$__publicField(this, "tag", $b17e0fb4b9e1d0b8$var$createTag());
    $b17e0fb4b9e1d0b8$var$__publicField(this, "tags", {});
    $b17e0fb4b9e1d0b8$var$__publicField(this, "children", {});
    $b17e0fb4b9e1d0b8$var$__publicField(this, "collectionTag", null);
    $b17e0fb4b9e1d0b8$var$__publicField(this, "id", $b17e0fb4b9e1d0b8$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $b17e0fb4b9e1d0b8$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $7fjaO._)(key)) === "symbol") return childValue;
            if (key in $b17e0fb4b9e1d0b8$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $b17e0fb4b9e1d0b8$var$createNode(childValue);
                if (childNode.tag) $b17e0fb4b9e1d0b8$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $b17e0fb4b9e1d0b8$var$createTag();
                    tag.value = childValue;
                }
                $b17e0fb4b9e1d0b8$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $b17e0fb4b9e1d0b8$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $b17e0fb4b9e1d0b8$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $8cfPm._)(this, ArrayTreeNode);
    this.value = value;
    $b17e0fb4b9e1d0b8$var$__publicField(this, "proxy", new Proxy([
        this
    ], $b17e0fb4b9e1d0b8$var$arrayProxyHandler));
    $b17e0fb4b9e1d0b8$var$__publicField(this, "tag", $b17e0fb4b9e1d0b8$var$createTag());
    $b17e0fb4b9e1d0b8$var$__publicField(this, "tags", {});
    $b17e0fb4b9e1d0b8$var$__publicField(this, "children", {});
    $b17e0fb4b9e1d0b8$var$__publicField(this, "collectionTag", null);
    $b17e0fb4b9e1d0b8$var$__publicField(this, "id", $b17e0fb4b9e1d0b8$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $b17e0fb4b9e1d0b8$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $g9pLc._)(param, 1), node = _param[0];
        if (key === "length") $b17e0fb4b9e1d0b8$var$consumeCollection(node);
        return $b17e0fb4b9e1d0b8$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $g9pLc._)(param, 1), node = _param[0];
        return $b17e0fb4b9e1d0b8$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $g9pLc._)(param, 1), node = _param[0];
        return $b17e0fb4b9e1d0b8$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $g9pLc._)(param, 1), node = _param[0];
        return $b17e0fb4b9e1d0b8$var$objectProxyHandler.has(node, prop);
    }
};
function $b17e0fb4b9e1d0b8$var$createNode(value) {
    if (Array.isArray(value)) return new $b17e0fb4b9e1d0b8$var$ArrayTreeNode(value);
    return new $b17e0fb4b9e1d0b8$var$ObjectTreeNode(value);
}
function $b17e0fb4b9e1d0b8$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $b17e0fb4b9e1d0b8$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $b17e0fb4b9e1d0b8$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $b17e0fb4b9e1d0b8$var$dirtyCollection(node);
            $b17e0fb4b9e1d0b8$var$dirtyTag(tags[key1], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if (typeof newChildValue1 === "object" && newChildValue1 !== null) $b17e0fb4b9e1d0b8$var$updateNode(childNode, newChildValue1);
        else {
            $b17e0fb4b9e1d0b8$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $b17e0fb4b9e1d0b8$var$deleteNode(node) {
    if (node.tag) $b17e0fb4b9e1d0b8$var$dirtyTag(node.tag, null);
    $b17e0fb4b9e1d0b8$var$dirtyCollection(node);
    for(var key in node.tags)$b17e0fb4b9e1d0b8$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$b17e0fb4b9e1d0b8$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $b17e0fb4b9e1d0b8$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $b17e0fb4b9e1d0b8$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $b17e0fb4b9e1d0b8$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $b17e0fb4b9e1d0b8$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $b17e0fb4b9e1d0b8$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $b17e0fb4b9e1d0b8$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $b17e0fb4b9e1d0b8$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $b17e0fb4b9e1d0b8$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $b17e0fb4b9e1d0b8$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $b17e0fb4b9e1d0b8$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize === 1 ? $b17e0fb4b9e1d0b8$var$createSingletonCache(comparator) : $b17e0fb4b9e1d0b8$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $b17e0fb4b9e1d0b8$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $b17e0fb4b9e1d0b8$export$c8f9cf88d9fdee55(func) {
    var node = $b17e0fb4b9e1d0b8$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $b17e0fb4b9e1d0b8$var$createCacheKeyComparator($b17e0fb4b9e1d0b8$export$3f025202a230c6dd);
    var cache = $b17e0fb4b9e1d0b8$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $b17e0fb4b9e1d0b8$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $b17e0fb4b9e1d0b8$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $8cfPm._)(this, StrongRef);
        this.value = value;
    }
    (0, $953s6._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $b17e0fb4b9e1d0b8$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $b17e0fb4b9e1d0b8$var$StrongRef;
var $b17e0fb4b9e1d0b8$var$UNTERMINATED = 0;
var $b17e0fb4b9e1d0b8$var$TERMINATED = 1;
function $b17e0fb4b9e1d0b8$var$createCacheNode() {
    return {
        s: $b17e0fb4b9e1d0b8$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $b17e0fb4b9e1d0b8$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $b17e0fb4b9e1d0b8$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $b17e0fb4b9e1d0b8$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $b17e0fb4b9e1d0b8$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $b17e0fb4b9e1d0b8$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $b17e0fb4b9e1d0b8$var$TERMINATED;
        if (resultEqualityCheck) {
            var lastResultValue = (_a = lastResult == null ? void 0 : lastResult.deref()) != null ? _a : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            var needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $b17e0fb4b9e1d0b8$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $b17e0fb4b9e1d0b8$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $b17e0fb4b9e1d0b8$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $b17e0fb4b9e1d0b8$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $7fjaO._)(resultFunc), "]"));
        var combinedOptions = $b17e0fb4b9e1d0b8$var$__spreadValues($b17e0fb4b9e1d0b8$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $b17e0fb4b9e1d0b8$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $b17e0fb4b9e1d0b8$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $b17e0fb4b9e1d0b8$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $b17e0fb4b9e1d0b8$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $3wcuq._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $b17e0fb4b9e1d0b8$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $3wcuq._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    return createSelector2;
}
var $b17e0fb4b9e1d0b8$export$595d22ed68ca2841 = /* @__PURE__ */ $b17e0fb4b9e1d0b8$export$5943f4447f6ef248($b17e0fb4b9e1d0b8$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $b17e0fb4b9e1d0b8$export$75979cfcd91bf38f = function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b17e0fb4b9e1d0b8$export$595d22ed68ca2841;
    $b17e0fb4b9e1d0b8$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $7fjaO._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
};


// src/index.ts
function $d1252765ba6ea3fb$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $d1252765ba6ea3fb$export$dd164f5517779f15 = $d1252765ba6ea3fb$var$createThunkMiddleware();
var $d1252765ba6ea3fb$export$16d06542a1949d9e = $d1252765ba6ea3fb$var$createThunkMiddleware;


var $29949dd91da7eb25$exports = {};
// shim for using process in browser
var $29949dd91da7eb25$var$process = $29949dd91da7eb25$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $29949dd91da7eb25$var$cachedSetTimeout;
var $29949dd91da7eb25$var$cachedClearTimeout;
function $29949dd91da7eb25$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $29949dd91da7eb25$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $29949dd91da7eb25$var$cachedSetTimeout = setTimeout;
        else $29949dd91da7eb25$var$cachedSetTimeout = $29949dd91da7eb25$var$defaultSetTimout;
    } catch (e) {
        $29949dd91da7eb25$var$cachedSetTimeout = $29949dd91da7eb25$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $29949dd91da7eb25$var$cachedClearTimeout = clearTimeout;
        else $29949dd91da7eb25$var$cachedClearTimeout = $29949dd91da7eb25$var$defaultClearTimeout;
    } catch (e) {
        $29949dd91da7eb25$var$cachedClearTimeout = $29949dd91da7eb25$var$defaultClearTimeout;
    }
})();
function $29949dd91da7eb25$var$runTimeout(fun) {
    if ($29949dd91da7eb25$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($29949dd91da7eb25$var$cachedSetTimeout === $29949dd91da7eb25$var$defaultSetTimout || !$29949dd91da7eb25$var$cachedSetTimeout) && setTimeout) {
        $29949dd91da7eb25$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $29949dd91da7eb25$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $29949dd91da7eb25$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $29949dd91da7eb25$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $29949dd91da7eb25$var$runClearTimeout(marker) {
    if ($29949dd91da7eb25$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($29949dd91da7eb25$var$cachedClearTimeout === $29949dd91da7eb25$var$defaultClearTimeout || !$29949dd91da7eb25$var$cachedClearTimeout) && clearTimeout) {
        $29949dd91da7eb25$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $29949dd91da7eb25$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $29949dd91da7eb25$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $29949dd91da7eb25$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $29949dd91da7eb25$var$queue = [];
var $29949dd91da7eb25$var$draining = false;
var $29949dd91da7eb25$var$currentQueue;
var $29949dd91da7eb25$var$queueIndex = -1;
function $29949dd91da7eb25$var$cleanUpNextTick() {
    if (!$29949dd91da7eb25$var$draining || !$29949dd91da7eb25$var$currentQueue) return;
    $29949dd91da7eb25$var$draining = false;
    if ($29949dd91da7eb25$var$currentQueue.length) $29949dd91da7eb25$var$queue = $29949dd91da7eb25$var$currentQueue.concat($29949dd91da7eb25$var$queue);
    else $29949dd91da7eb25$var$queueIndex = -1;
    if ($29949dd91da7eb25$var$queue.length) $29949dd91da7eb25$var$drainQueue();
}
function $29949dd91da7eb25$var$drainQueue() {
    if ($29949dd91da7eb25$var$draining) return;
    var timeout = $29949dd91da7eb25$var$runTimeout($29949dd91da7eb25$var$cleanUpNextTick);
    $29949dd91da7eb25$var$draining = true;
    var len = $29949dd91da7eb25$var$queue.length;
    while(len){
        $29949dd91da7eb25$var$currentQueue = $29949dd91da7eb25$var$queue;
        $29949dd91da7eb25$var$queue = [];
        while(++$29949dd91da7eb25$var$queueIndex < len)if ($29949dd91da7eb25$var$currentQueue) $29949dd91da7eb25$var$currentQueue[$29949dd91da7eb25$var$queueIndex].run();
        $29949dd91da7eb25$var$queueIndex = -1;
        len = $29949dd91da7eb25$var$queue.length;
    }
    $29949dd91da7eb25$var$currentQueue = null;
    $29949dd91da7eb25$var$draining = false;
    $29949dd91da7eb25$var$runClearTimeout(timeout);
}
$29949dd91da7eb25$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $29949dd91da7eb25$var$queue.push(new $29949dd91da7eb25$var$Item(fun, args));
    if ($29949dd91da7eb25$var$queue.length === 1 && !$29949dd91da7eb25$var$draining) $29949dd91da7eb25$var$runTimeout($29949dd91da7eb25$var$drainQueue);
};
// v8 likes predictible objects
function $29949dd91da7eb25$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$29949dd91da7eb25$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$29949dd91da7eb25$var$process.title = "browser";
$29949dd91da7eb25$var$process.browser = true;
$29949dd91da7eb25$var$process.env = {};
$29949dd91da7eb25$var$process.argv = [];
$29949dd91da7eb25$var$process.version = ""; // empty string to avoid regexp issues
$29949dd91da7eb25$var$process.versions = {};
function $29949dd91da7eb25$var$noop() {}
$29949dd91da7eb25$var$process.on = $29949dd91da7eb25$var$noop;
$29949dd91da7eb25$var$process.addListener = $29949dd91da7eb25$var$noop;
$29949dd91da7eb25$var$process.once = $29949dd91da7eb25$var$noop;
$29949dd91da7eb25$var$process.off = $29949dd91da7eb25$var$noop;
$29949dd91da7eb25$var$process.removeListener = $29949dd91da7eb25$var$noop;
$29949dd91da7eb25$var$process.removeAllListeners = $29949dd91da7eb25$var$noop;
$29949dd91da7eb25$var$process.emit = $29949dd91da7eb25$var$noop;
$29949dd91da7eb25$var$process.prependListener = $29949dd91da7eb25$var$noop;
$29949dd91da7eb25$var$process.prependOnceListener = $29949dd91da7eb25$var$noop;
$29949dd91da7eb25$var$process.listeners = function(name) {
    return [];
};
$29949dd91da7eb25$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$29949dd91da7eb25$var$process.cwd = function() {
    return "/";
};
$29949dd91da7eb25$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$29949dd91da7eb25$var$process.umask = function() {
    return 0;
};


var $0d2ebcff583d07fa$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $b17e0fb4b9e1d0b8$export$5943f4447f6ef248).apply(void 0, (0, $3wcuq._)(args));
    return function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $3wcuq._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $2aK6P.isDraft)(value) ? (0, $2aK6P.current)(value) : value
            ].concat((0, $3wcuq._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    };
};
var $0d2ebcff583d07fa$export$a5d3c27355e35910 = $0d2ebcff583d07fa$export$aab6de9e3dbb1473((0, $b17e0fb4b9e1d0b8$export$8402dc26d96f6902));
var $0d2ebcff583d07fa$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $3dfb2b38496d9965$export$f672e0b6f7222cd7;
    return (0, $3dfb2b38496d9965$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $0d2ebcff583d07fa$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $0d2ebcff583d07fa$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $0d2ebcff583d07fa$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $3wcuq._)(args));
            if (!prepared) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(0));
            return (0, $4fea265c9a477b36$export$581ff339ea0ba762)({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }, "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $3dfb2b38496d9965$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $0d2ebcff583d07fa$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $0d2ebcff583d07fa$var$hasMatchFunction(action);
}
function $0d2ebcff583d07fa$export$ebd532f9034651f3(action) {
    return (0, $3dfb2b38496d9965$export$b956e38827fca970)(action) && Object.keys(action).every($0d2ebcff583d07fa$var$isValidKey);
}
function $0d2ebcff583d07fa$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $0d2ebcff583d07fa$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $0d2ebcff583d07fa$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $0d2ebcff583d07fa$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
function $0d2ebcff583d07fa$var$find(iterable, comparator) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (comparator(entry)) return entry;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return void 0;
}
var $0d2ebcff583d07fa$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $feZkv._)(_Tuple, Array1);
    var _super = (0, $6ZKiV._)(_Tuple);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $8cfPm._)(this, _Tuple);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $3wcuq._)(items)));
        Object.setPrototypeOf((0, $dhgu3._)(_this), _Tuple.prototype);
        return _this;
    }
    (0, $953s6._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $6262699f5a2bb86e$export$afb3516d9d608401)((0, $4R95R._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $7Z16o._)(_Tuple, (0, $3wcuq._)(arr[0].concat(this)));
                return (0, $7Z16o._)(_Tuple, (0, $3wcuq._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $3O8MO._)(Array));
function $0d2ebcff583d07fa$var$freezeDraftable(val) {
    return (0, $2aK6P.isDraftable)(val) ? (0, $2aK6P.produce)(val, function() {}) : val;
}
function $0d2ebcff583d07fa$var$emplace(map, key, handler) {
    if (map.has(key)) {
        var value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(10));
    var inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $0d2ebcff583d07fa$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $0d2ebcff583d07fa$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $0d2ebcff583d07fa$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $0d2ebcff583d07fa$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $0d2ebcff583d07fa$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $0d2ebcff583d07fa$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $0d2ebcff583d07fa$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $0d2ebcff583d07fa$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $7fjaO._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $0d2ebcff583d07fa$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $0d2ebcff583d07fa$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $7fjaO._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $3dfb2b38496d9965$export$53b83ca8eaab0383)(val);
}
function $0d2ebcff583d07fa$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $0d2ebcff583d07fa$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache === null || cache === void 0 ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $g9pLc._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if (typeof nestedValue === "object") {
                foundNestedSerializable = $0d2ebcff583d07fa$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $7fjaO._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $0d2ebcff583d07fa$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $0d2ebcff583d07fa$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if (typeof nestedValue !== "object" || nestedValue === null) continue;
            if (!$0d2ebcff583d07fa$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $0d2ebcff583d07fa$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $0d2ebcff583d07fa$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $0d2ebcff583d07fa$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options !== null && options !== void 0 ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $0d2ebcff583d07fa$export$1908877435b1d5e9();
        if (thunk) {
            if ($0d2ebcff583d07fa$var$isBoolean(thunk)) middlewareArray.push((0, $d1252765ba6ea3fb$export$dd164f5517779f15));
            else middlewareArray.push((0, $d1252765ba6ea3fb$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $0d2ebcff583d07fa$export$8fb31c0f05df007b = "RTK_autoBatch";
var $0d2ebcff583d07fa$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $fkQxX._)({}, $0d2ebcff583d07fa$export$8fb31c0f05df007b, true)
        };
    };
};
var $0d2ebcff583d07fa$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $0d2ebcff583d07fa$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $0d2ebcff583d07fa$var$createQueueWithTimer(10);
var $0d2ebcff583d07fa$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $3wcuq._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $0d2ebcff583d07fa$var$rAF : options.type === "callback" ? options.queueNotification : $0d2ebcff583d07fa$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    try {
                        var _action_meta;
                        notifying = !(action === null || action === void 0 ? void 0 : (_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : _action_meta[$0d2ebcff583d07fa$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $0d2ebcff583d07fa$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options !== null && options !== void 0 ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $0d2ebcff583d07fa$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($0d2ebcff583d07fa$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
var $0d2ebcff583d07fa$var$IS_PRODUCTION = true;
function $0d2ebcff583d07fa$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $0d2ebcff583d07fa$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $3dfb2b38496d9965$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $3dfb2b38496d9965$export$66e4520cdb265d18)(reducer);
    else throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(1));
    if (!$0d2ebcff583d07fa$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(2));
    var finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$0d2ebcff583d07fa$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$0d2ebcff583d07fa$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(4));
    var finalCompose = (0, $3dfb2b38496d9965$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $0d2ebcff583d07fa$var$composeWithDevTools((0, $4fea265c9a477b36$export$581ff339ea0ba762)({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$0d2ebcff583d07fa$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var middlewareEnhancer = (0, $3dfb2b38496d9965$export$9ff26e0402cc7b7).apply(void 0, (0, $3wcuq._)(finalMiddleware));
    var getDefaultEnhancers = $0d2ebcff583d07fa$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$0d2ebcff583d07fa$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(5));
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$0d2ebcff583d07fa$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(6));
    if (!$0d2ebcff583d07fa$var$IS_PRODUCTION && storeEnhancers.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(7));
    if (!$0d2ebcff583d07fa$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    var composedEnhancer = finalCompose.apply(void 0, (0, $3wcuq._)(storeEnhancers));
    return (0, $3dfb2b38496d9965$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $0d2ebcff583d07fa$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $0d2ebcff583d07fa$var$isStateFunction(x) {
    return typeof x === "function";
}
function $0d2ebcff583d07fa$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $g9pLc._)($0d2ebcff583d07fa$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($0d2ebcff583d07fa$var$isStateFunction(initialState)) getInitialState = function() {
        return $0d2ebcff583d07fa$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $0d2ebcff583d07fa$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $3wcuq._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $2aK6P.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $2aK6P.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(9));
                    }
                    return result1;
                } else return (0, $2aK6P.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $0d2ebcff583d07fa$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $0d2ebcff583d07fa$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $0d2ebcff583d07fa$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $0d2ebcff583d07fa$var$matches = function(matcher, action) {
    if ($0d2ebcff583d07fa$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $0d2ebcff583d07fa$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $0d2ebcff583d07fa$var$matches(matcher, action);
        });
    };
}
function $0d2ebcff583d07fa$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $0d2ebcff583d07fa$var$matches(matcher, action);
        });
    };
}
function $0d2ebcff583d07fa$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $0d2ebcff583d07fa$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $0d2ebcff583d07fa$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $0d2ebcff583d07fa$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$0d2ebcff583d07fa$var$isAsyncThunkArray(asyncThunks)) return $0d2ebcff583d07fa$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $0d2ebcff583d07fa$export$2c3435c7647f7b0d.apply(void 0, (0, $3wcuq._)(matchers));
        return combinedMatcher(action);
    };
}
function $0d2ebcff583d07fa$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $0d2ebcff583d07fa$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$0d2ebcff583d07fa$var$isAsyncThunkArray(asyncThunks)) return $0d2ebcff583d07fa$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $0d2ebcff583d07fa$export$2c3435c7647f7b0d.apply(void 0, (0, $3wcuq._)(matchers));
        return combinedMatcher(action);
    };
}
function $0d2ebcff583d07fa$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $0d2ebcff583d07fa$export$9dd1fb32974da385($0d2ebcff583d07fa$export$a5c5d27e3994c5be.apply(void 0, (0, $3wcuq._)(asyncThunks)), hasFlag);
        return combinedMatcher(action);
    };
    if (!$0d2ebcff583d07fa$var$isAsyncThunkArray(asyncThunks)) return $0d2ebcff583d07fa$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $0d2ebcff583d07fa$export$9dd1fb32974da385($0d2ebcff583d07fa$export$a5c5d27e3994c5be.apply(void 0, (0, $3wcuq._)(asyncThunks)), hasFlag);
        return combinedMatcher(action);
    };
}
function $0d2ebcff583d07fa$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $0d2ebcff583d07fa$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$0d2ebcff583d07fa$var$isAsyncThunkArray(asyncThunks)) return $0d2ebcff583d07fa$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $0d2ebcff583d07fa$export$2c3435c7647f7b0d.apply(void 0, (0, $3wcuq._)(matchers));
        return combinedMatcher(action);
    };
}
function $0d2ebcff583d07fa$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $0d2ebcff583d07fa$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$0d2ebcff583d07fa$var$isAsyncThunkArray(asyncThunks)) return $0d2ebcff583d07fa$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = asyncThunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var asyncThunk = _step.value;
                matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var combinedMatcher = $0d2ebcff583d07fa$export$2c3435c7647f7b0d.apply(void 0, (0, $3wcuq._)(matchers));
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $0d2ebcff583d07fa$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $0d2ebcff583d07fa$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $8cfPm._)(this, RejectWithValue);
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ (0, $fkQxX._)(this, "_type", void 0);
    this.payload = payload;
    this.meta = meta;
};
var $0d2ebcff583d07fa$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $8cfPm._)(this, FulfillWithMeta);
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ (0, $fkQxX._)(this, "_type", void 0);
    this.payload = payload;
    this.meta = meta;
};
var $0d2ebcff583d07fa$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $0d2ebcff583d07fa$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $0d2ebcff583d07fa$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $0d2ebcff583d07fa$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: (0, $7305121fbb913b12$export$4fa2f4023c9cbda5)((0, $4fea265c9a477b36$export$581ff339ea0ba762)({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $0d2ebcff583d07fa$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: (0, $7305121fbb913b12$export$4fa2f4023c9cbda5)((0, $4fea265c9a477b36$export$581ff339ea0ba762)({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $0d2ebcff583d07fa$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $0d2ebcff583d07fa$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: (0, $7305121fbb913b12$export$4fa2f4023c9cbda5)((0, $4fea265c9a477b36$export$581ff339ea0ba762)({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error === null || error === void 0 ? void 0 : error.name) === "AbortError",
                    condition: (error === null || error === void 0 ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options === null || options === void 0 ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $0d2ebcff583d07fa$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortReason;
                var promise = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function() {
                    var finalAction, _options_condition, _options_getPendingMeta, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                conditionResult = options === null || options === void 0 ? void 0 : (_options_condition = options.condition) === null || _options_condition === void 0 ? void 0 : _options_condition.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$0d2ebcff583d07fa$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    return abortController.signal.addEventListener("abort", function() {
                                        return reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    });
                                });
                                dispatch(pending(requestId, arg, options === null || options === void 0 ? void 0 : (_options_getPendingMeta = options.getPendingMeta) === null || _options_getPendingMeta === void 0 ? void 0 : _options_getPendingMeta.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $0d2ebcff583d07fa$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $0d2ebcff583d07fa$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $0d2ebcff583d07fa$var$RejectWithValue) throw result;
                                            if (result instanceof $0d2ebcff583d07fa$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $0d2ebcff583d07fa$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($0d2ebcff583d07fa$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $0d2ebcff583d07fa$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $0d2ebcff583d07fa$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $0d2ebcff583d07fa$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $0d2ebcff583d07fa$var$asyncThunkSymbol = Symbol.for("rtk-slice-createasyncthunk");
var $0d2ebcff583d07fa$export$343355ed40c51c46 = (0, $fkQxX._)({}, $0d2ebcff583d07fa$var$asyncThunkSymbol, $0d2ebcff583d07fa$export$6abd22dc03e5063f);
var $0d2ebcff583d07fa$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($0d2ebcff583d07fa$export$23a094319a4b586 || {});
function $0d2ebcff583d07fa$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $0d2ebcff583d07fa$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _creators_asyncThunk;
    var cAT = creators === null || creators === void 0 ? void 0 : (_creators_asyncThunk = creators.asyncThunk) === null || _creators_asyncThunk === void 0 ? void 0 : _creators_asyncThunk[$0d2ebcff583d07fa$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(11));
        typeof $29949dd91da7eb25$exports === "undefined" ? "undefined" : (0, $7fjaO._)($29949dd91da7eb25$exports);
        var reducers = (typeof options.reducers === "function" ? options.reducers($0d2ebcff583d07fa$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer) {
                context.sliceCaseReducersByName[name2] = reducer;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $0d2ebcff583d07fa$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($0d2ebcff583d07fa$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $0d2ebcff583d07fa$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $0d2ebcff583d07fa$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $g9pLc._)(typeof options.extraReducers === "function" ? $0d2ebcff583d07fa$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = (0, $4fea265c9a477b36$export$581ff339ea0ba762)({}, extraReducers, context.sliceCaseReducersByType);
            return $0d2ebcff583d07fa$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new WeakMap();
        var _reducer;
        var slice = (0, $fkQxX._)({
            name: name,
            reducerPath: reducerPath,
            reducer: function(state, action) {
                if (!_reducer) _reducer = buildReducer();
                return _reducer(state, action);
            },
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: function() {
                if (!_reducer) _reducer = buildReducer();
                return _reducer.getInitialState();
            },
            getSelectors: function() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var _this = this;
                var selectorCache = $0d2ebcff583d07fa$var$emplace(injectedSelectorCache, this, {
                    insert: function() {
                        return /* @__PURE__ */ new WeakMap();
                    }
                });
                return $0d2ebcff583d07fa$var$emplace(selectorCache, selectState, {
                    insert: function() {
                        var map = {};
                        var _options_selectors;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.entries((_options_selectors = options.selectors) !== null && _options_selectors !== void 0 ? _options_selectors : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $g9pLc._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                                map[name2] = $0d2ebcff583d07fa$var$wrapSelector(_this, selector, selectState, _this !== slice);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return map;
                    }
                });
            },
            selectSlice: function(state) {
                var sliceState = state[this.reducerPath];
                if (typeof sliceState === "undefined") {
                    if (this !== slice) sliceState = this.getInitialState();
                }
                return sliceState;
            },
            get selectors () {
                return this.getSelectors(this.selectSlice);
            }
        }, "injectInto", function(injectable) {
            var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var pathOpt = _param["reducerPath"], config = (0, $6076f0b8fabffc21$export$69fdd232f62cde60)(_param, [
                "reducerPath"
            ]);
            var reducerPath2 = pathOpt !== null && pathOpt !== void 0 ? pathOpt : this.reducerPath;
            injectable.inject({
                reducerPath: reducerPath2,
                reducer: this.reducer
            }, config);
            return (0, $7305121fbb913b12$export$4fa2f4023c9cbda5)((0, $4fea265c9a477b36$export$581ff339ea0ba762)({}, this), {
                reducerPath: reducerPath2
            });
        });
        return slice;
    };
}
function $0d2ebcff583d07fa$var$wrapSelector(slice, selector, selectState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState.call(slice, rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = slice.getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $3wcuq._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $0d2ebcff583d07fa$export$4d8d9bd83c24ae8b = $0d2ebcff583d07fa$export$affdea4146de9cf5();
function $0d2ebcff583d07fa$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return (0, $4fea265c9a477b36$export$581ff339ea0ba762)({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $fkQxX._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $3wcuq._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $0d2ebcff583d07fa$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$0d2ebcff583d07fa$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $0d2ebcff583d07fa$export$309c7a02b0b0bc62(type, prepareCallback) : $0d2ebcff583d07fa$export$309c7a02b0b0bc62(type));
}
function $0d2ebcff583d07fa$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $0d2ebcff583d07fa$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $0d2ebcff583d07fa$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $0d2ebcff583d07fa$var$noop,
        pending: pending || $0d2ebcff583d07fa$var$noop,
        rejected: rejected || $0d2ebcff583d07fa$var$noop,
        settled: settled || $0d2ebcff583d07fa$var$noop
    });
}
function $0d2ebcff583d07fa$var$noop() {}
// src/entities/entity_state.ts
function $0d2ebcff583d07fa$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $0d2ebcff583d07fa$var$createInitialStateFactory() {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return Object.assign($0d2ebcff583d07fa$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $0d2ebcff583d07fa$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $0d2ebcff583d07fa$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $0d2ebcff583d07fa$var$isDraftTyped = (0, $2aK6P.isDraft);
function $0d2ebcff583d07fa$var$createSingleArgumentStateOperator(mutator) {
    var operator = $0d2ebcff583d07fa$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $0d2ebcff583d07fa$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $0d2ebcff583d07fa$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($0d2ebcff583d07fa$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $2aK6P.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $0d2ebcff583d07fa$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $0d2ebcff583d07fa$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $0d2ebcff583d07fa$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $0d2ebcff583d07fa$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $0d2ebcff583d07fa$var$selectIdValue(entity, selectId);
            if (id in state.entities) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $0d2ebcff583d07fa$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $0d2ebcff583d07fa$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $0d2ebcff583d07fa$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $0d2ebcff583d07fa$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $0d2ebcff583d07fa$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $0d2ebcff583d07fa$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $0d2ebcff583d07fa$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: (0, $4fea265c9a477b36$export$581ff339ea0ba762)({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null, update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $0d2ebcff583d07fa$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $g9pLc._)($0d2ebcff583d07fa$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $0d2ebcff583d07fa$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $0d2ebcff583d07fa$var$createStateOperator(addOneMutably),
        addMany: $0d2ebcff583d07fa$var$createStateOperator(addManyMutably),
        setOne: $0d2ebcff583d07fa$var$createStateOperator(setOneMutably),
        setMany: $0d2ebcff583d07fa$var$createStateOperator(setManyMutably),
        setAll: $0d2ebcff583d07fa$var$createStateOperator(setAllMutably),
        updateOne: $0d2ebcff583d07fa$var$createStateOperator(updateOneMutably),
        updateMany: $0d2ebcff583d07fa$var$createStateOperator(updateManyMutably),
        upsertOne: $0d2ebcff583d07fa$var$createStateOperator(upsertOneMutably),
        upsertMany: $0d2ebcff583d07fa$var$createStateOperator(upsertManyMutably),
        removeOne: $0d2ebcff583d07fa$var$createStateOperator(removeOneMutably),
        removeMany: $0d2ebcff583d07fa$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $0d2ebcff583d07fa$var$createSortedStateAdapter(selectId, sort) {
    var _createUnsortedStateAdapter = $0d2ebcff583d07fa$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $0d2ebcff583d07fa$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($0d2ebcff583d07fa$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $0d2ebcff583d07fa$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $0d2ebcff583d07fa$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    delete state.entities[update.id];
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $g9pLc._)($0d2ebcff583d07fa$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $0d2ebcff583d07fa$var$createStateOperator(addOneMutably),
        updateOne: $0d2ebcff583d07fa$var$createStateOperator(updateOneMutably),
        upsertOne: $0d2ebcff583d07fa$var$createStateOperator(upsertOneMutably),
        setOne: $0d2ebcff583d07fa$var$createStateOperator(setOneMutably),
        setMany: $0d2ebcff583d07fa$var$createStateOperator(setManyMutably),
        setAll: $0d2ebcff583d07fa$var$createStateOperator(setAllMutably),
        addMany: $0d2ebcff583d07fa$var$createStateOperator(addManyMutably),
        updateMany: $0d2ebcff583d07fa$var$createStateOperator(updateManyMutably),
        upsertMany: $0d2ebcff583d07fa$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $0d2ebcff583d07fa$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _$_object_spread = (0, $4fea265c9a477b36$export$581ff339ea0ba762)({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _$_object_spread.selectId, sortComparer = _$_object_spread.sortComparer;
    var stateFactory = $0d2ebcff583d07fa$var$createInitialStateFactory();
    var selectorsFactory = $0d2ebcff583d07fa$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $0d2ebcff583d07fa$var$createSortedStateAdapter(selectId, sortComparer) : $0d2ebcff583d07fa$var$createUnsortedStateAdapter(selectId);
    return (0, $4fea265c9a477b36$export$581ff339ea0ba762)({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory, selectorsFactory, stateAdapter);
}
// src/listenerMiddleware/utils.ts
var $0d2ebcff583d07fa$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(32));
};
var $0d2ebcff583d07fa$var$noop2 = function() {};
var $0d2ebcff583d07fa$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $0d2ebcff583d07fa$var$noop2;
    promise.catch(onError);
    return promise;
};
var $0d2ebcff583d07fa$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $0d2ebcff583d07fa$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $0d2ebcff583d07fa$var$task = "task";
var $0d2ebcff583d07fa$var$listener = "listener";
var $0d2ebcff583d07fa$var$completed = "completed";
var $0d2ebcff583d07fa$var$cancelled = "cancelled";
var $0d2ebcff583d07fa$var$taskCancelled = "task-".concat($0d2ebcff583d07fa$var$cancelled);
var $0d2ebcff583d07fa$var$taskCompleted = "task-".concat($0d2ebcff583d07fa$var$completed);
var $0d2ebcff583d07fa$var$listenerCancelled = "".concat($0d2ebcff583d07fa$var$listener, "-").concat($0d2ebcff583d07fa$var$cancelled);
var $0d2ebcff583d07fa$var$listenerCompleted = "".concat($0d2ebcff583d07fa$var$listener, "-").concat($0d2ebcff583d07fa$var$completed);
var $0d2ebcff583d07fa$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $8cfPm._)(this, TaskAbortError);
    (0, $fkQxX._)(this, "name", "TaskAbortError");
    (0, $fkQxX._)(this, "message", void 0);
    this.code = code;
    this.message = "".concat($0d2ebcff583d07fa$var$task, " ").concat($0d2ebcff583d07fa$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/task.ts
var $0d2ebcff583d07fa$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $0d2ebcff583d07fa$export$cb1bdac908fed7f(reason);
    }
};
function $0d2ebcff583d07fa$var$raceWithSignal(signal, promise) {
    var cleanup = $0d2ebcff583d07fa$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $0d2ebcff583d07fa$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $0d2ebcff583d07fa$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $0d2ebcff583d07fa$var$noop2;
    });
}
var $0d2ebcff583d07fa$var$runTask = function() {
    var _ref = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(task2, cleanUp) {
        var value, error;
        return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $0d2ebcff583d07fa$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp === null || cleanUp === void 0 ? void 0 : cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $0d2ebcff583d07fa$var$createPause = function(signal) {
    return function(promise) {
        return $0d2ebcff583d07fa$var$catchRejection($0d2ebcff583d07fa$var$raceWithSignal(signal, promise).then(function(output) {
            $0d2ebcff583d07fa$var$validateActive(signal);
            return output;
        }));
    };
};
var $0d2ebcff583d07fa$var$createDelay = function(signal) {
    var pause = $0d2ebcff583d07fa$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $0d2ebcff583d07fa$var$assign = Object.assign;
var $0d2ebcff583d07fa$var$INTERNAL_NIL_TOKEN = {};
var $0d2ebcff583d07fa$var$alm = "listenerMiddleware";
var $0d2ebcff583d07fa$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $0d2ebcff583d07fa$var$addAbortSignalListener(parentAbortSignal, function() {
            return $0d2ebcff583d07fa$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $0d2ebcff583d07fa$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $0d2ebcff583d07fa$var$runTask(/*#__PURE__*/ (0, $39e0c52944643fcc$export$7c398597f8905a1)(function() {
            var result2;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $0d2ebcff583d07fa$var$validateActive(parentAbortSignal);
                        $0d2ebcff583d07fa$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $0d2ebcff583d07fa$var$createPause(childAbortController.signal),
                                delay: $0d2ebcff583d07fa$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $0d2ebcff583d07fa$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $0d2ebcff583d07fa$var$abortControllerWithReason(childAbortController, $0d2ebcff583d07fa$var$taskCompleted);
        });
        if (opts === null || opts === void 0 ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $0d2ebcff583d07fa$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $0d2ebcff583d07fa$var$abortControllerWithReason(childAbortController, $0d2ebcff583d07fa$var$taskCancelled);
            }
        };
    };
};
var $0d2ebcff583d07fa$var$createTakePattern = function(startListening, signal) {
    var take = function() {
        var _ref = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $0d2ebcff583d07fa$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $0d2ebcff583d07fa$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $0d2ebcff583d07fa$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $0d2ebcff583d07fa$var$catchRejection(take(predicate, timeout));
    };
};
var $0d2ebcff583d07fa$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $0d2ebcff583d07fa$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(21));
    $0d2ebcff583d07fa$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $0d2ebcff583d07fa$var$createListenerEntry = function(options) {
    var _getListenerEntryPropsFrom = $0d2ebcff583d07fa$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var id = $0d2ebcff583d07fa$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(22));
        }
    };
    return entry;
};
var $0d2ebcff583d07fa$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $0d2ebcff583d07fa$var$abortControllerWithReason(controller, $0d2ebcff583d07fa$var$listenerCancelled);
    });
};
var $0d2ebcff583d07fa$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($0d2ebcff583d07fa$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $0d2ebcff583d07fa$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $0d2ebcff583d07fa$export$f03a6b845d3fb58b = $0d2ebcff583d07fa$export$309c7a02b0b0bc62("".concat($0d2ebcff583d07fa$var$alm, "/add"));
var $0d2ebcff583d07fa$export$b1b8022855fb2b71 = $0d2ebcff583d07fa$export$309c7a02b0b0bc62("".concat($0d2ebcff583d07fa$var$alm, "/removeAll"));
var $0d2ebcff583d07fa$export$b03e9483f936dccb = $0d2ebcff583d07fa$export$309c7a02b0b0bc62("".concat($0d2ebcff583d07fa$var$alm, "/remove"));
var $0d2ebcff583d07fa$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($0d2ebcff583d07fa$var$alm, "/error")
    ].concat((0, $3wcuq._)(args)));
};
function $0d2ebcff583d07fa$export$1228acebbbcb485b() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $0d2ebcff583d07fa$var$defaultErrorHandler : _middlewareOptions_onError;
    $0d2ebcff583d07fa$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions === null || cancelOptions === void 0 ? void 0 : cancelOptions.cancelActive) $0d2ebcff583d07fa$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var entry = $0d2ebcff583d07fa$var$find(Array.from(listenerMap.values()), function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $0d2ebcff583d07fa$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _getListenerEntryPropsFrom = $0d2ebcff583d07fa$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
        var entry = $0d2ebcff583d07fa$var$find(Array.from(listenerMap.values()), function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $0d2ebcff583d07fa$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function() {
        var _ref = (0, $39e0c52944643fcc$export$7c398597f8905a1)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $3529a7406e1ba74f$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $0d2ebcff583d07fa$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $0d2ebcff583d07fa$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $0d2ebcff583d07fa$var$createDelay(internalTaskController.signal),
                                pause: $0d2ebcff583d07fa$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $0d2ebcff583d07fa$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $0d2ebcff583d07fa$var$abortControllerWithReason(controller, $0d2ebcff583d07fa$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $0d2ebcff583d07fa$var$abortControllerWithReason(internalTaskController, $0d2ebcff583d07fa$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $0d2ebcff583d07fa$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $0d2ebcff583d07fa$export$cb1bdac908fed7f)) $0d2ebcff583d07fa$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $0d2ebcff583d07fa$var$abortControllerWithReason(internalTaskController, $0d2ebcff583d07fa$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $0d2ebcff583d07fa$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $3dfb2b38496d9965$export$b956e38827fca970)(action)) return next(action);
                if ($0d2ebcff583d07fa$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($0d2ebcff583d07fa$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($0d2ebcff583d07fa$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $0d2ebcff583d07fa$var$INTERNAL_NIL_TOKEN) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $0d2ebcff583d07fa$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $0d2ebcff583d07fa$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
var $0d2ebcff583d07fa$var$createMiddlewareEntry = function(middleware) {
    return {
        id: $0d2ebcff583d07fa$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $0d2ebcff583d07fa$var$matchInstance = function(instanceId) {
    return function(action) {
        var _action_meta;
        return (action === null || action === void 0 ? void 0 : (_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : _action_meta.instanceId) === instanceId;
    };
};
var $0d2ebcff583d07fa$export$4bb1606a79445586 = function() {
    var instanceId = $0d2ebcff583d07fa$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($0d2ebcff583d07fa$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            var entry = $0d2ebcff583d07fa$var$find(Array.from(middlewareMap.values()), function(entry2) {
                return entry2.middleware === middleware2;
            });
            if (!entry) entry = $0d2ebcff583d07fa$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $0d2ebcff583d07fa$var$emplace(entry.applied, api, {
                insert: function() {
                    return entry.middleware(api);
                }
            });
        });
        return (0, $3dfb2b38496d9965$export$f672e0b6f7222cd7).apply(void 0, (0, $3wcuq._)(appliedMiddleware));
    };
    var isWithMiddleware = $0d2ebcff583d07fa$export$9dd1fb32974da385(withMiddleware, $0d2ebcff583d07fa$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $3wcuq._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $0d2ebcff583d07fa$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $0d2ebcff583d07fa$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $0d2ebcff583d07fa$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $0d2ebcff583d07fa$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $0d2ebcff583d07fa$var$isStateProxy = function(value) {
    return !!value && !!value[$0d2ebcff583d07fa$var$ORIGINAL_STATE];
};
var $0d2ebcff583d07fa$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $0d2ebcff583d07fa$var$createStateProxy = function(state, reducerMap) {
    return $0d2ebcff583d07fa$var$emplace($0d2ebcff583d07fa$var$stateProxyMap, state, {
        insert: function() {
            return new Proxy(state, {
                get: function(target, prop, receiver) {
                    if (prop === $0d2ebcff583d07fa$var$ORIGINAL_STATE) return target;
                    var result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        var reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            var reducerResult = reducer(void 0, {
                                type: $0d2ebcff583d07fa$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            });
        }
    });
};
var $0d2ebcff583d07fa$var$original = function(state) {
    if (!$0d2ebcff583d07fa$var$isStateProxy(state)) throw new Error($0d2ebcff583d07fa$export$378fa86b259c0280(25));
    return state[$0d2ebcff583d07fa$var$ORIGINAL_STATE];
};
function $0d2ebcff583d07fa$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($0d2ebcff583d07fa$var$getReducers(slices));
    var getReducer = function() {
        return (0, $3dfb2b38496d9965$export$66e4520cdb265d18)(reducerMap);
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $29949dd91da7eb25$exports === "undefined" ? "undefined" : (0, $7fjaO._)($29949dd91da7eb25$exports);
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $0d2ebcff583d07fa$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $3wcuq._)(args))) : state, reducerMap)
            ].concat((0, $3wcuq._)(args)));
        };
    }, {
        original: $0d2ebcff583d07fa$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $0d2ebcff583d07fa$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $3a6bf3b7b6743c89$var$cartSlice = (0, $0d2ebcff583d07fa$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: function(state, action) {
            state.items.push(action.payload);
        },
        removeItem: function(state, action) {
            state.items.pop();
        },
        clearCart: function(state, action) {
            // state.items.length=0;
            return {
                items: []
            };
        }
    }
});
var $3a6bf3b7b6743c89$var$_cartSlice_actions = $3a6bf3b7b6743c89$var$cartSlice.actions;
var $3a6bf3b7b6743c89$export$fb9705de59d96855 = $3a6bf3b7b6743c89$var$_cartSlice_actions.addItem, $3a6bf3b7b6743c89$export$fe2d9b4e03920b4c = $3a6bf3b7b6743c89$var$_cartSlice_actions.removeItem, $3a6bf3b7b6743c89$export$810121176e3e3671 = $3a6bf3b7b6743c89$var$_cartSlice_actions.clearCart;
var $3a6bf3b7b6743c89$export$2e2bcd8739ae039 = $3a6bf3b7b6743c89$var$cartSlice.reducer;



var $535bf0df3dadae66$var$ItemList = function(param) {
    var items = param.items;
    var dispatch = (0, $19813643f60dbb4e$export$8ad76b76a4c905f8)();
    var handleAddItem = function(item) {
        // diapatch and action 
        dispatch((0, $3a6bf3b7b6743c89$export$fb9705de59d96855)(item));
    // console.log(item);
    };
    // console.log(items)
    return /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
        children: items.map(function(item) {
            return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "p-2 m-2  border-black border-b-2 text-left flex justify-between ",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                        className: "w-9/12",
                        children: [
                            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                                className: "py-2",
                                children: [
                                    /*#__PURE__*/ (0, $ht8Wd.jsx)("span", {
                                        children: item.card.info.name
                                    }),
                                    /*#__PURE__*/ (0, $ht8Wd.jsxs)("span", {
                                        children: [
                                            "      ",
                                            " -\u20B9",
                                            "      ",
                                            " ",
                                            item.card.info.price / 100 || item.card.info.defaultPrice / 100,
                                            "Rs"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("p", {
                                className: " text-xs",
                                children: item.card.info.description
                            }),
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                        className: "w-3/12 p-4",
                        children: [
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
                                className: "absolute",
                                children: /*#__PURE__*/ (0, $ht8Wd.jsx)("button", {
                                    className: "p-2 mx-10 rounded-lg bg-white shadow-lg  m-auto",
                                    onClick: function() {
                                        return handleAddItem(item);
                                    },
                                    children: "Add +"
                                })
                            }),
                            /*#__PURE__*/ (0, $ht8Wd.jsx)("img", {
                                className: "bg-green-100 rounded-md ",
                                src: (0, $f1a1b29ad18234d0$export$cd85698b2b1026a5) + item.card.info.imageId
                            })
                        ]
                    })
                ]
            }, item.card.info.id);
        })
    });
};
var $535bf0df3dadae66$export$2e2bcd8739ae039 //  src={ Menu_API +item.card.info.imageId }
 = $535bf0df3dadae66$var$ItemList;


var $f6713629744b7e3d$var$RestaurantCategory = function(param) {
    var data = param.data, showItem = param.showItem, setshowIndex = param.setshowIndex;
    //  console.log(data);
    //  const [showItem ,setShowItemss] = useState(false);
    var handleClick = function() {
        //  setShowItemss(!showItem);
        setshowIndex();
    };
    return /*#__PURE__*/ (0, $ht8Wd.jsx)("div", {
        children: /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
            className: "w-6/12 mx-auto my-4 bg-gray-50 shadow-lg p-4",
            children: [
                /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                    className: " flex justify-between cursor-pointer",
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $ht8Wd.jsxs)("span", {
                            className: "text-lg font-bold",
                            children: [
                                data.title,
                                "(",
                                data.itemCards.length,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ht8Wd.jsx)("span", {
                            className: "text-xl",
                            children: "\u2935 "
                        })
                    ]
                }),
                showItem && /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $535bf0df3dadae66$export$2e2bcd8739ae039), {
                    items: data.itemCards
                })
            ]
        })
    });
};
var $f6713629744b7e3d$export$2e2bcd8739ae039 = $f6713629744b7e3d$var$RestaurantCategory;


var $327c0f30e910975f$var$RestaurantMenu = function() {
    var _resInfo_cards__card_card, _resInfo_cards__card, _resInfo_cards_, _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card, _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_, _resInfo_cards__groupedCard_cardGroupMap_REGULAR, _resInfo_cards__groupedCard_cardGroupMap, _resInfo_cards__groupedCard, _resInfo_cards_1, _resInfo_cards__groupedCard_cardGroupMap_REGULAR1, _resInfo_cards__groupedCard_cardGroupMap1, _resInfo_cards__groupedCard1, _resInfo_cards_2;
    var resId = (0, $b50ff877aba8fe4d$export$99eaa27ddbbb95ef)().resId;
    //   console.log(params)
    var resInfo = (0, $6f2912c4ad8142db$export$2e2bcd8739ae039)(resId);
    var _useState = (0, $g9pLc._)((0, $f6C7p.useState)(null), 2), showIndex = _useState[0], setshowIndex = _useState[1];
    if (resInfo === null) return /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $0cd640e6f31826d2$export$2e2bcd8739ae039), {});
    var _ref = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_ = resInfo.cards[2]) === null || _resInfo_cards_ === void 0 ? void 0 : (_resInfo_cards__card = _resInfo_cards_.card) === null || _resInfo_cards__card === void 0 ? void 0 : (_resInfo_cards__card_card = _resInfo_cards__card.card) === null || _resInfo_cards__card_card === void 0 ? void 0 : _resInfo_cards__card_card.info, name = _ref.name, cuisines = _ref.cuisines, costForTwoMessage = _ref.costForTwoMessage, imageId = _ref.imageId;
    var itemCards = (resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_1 = resInfo.cards[4]) === null || _resInfo_cards_1 === void 0 ? void 0 : (_resInfo_cards__groupedCard = _resInfo_cards_1.groupedCard) === null || _resInfo_cards__groupedCard === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap = _resInfo_cards__groupedCard.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR = _resInfo_cards__groupedCard_cardGroupMap.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_ = _resInfo_cards__groupedCard_cardGroupMap_REGULAR.cards[3]) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_ === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card = _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards_.card) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR_cards__card.card).itemCards;
    console.log(itemCards);
    //  console.log(resInfo?.cards[2]?.groupedCard?.cardGroupMap?.REGULAR?.cards[3]?.card)
    var categories = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_2 = resInfo.cards[4]) === null || _resInfo_cards_2 === void 0 ? void 0 : (_resInfo_cards__groupedCard1 = _resInfo_cards_2.groupedCard) === null || _resInfo_cards__groupedCard1 === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap1 = _resInfo_cards__groupedCard1.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap1 === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR1 = _resInfo_cards__groupedCard_cardGroupMap1.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR1 === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR1.cards.filter(function(c) {
        var _c_card_card, _c_card;
        return ((_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card.card) === null || _c_card_card === void 0 ? void 0 : _c_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
    });
    console.log(categories);
    return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
        className: "text-center ",
        children: [
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("h1", {
                className: "font-bold my-6 text-2xl",
                children: [
                    " ",
                    name
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("h3", {
                className: "font-bold   text-lg",
                children: [
                    " ",
                    cuisines.join(", "),
                    "-",
                    costForTwoMessage
                ]
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h3", {
                children: " "
            }),
            categories.map(function(category, index) {
                var _category_card, _category_card1;
                return /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $f6713629744b7e3d$export$2e2bcd8739ae039), {
                    data: category === null || category === void 0 ? void 0 : (_category_card = category.card) === null || _category_card === void 0 ? void 0 : _category_card.card,
                    showItem: index === showIndex ? true : false,
                    setshowIndex: function() {
                        return setshowIndex(index);
                    }
                }, category === null || category === void 0 ? void 0 : (_category_card1 = category.card) === null || _category_card1 === void 0 ? void 0 : _category_card1.card.title);
            })
        ]
    });
};
var $327c0f30e910975f$export$2e2bcd8739ae039 //      const categories= resInfo?.cards[2]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter(c=> c.card?.card?.["@type"]===);
 = $327c0f30e910975f$var$RestaurantMenu;






var $cac1f9a9e1e0fb0c$var$appStore = (0, $0d2ebcff583d07fa$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $3a6bf3b7b6743c89$export$2e2bcd8739ae039)
    }
});
var $cac1f9a9e1e0fb0c$export$2e2bcd8739ae039 = $cac1f9a9e1e0fb0c$var$appStore;



var $ht8Wd = parcelRequire("ht8Wd");



var $dc94a42ba7769073$var$Cart = function() {
    var cartItems = (0, $19813643f60dbb4e$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var dispatch = (0, $19813643f60dbb4e$export$8ad76b76a4c905f8)();
    var handleClearCart = function() {
        dispatch((0, $3a6bf3b7b6743c89$export$810121176e3e3671)());
    };
    return /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
        className: "text-center m-4 p-4 ",
        children: [
            /*#__PURE__*/ (0, $ht8Wd.jsx)("h1", {
                className: "text-xl font-bold",
                children: "Cart"
            }),
            /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "w-6/12 m-auto",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)("button", {
                        className: "p-2 m-2 bg-black rounded-lg text-white",
                        onClick: handleClearCart,
                        children: "Clear Cart"
                    }),
                    cartItems.length === 0 && /*#__PURE__*/ (0, $ht8Wd.jsx)("h1", {
                        children: "cart is empty"
                    }),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $535bf0df3dadae66$export$2e2bcd8739ae039), {
                        items: cartItems
                    })
                ]
            })
        ]
    });
};
var $dc94a42ba7769073$export$2e2bcd8739ae039 = $dc94a42ba7769073$var$Cart;



/**
 * Header
 * -logo
 * -Nav Item
 * Body 
 * -Search
 * -Card container
 * --Restocard
 *    -Img
 *     -Name of Res , Star Rating , cuisines and deve
 *   
 * 
 * Footer
 * -Copyright
 * -link
 * Address
 * Contact
 */ // <img  className='res-logo'   src= { "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320/e0vvulfbahjxjz6k4uwi" + 
// cloudinaryImageId
// } />    
// const resData = {
//   info: {
//     id: "303893",
//     name: "Haji Biryani House",
//     cloudinaryImageId: "hgzhzbqryqw59tzslics",
//     locality: "Kalyani",
//     areaName: "Kanchrapara Loco",
//     costForTwo: "₹350 for two",
//     cuisines: ["Biryani", "Mughlai", "Indian"],
//     avgRating: 3.7,
//     feeDetails: {
//       restaurantId: "303893",
//       fees: [
//         {
//           name: "BASE_DISTANCE",
//           fee: 1900,
//         },
//         {
//           name: "BASE_TIME",
//         },
//         {
//           name: "ANCILLARY_SURGE_FEE",
//         },
//       ],
//       totalFee: 1900,
//     },
//     parentId: "18592",
//     avgRatingString: "3.7",
//     totalRatingsString: "1K+",
//     sla: {
//       deliveryTime: 18,
//       lastMileTravel: 0.6,
//       serviceability: "SERVICEABLE",
//       slaString: "18 mins",
//       lastMileTravelString: "0.6 km",
//       iconType: "ICON_TYPE_EMPTY",
//     },
//     availability: {
//       nextCloseTime: "2023-09-20 23:59:00",
//       opened: true,
//     },
//     badges: {},
//     isOpen: true,
//     aggregatedDiscountInfoV2: {},
//     type: "F",
//     badgesV2: {
//       entityBadges: {
//         imageBased: {},
//         textBased: {},
//         textExtendedBadges: {},
//       },
//     },
//     orderabilityCommunication: {
//       title: {},
//       subTitle: {},
//       message: {},
//       customIcon: {},
//     },
//     differentiatedUi: {
//       displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//       differentiatedUiMediaDetails: {
//         mediaType: "ADS_MEDIA_ENUM_IMAGE",
//         lottie: {},
//         video: {},
//       },
//     },
//     reviewsSummary: {},
//     displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//     restaurantOfferPresentationInfo: {},
//   },
// };
//  const resData = {
//  "restaurants": [
//   {
//     "info": {
//       "id": "684427",
//       "name": "Cafe Amudham",
//       "cloudinaryImageId": "0bcdca61f3cd1e9135b98328593d044f",
//       "locality": "Lalbhagh  Siddapura",
//       "areaName": "Jayanagar",
//       "costForTwo": "₹400 for two",
//       "cuisines": [
//         "South Indian",
//         "Snacks"
//       ],
//       "avgRating": 4.5,
//       "veg": true,
//       "feeDetails": {
//         "restaurantId": "684427",
//         "fees": [
//           {
//             "name": "BASE_DISTANCE",
//             "fee": 4100
//           },
//           {
//             "name": "BASE_TIME"
//           },
//           {
//             "name": "ANCILLARY_SURGE_FEE"
//           }
//         ],
//         "totalFee": 4100
//       },
//       "parentId": "396620",
//       "avgRatingString": "4.5",
//       "totalRatingsString": "1K+",
//       "sla": {
//         "deliveryTime": 24,
//         "lastMileTravel": 4,
//         "serviceability": "SERVICEABLE",
//         "slaString": "24 mins",
//         "lastMileTravelString": "4.0 km",
//         "iconType": "ICON_TYPE_EMPTY"
//       },
//       "availability": {
//         "nextCloseTime": "2023-10-05 23:59:00",
//         "opened": true
//       },
//       "badges": {
//         "textExtendedBadges": [
//           {
//             "iconId": "guiltfree/GF_Logo_android_3x",
//             "shortDescription": "options available",
//             "fontColor": "#7E808C"
//           }
//         ]
//       },
//       "isOpen": true,
//       "type": "F",
//       "badgesV2": {
//         "entityBadges": {
//           "textBased": {
//           },
//           "imageBased": {
//           },
//           "textExtendedBadges": {
//             "badgeObject": [
//               {
//                 "attributes": {
//                   "iconId": "guiltfree/GF_Logo_android_3x",
//                   "description": "",
//                   "shortDescription": "options available",
//                   "fontColor": "#7E808C"
//                 }
//               }
//             ]
//           }
//         }
//       },
//       "aggregatedDiscountInfoV3": {
//         "header": "20% OFF",
//         "subHeader": "UPTO ₹50"
//       },
//       "differentiatedUi": {
//         "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//         "differentiatedUiMediaDetails": {
//           "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//           "lottie": {
//           },
//           "video": {
//           }
//         }
//       },
//       "reviewsSummary": {
//       },
//       "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//       "restaurantOfferPresentationInfo": {
//       }
//     },
//     "analytics": {
//     },
//     "cta": {
//       "link": "swiggy://menu?restaurant_id=684427",
//       "text": "RESTAURANT_MENU",
//       "type": "DEEPLINK"
//     }
//  },
// ],
//  };
/* <RestaurantCard resData ={resList}/> */ var $aa1a9f7a0b1f904d$var$Grocery = /*#__PURE__*/ (0, $f6C7p.lazy)(function() {
    return (parcelRequire("fBF8i"));
});
var $aa1a9f7a0b1f904d$var$AppLayout = function() {
    var _useState = (0, $g9pLc._)((0, $f6C7p.useState)(), 2), userName = _useState[0], setUserName = _useState[1];
    (0, $f6C7p.useEffect)(function() {
        var data = {
            name: "Rakesh Kushwaha"
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $19813643f60dbb4e$export$2881499e37b75b9a), {
        store: (0, $cac1f9a9e1e0fb0c$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $cb9202d36b904eb0$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $ht8Wd.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $8ab1f8f0fdfee72f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $b50ff877aba8fe4d$export$910ae8079b2c2852), {})
                ]
            })
        })
    });
};
var $aa1a9f7a0b1f904d$var$appRouter = (0, $58d3e9a89be9b556$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $ht8Wd.jsx)($aa1a9f7a0b1f904d$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $48ffb8e4618bf807$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $a96f393f1ad99ab0$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $95f752b07db7681f$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $f6C7p.Suspense), {
                    fallback: /*#__PURE__*/ (0, $ht8Wd.jsx)("h1", {
                        children: "Loading ...."
                    }),
                    children: /*#__PURE__*/ (0, $ht8Wd.jsx)($aa1a9f7a0b1f904d$var$Grocery, {})
                })
            },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $327c0f30e910975f$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $dc94a42ba7769073$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $ht8Wd.jsx)((0, $8689f7d3a93be4f8$export$2e2bcd8739ae039), {})
    }
]);
// const Title =() =>(
//     <h1 className='head' tabIndex="5">
//         Namaste Rakesh using JSX
//     </h1>
//  )
//  const heading = (
//     <h1  className='head'tabIndex="1" >
//          Nanaste Rakesh Kushwaha in JSX</h1>
//          );
//  const HeadingComponent = () =>(
//     <div id= "container">
//         <Title/>
//         {heading}
//         {Title()}
// <h1 className='heading'> Namaste React Fucntional Component  <Title/></h1>
// <Title/>
// </div>
// );
var $aa1a9f7a0b1f904d$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($dbc53e6cc89d3c52$exports))).createRoot(document.getElementById("root"));
$aa1a9f7a0b1f904d$var$root.render(/*#__PURE__*/ (0, $ht8Wd.jsx)((0, $58d3e9a89be9b556$export$323e4fc2fa4753fb), {
    router: $aa1a9f7a0b1f904d$var$appRouter
}));

})();
//# sourceMappingURL=index.9a11a753.js.map
